export default {
  10000000: 'Haustierbedarf / Haustiernahrung',
  10000002: 'Obst – nicht bearbeitet / verarbeitet (tiefgefroren)',
  10000003: 'Obst – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000005: 'Gemüse – nicht bearbeitet / verarbeitet (tiefgefroren)',
  10000006: 'Gemüse – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000007:
    'Nüsse / Samen – nicht bearbeitet / verarbeitet (leicht verderblich)',
  10000008:
    'Nüsse / Samen – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000016: 'Fisch – bearbeitet / verarbeitet (leicht verderblich)',
  10000017: 'Fisch – bearbeitet / verarbeitet (tiefgefroren)',
  10000018: 'Fisch – bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000019:
    'Krustentiere / Muscheln / Schnecken – nicht bearbeitet / verarbeitet (leicht verderblich)',
  10000020:
    'Krustentiere / Muscheln / Schnecken – nicht bearbeitet / verarbeitet (tiefgefroren)',
  10000021:
    'Krustentiere / Muscheln / Schnecken – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000025: 'Milch (leicht verderblich)',
  10000026: 'Milch / Milchersatz (ohne Kühlung haltbar)',
  10000027: 'Milch (tiefgefroren)',
  10000028: 'Käse (leicht verderblich)',
  10000029: 'Käse (ohne Kühlung haltbar)',
  10000030: 'Käse (tiefgefroren)',
  10000040: 'Speiseöle – pflanzlich (ohne Kühlung haltbar)',
  10000041: 'Speisefette – tierisch (leicht verderblich)',
  10000042: 'Speisefette – pflanzlich (ohne Kühlung haltbar)',
  10000043: 'Zucker / Zuckerersatzstoffe (ohne Kühlung haltbar)',
  10000044: 'Sirup / schwarzer Rübensirup / Melasse (ohne Kühlung haltbar)',
  10000045:
    'Schokolade und Mischungen aus Schokolade und Zuckerwaren – Süßwaren',
  10000047: 'Bonbons / Zuckerwaren auf Basis Zuckerersatz',
  10000048: 'Kräuter / Gewürze (leicht verderblich)',
  10000049: 'Kräuter / Gewürze (ohne Kühlung haltbar)',
  10000050: 'Extrakte  / Salz / Fleischzartmacher (ohne Kühlung haltbar)',
  10000051: 'Essig',
  10000052: 'Kochweine',
  10000054:
    'Dipsaucen / Würzsaucen / Feinkostsaucen / Aufstriche / Marinaden (leicht verderblich)',
  10000055: 'Saucen (leicht verderblich)',
  10000056: 'Saucen (tiefgefroren)',
  10000057: 'Saucen (ohne Kühlung haltbar)',
  10000064: 'Pasteten / Paté (leicht verderblich)',
  10000068: 'Back– / Kochmischungen (leicht verderblich)',
  10000069: 'Back– / Kochzutaten (leicht verderblich)',
  10000104: 'Baby– und Kleinkindernahrungsmittel (ohne Kühlung haltbar)',
  10000105: 'Baby– und Kleinkindergetränke (ohne Kühlung haltbar)',
  10000111: 'Kaffee – ganze Bohnen / gemahlen',
  10000114: 'Kaffee – trinkfertig',
  10000115: 'Kaffee – Instant',
  10000116: 'Tee – lose / abgepackt / Aufgussbeutel',
  10000117: 'Tee – Instant',
  10000118: 'Tee – trinkfertig',
  10000119: 'Kräuter– und Früchtetees – lose / abgepackt / Aufgussbeutel',
  10000134: 'Kautabak / Schnupftabak',
  10000137:
    'Wasserpflanzen / Algen – nicht bearbeitet / verarbeitet (leicht verderblich)',
  10000138:
    'Wasserpflanzen / Algen – nicht bearbeitet / verarbeitet (tiefgefroren)',
  10000139:
    'Wasserpflanzen / Algen – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000142: 'Sets zur Alkoholherstellung',
  10000143: 'Alkoholherstellungszubehör',
  10000144: 'Alkoholische Mixgetränke',
  10000145: 'Weichtiere – bearbeitet / verarbeitet (tiefgefroren)',
  10000146: 'Weichtiere – bearbeitet / verarbeitet (leicht verderblich)',
  10000147: 'Weichtiere – bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000148: 'Weichtiere – nicht bearbeitet / verarbeitet (tiefgefroren)',
  10000149: 'Weichtiere – nicht bearbeitet / verarbeitet (leicht verderblich)',
  10000150:
    'Weichtiere – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000151: 'Wasserpflanzen / Algen – bearbeitet / verarbeitet (tiefgefroren)',
  10000152:
    'Wasserpflanzen / Algen – bearbeitet / verarbeitet (leicht verderblich)',
  10000153:
    'Wasserpflanzen / Algen – bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000155: 'Back– / Kochmischungen (tiefgefroren)',
  10000156: 'Back– / Kochmischungen (ohne Kühlung haltbar)',
  10000157: 'Back– / Kochzutaten (tiefgefroren)',
  10000158: 'Back– / Kochzutaten (ohne Kühlung haltbar)',
  10000159: 'Bier',
  10000160: 'Kekse / Gebäck (leicht verderblich)',
  10000161: 'Kekse / Gebäck (ohne Kühlung haltbar)',
  10000163: 'Brot (tiefgefroren)',
  10000164: 'Brot (leicht verderblich)',
  10000165: 'Brot (behandelt – ohne Kühlung haltbar)',
  10000166: 'Getrocknete Broterzeugnisse (ohne Kühlung haltbar)',
  10000167: 'Butter (tiefgefroren)',
  10000168: 'Butter (leicht verderblich)',
  10000169: 'Butter (ohne Kühlung haltbar)',
  10000170: 'Kuchen / Torten – süß (tiefgefroren)',
  10000171: 'Kuchen / Torten – süß (verderblich)',
  10000172: 'Kuchen / Torten – süß (konserviert – ohne Kühlung haltbar)',
  10000177:
    'Chips / Knabbertikel / Knabbermischungen – natürlich / extrudiert (ohne Kühlung haltbar)',
  10000178: 'Trinkschokolade / Kakao / Malzgetränke – nicht trinkfertig',
  10000179: 'Trinkschokolade / Kakao / Malzgetränke – trinkfertig',
  10000180: 'Chutneys / Relishes (ohne Kühlung haltbar)',
  10000181: 'Alkoholische Getränke auf Apfel– / Birnenbasis – mit Kohlensäure',
  10000185: 'Zigaretten',
  10000186: 'Zigarren / Zigarillos',
  10000187: 'Nuss– und Schokoladencremes (ohne Kühlung haltbar)',
  10000188: 'Sahne (tiefgefroren)',
  10000189: 'Sahne (leicht verderblich)',
  10000190: 'Sahne (ohne Kühlung haltbar)',
  10000191:
    'Milchbasierte / Milchersatzbasierte Getränke – trinkfertig (leicht verderblich)',
  10000192: 'Milchbasierte Getränke – trinkfertig (ohne Kühlung haltbar)',
  10000193: 'Dessertsaucen / Garnierungen / Füllungen (tiefgefroren)',
  10000194: 'Dessertsaucen / Garnierungen / Füllungen (leicht verderblich)',
  10000195: 'Dessertsaucen / Garnierungen / Füllungen (ohne Kühlung haltbar)',
  10000196: 'Desserts (tiefgefroren)',
  10000197: 'Desserts (leicht verderblich)',
  10000199: 'Salatsaucen / Dips (leicht verderblich)',
  10000200: 'Salatsaucen / Dips (ohne Kühlung haltbar)',
  10000201: 'Erfrischungsgetränke, aromatisiert – trinkfertig',
  10000202: 'Erfrischungsgetränke aromatisiert – nicht trinkfertig',
  10000203: 'Mehle – Getreide / Hülsenfrüchte (ohne Kühlung haltbar)',
  10000204: 'Obst – bearbeitet / verarbeitet (tiefgefroren)',
  10000205: 'Obst – bearbeitet / verarbeitet (leicht verderblich)',
  10000206: 'Obst – bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000207:
    'Früchte / Nüsse / Samen Mischungen – bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000210: 'Kräuter– und Früchtetees – Instant',
  10000211: 'Körner / Getreide – nicht verzehrbereit (ohne Kühlung haltbar)',
  10000212: 'Kräuter / Gewürze (tiefgefroren)',
  10000213: 'Honig (ohne Kühlung haltbar)',
  10000214: 'Eis',
  10000215: 'Speiseeis (tiefgefroren)',
  10000216: 'Speiseeis (ohne Kühlung haltbar)',
  10000217: 'Marmeladen / Gelees / Konfitüren (ohne Kühlung haltbar)',
  10000219: 'Fruchtsaft – trinkfertig (leicht verderblich)',
  10000220: 'Fruchtsaft – trinkfertig (ohne Kühlung haltbar)',
  10000222: 'Fruchtsaftgetränke – trinkfertig (leicht verderblich)',
  10000223: 'Fruchtsaftgetränke – trinkfertig (ohne Kühlung haltbar)',
  10000227: 'Liköre',
  10000232: 'Mineral– / Quell– / Tafelwasser',
  10000235: 'Nüsse / Samen – bearbeitet / verarbeitet (leicht verderblich)',
  10000236: 'Nüsse / Samen – bearbeitet / verarbeitet (ohne Kühlung Haltbar)',
  10000238: 'Oliven (leicht verderblich)',
  10000239: 'Oliven (ohne Kühlung haltbar)',
  10000240: 'Teigwaren / Nudeln – verzehrbereit (leicht verderblich)',
  10000241: 'Teigwaren / Nudeln – verzehrbereit (ohne Kühlung haltbar)',
  10000242: 'Teigwaren / Nudeln – nicht verzehrbereit (ohne Kühlung haltbar)',
  10000244: 'Eingelegtes Gemüse / Sauerkonserven',
  10000245: 'Pasteten / Gebäck – süß (tiefgefroren)',
  10000246: 'Pasteten / Gebäck – süß (verderblich)',
  10000247: 'Pasteten / Gebäck – süß (konserviert – ohne Kühlung haltbar)',
  10000248: 'Pasteten / Gebäck / Pizzas / Quiches – herzhaft (tiefgefroren)',
  10000249:
    'Pasteten / Gebäck / Pizzas / Quiches – herzhaft (leicht verderblich)',
  10000250:
    'Pasteten / Gebäck / Pizzas / Quiches – herzhaft (ohne Kühlung haltbar)',
  10000252: 'Popcorn (ohne Kühlung haltbar)',
  10000254: 'Sandwiches / belegte Brötchen / Wraps (tiefgefroren)',
  10000255: 'Sandwiches / belegte Brötchen / Wraps (leicht verderblich)',
  10000256:
    'Krustentiere / Muscheln / Schnecken – bearbeitet / verarbeitet (tiefgefroren)',
  10000257:
    'Krustentiere / Muscheln / Schnecken – bearbeitet / verarbeitet (leicht verderblich)',
  10000258:
    'Krustentiere / Muscheln / Schnecken – bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000260: 'Fertigsuppen (tiefgefroren)',
  10000261: 'Fertigsuppen (leicht verderblich)',
  10000262: 'Fertigsuppen (ohne Kühlung haltbar)',
  10000263: 'Spirituosen',
  10000264:
    'Sportgetränke – Isotonische und mineralangereicherte Getränke (nicht trinkfertig)',
  10000265:
    'Sportgetränke – Isotonische und mineralangereicherte Getränke (trinkfertig)',
  10000266: 'Energydrinks – trinkfertig',
  10000267: 'Feinschnitt–Tabak / Pfeifentabak',
  10000268: 'Blocktabak',
  10000270: 'Gemüse – bearbeitet / verarbeitet (tiefgefroren)',
  10000271: 'Gemüse – bearbeitet / verarbeitet (leicht verderblich)',
  10000272: 'Gemüse – bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000273: 'Alkoholverstärkte Weine / Wermut',
  10000275: 'Sekte / Schaumweine / Perlweine',
  10000276: 'Weine – ohne Kohlensäure',
  10000277: 'Joghurt (tiefgefroren)',
  10000278: 'Joghurt (leicht verderblich)',
  10000279: 'Joghurt (ohne Kühlung haltbar)',
  10000280:
    'Dipsaucen / Würzsaucen / Feinkostsaucen / Aufstriche / Marinaden (ohne Kühlung haltbar)',
  10000281: 'Fisch – nicht bearbeitet / verarbeitet (tiefgefroren)',
  10000282: 'Fisch – nicht bearbeitet / verarbeitet (leicht verderblich)',
  10000283: 'Fisch – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000284: 'Getreideprodukte – verzehrbereit (ohne Kühlung haltbar)',
  10000285: 'Cerealien – nicht verzehrbereit (ohne Kühlung haltbar)',
  10000286: 'Cerealien – verzehrbereit (leicht verderblich)',
  10000287: 'Müslis / Müsliriegel',
  10000288:
    'Gemüse- /Kartoffelbasierte Produkte /-Gerichte – verzehrbereit (ohne Kühlung haltbar)',
  10000289:
    'Gemüse-/Kartoffelbasierte Produkte /- Gerichte – verzehrbereit (leicht verderblich)',
  10000290:
    'Gemüse-/Kartoffelbasierte Produkte / – Gerichte – nicht verzehrbereit (leicht verderblich)',
  10000291:
    'Gemüse- / Kartoffelbasierte Produkte /- Gerichte – nicht verzehrbereit (tiefgefroren)',
  10000292:
    'Gemüse- / Kartoffelbasierte Produkte /- Gerichte – nicht verzehrbereit (ohne Kühlung haltbar)',
  10000293:
    'Getreidebasierte Produkte/-Gerichte, herzhaft – verzehrbereit (leicht verderblich)',
  10000294:
    'Getreidebasierte Produkte/-Gerichte, herzhaft – verzehrbereit (ohne Kühlung haltbar)',
  10000295:
    'Getreidebasierte Produkte /-Gerichte, herzhaft – nicht verzehrbereit (leicht verderblich)',
  10000296:
    'Getreidebasierte Produkte/-Gerichte, herzhaft – nicht verzehrbereit (tiefgefroren)',
  10000297:
    'Getreidebasierte Produkte/-Gerichte, herzhaft – nicht verzehrbereit (ohne Kühlung haltbar)',
  10000298:
    'Teigbasierte Produkte /- Gerichte, herzhaft – verzehrbereit  (leicht verderblich)',
  10000299:
    'Teigbasierte Produkte/- Gerichte, herzhaft – verzehrbereit (ohne Kühlung haltbar)',
  10000300:
    'Teigbasierte Produkte/- Gerichte, herzhaft – nicht verzehrbereit  (leicht verderblich)',
  10000301:
    'Teigbasierte Produkte /- Gerichte, herzhaft – nicht verzehrbereit (tiefgefroren)',
  10000302:
    'Teigbasierte Produkte /- Gerichte, herzhaft – nicht verzehrbereit (ohne Kühlung haltbar)',
  10000303: 'Raucherbedarf',
  10000304: 'Kekse / Gebäck (tiefgefroren)',
  10000305: 'Getrocknete Broterzeugnisse (tiefgefroren)',
  10000306: 'Pasteten / Paté (ohne Kühlung haltbar)',
  10000307: 'Fruchtsaft – nicht trinkfertig (tiefgefroren)',
  10000308: 'Fruchtsaft – nicht trinkfertig (ohne Kühlung haltbar)',
  10000309: 'Fruchtsaftgetränke– nicht trinkfertig (ohne Kühlung haltbar)',
  10000310: 'Milchbasierte Getränke – nicht trinkfertig (ohne Kühlung haltbar)',
  10000311: 'Energydrinks – nicht trinkfertig',
  10000312: 'Desserts (ohne Kühlung haltbar)',
  10000313: 'Kräuter– und Früchtetees – trinkfertig',
  10000314: 'Körner / Getreide – nicht verzehrbereit (tiefgefroren)',
  10000315: 'Körner / Getreide – nicht verzehrbereit (leicht verderblich)',
  10000316: 'Körner / Getreide – verzehrbereit (leicht verderblich)',
  10000317: 'Teigwaren / Nudeln – nicht verzehrbereit (leicht verderblich)',
  10000318: 'Teigwaren / Nudeln – nicht verzehrbereit (tiefgefroren)',
  10000319: 'Körner / Getreide – verzehrbereit (ohne Kühlung haltbar)',
  10000320: 'Tampons',
  10000321: 'Inkontinenzprodukte – Ergänzungsprodukte / Zubehör',
  10000324: 'After–Shave–Produkte',
  10000327: 'Anti–Pickel–Pflegegeräte  (nicht elektrisch)',
  10000328: 'Badezusätze',
  10000329: 'Haarbleichmittel / –aufheller (Körperhaare)',
  10000330: 'Produkte zur Körperreinigung (u.a. Seifen / Duschbäder)',
  10000332:
    'Gesichtsreinigungs / Make–Up Entfernungsprodukte (nicht elektrisch)',
  10000333: 'Nagellackentferner / Nagelreiniger',
  10000334: 'Bade– / Duschzubehör – persönlich',
  10000335: 'Watteprodukte',
  10000336: 'Zahnersatz– / Zahnspangen–Pflegeprodukte',
  10000337: 'Gebiss– / Zahnspangen–Reiniger',
  10000338: 'Antitranspirante / Deodorants',
  10000340: 'Produkte zur Epilation / Depilation (nicht elektrisch)',
  10000341: 'Ohren– / Nasenpflegeprodukte',
  10000342: 'Peelings / Masken',
  10000343: 'Haarverlängerungen / Haarteile / Perücken',
  10000344: 'Damenhygiene – Zubehör',
  10000345: 'Haarfärbeprodukte / Colorationen',
  10000346: 'Haarspülungen / Haarkurprodukte',
  10000348: 'Dauerwellenpräparate',
  10000349: 'Haarentfernung / Rasurbedarf – Zubehör',
  10000350: 'Produkte zur Unterstützung / Pflege bei Haarentfernung',
  10000355: 'Selbstbräuner (Anwendung auf der Haut)',
  10000356: 'Feuchtigkeitsspendende Hautpflegeprodukte',
  10000358: 'Nagelkosmetik / Nagelpflege – Hilfsmittel  (nicht elektrisch)',
  10000359: 'Künstliche Fingernägel',
  10000360: 'Nagellacke',
  10000361: 'Nagelpflegeprodukte / Nagelkuren',
  10000362: 'Stillhygieneprodukte',
  10000363: 'Mundpflegeprodukte – Zubehör',
  10000365: 'Parfüms / Düfte',
  10000368: 'Haarshampoo',
  10000369: 'Rasierklingen',
  10000370: 'Einwegrasierer (nicht elektrisch)',
  10000373: 'Sonnenschutzmittel',
  10000374: 'Körperpuder',
  10000375: 'Toilettenpapier',
  10000376: 'Damenbinden',
  10000377: 'Kosmetische Hilfsmittel / Zubehör',
  10000379: 'Haarschmuck / Accessoires',
  10000381: 'Haarstyling',
  10000383: 'Zahnreinigungsmittel / Zahnpasta',
  10000384: 'Mundpflegeprodukte / Zahnbürsten (nicht elektrisch)',
  10000385: 'Nagelkosmetik / Nagelpflege – Zubehör (nicht elektrisch)',
  10000388: 'Bräunungsbeschleuninger',
  10000397: 'Reinigungs–Hilfsmittel',
  10000398: 'Reinigung – Zubehör',
  10000400: 'Pflege– und Reinigungsprodukte für Schuhe',
  10000402: 'Lufterfrischer (nicht elektrisch)',
  10000405: 'Oberflächenreiniger',
  10000406: 'Spülmaschinen–Geschirrreiniger',
  10000411: 'Insekten– / Schädlingsbekämpfungs – Barrieren / Gitter / Fallen',
  10000423: 'Rohrreiniger',
  10000424: 'Waschmittel',
  10000426: 'Toilettenreiniger',
  10000427: 'Wäsche–Färbemittel / –Entfärbemittel',
  10000432: 'Schuhfarben',
  10000433: 'Schuhe – Ersatzteile / Zubehör',
  10000434: 'Oberflächenpflege / –schutz – Polituren / Versiegelungen',
  10000435: 'Insektizide / Pestizide / Rodentizide',
  10000436: 'Insekten– / Schädlingsabwehrmittel (ohne Körperschutz)',
  10000440: 'Schimmel–Entferner',
  10000441: 'Sterilisationsmittel (Oberflächen)',
  10000442: 'Entkalker',
  10000443: 'Fleckenentferner',
  10000444: 'Trockenreinigungsmittel',
  10000445: 'Geschirrrschutz–Zusätze (Spülmaschine)',
  10000446: 'Wasserenthärter',
  10000447: 'Papiertücher',
  10000448: 'Erste–Hilfe–Produkte – Verbände / Pflaster',
  10000449: 'Erste–Hilfe–Produkte – Zubehör',
  10000450: 'Erste–Hilfe–Produkte – Schlingen / Stützvorrichtungen',
  10000451: 'Kühl– / Wärmekissen / –Packungen',
  10000452: 'Thermometer',
  10000453: 'Heimdiagnostik–Tests',
  10000454: 'Heimdiagnostik–Produkte – Zubehör',
  10000455: 'Heimdiagnostik – Überwachungsgeräte',
  10000456: 'Geräte / Hilfsmittel zur Medikamentenverabreichung',
  10000457: 'Geräte / Hilfsmittel zur Medikamentenverabreichung – Zubehör',
  10000458: 'Hilfsmittel für Menschen mit Behinderungen',
  10000459: 'Entwöhnungsprodukte',
  10000460: 'Kondome',
  10000461: 'Diaphragmen / Portiokappen',
  10000462: 'Spermizide',
  10000463: 'Hormonelle Verhütungsmittel',
  10000464: 'Intrauterinpessare',
  10000465: 'Appetitzügler / –Stimulantien / Fettblocker / Fatburner',
  10000466: 'Mahlzeitenersatzprodukte',
  10000467: 'Vitamine / Mineralstoffe',
  10000468: 'Nahrungsergänzungsmittel',
  10000474: 'Therapeutische Strümpfe / Kompressionsstrümpfe',
  10000481: 'Inkontinenzeinlagen',
  10000482: 'Menstruationsbecher',
  10000483: 'Slipeinlagen',
  10000484: 'Gesichtswasser / Adstringentien',
  10000485: 'Gesichtstücher / Taschentücher (einweg)',
  10000486: 'Hautaufheller',
  10000487: 'Hörgeräte',
  10000488: 'Medizinisches / Orthopädisches Schuhwerk / Einlagen',
  10000489: 'Fußpflegehilfsmittel',
  10000490: 'Babygeschirr',
  10000491: 'Babyfläschchen',
  10000492: 'Baby–Fütterungszubehör',
  10000493: 'Baby–Fütterungshilfen (nicht elektrisch)',
  10000494: 'Baby–Einwegwindeln',
  10000495: 'Baby–Windeleinlagen',
  10000496: 'Baby–Windelzubehör',
  10000498: 'Baby–Badesicherheitsprodukte',
  10000500: 'Heil– / Hilfsmittel für Babys / Kleinkinder',
  10000501: 'Wickeltische',
  10000502: 'Babybauchbinden / –Rucksäcke',
  10000503: 'Kindersicherungen (nicht elektrisch)',
  10000504: 'Schnuller / Beißringe',
  10000505: 'Baby–Hygieneprodukte',
  10000506: 'Haustiergetränke (tiefgefroren)',
  10000507: 'Haustierfutter (tiefgefroren)',
  10000508: 'Fellpflegehilfen',
  10000510: 'Haustierhygiene / –Gesundheitsschutz',
  10000513: 'Haustier–Nahrungsergänzungsmittel',
  10000514: 'Arzneimittel für Haustiere',
  10000515: 'Haustier–Parasitenbekämpfungsmittel',
  10000516: 'Aquarium–Hilfsmittel /–Zubehör',
  10000521: 'Haustierfutter (leicht verderblich)',
  10000522: 'Haustierfutter (ohne Kühlung haltbar)',
  10000523: 'Haustiergetränke (leicht verderblich)',
  10000524: 'Haustiergetränke (ohne Kühlung haltbar)',
  10000525: 'Präparate gegen Erkrankungen im / am Ohr / Otologika',
  10000526: 'Präparate gegen Erkrankungen im / am Auge / Ophtalmologika',
  10000527: 'Pflegeprodukte für Kontaktlinsen',
  10000528: 'Brillen – Fertiglesebrillen',
  10000529: 'Kontaktlinsen',
  10000531: 'Bleiche',
  10000532: 'Teintkosmetikprodukte',
  10000533: 'Augenkosmetikprodukte',
  10000534: 'Lippenkosmetikprodukte',
  10000535: 'Rasiermittel / Rasierschaum (ohne After–Shave–Produkte)',
  10000536: 'Atemerfrischer / Mundspülungen',
  10000541: 'Kordeln / Bänder',
  10000542: 'Haushaltsscheren',
  10000543: 'Entzündungswerkzeuge / Streichhölzer',
  10000546: 'Batterien',
  10000547: 'Gleichrichter / Wechselrichter / Regler / Transformatoren',
  10000548: 'Batterieladegeräte',
  10000549: 'Sicherungen',
  10000551: 'Haushaltsstecker',
  10000552: 'Glühbirnen / Leuchtstoffröhren /lichtemittierende Dioden',
  10000554: 'Einweg–Kochgeschirr',
  10000555: 'Kerzen',
  10000556: 'Kratzer–Entferner–Sets',
  10000559: 'Papierfilter',
  10000564: 'Haarpflege – Geräte / Hilfsmittel (nicht elektrisch)',
  10000566: 'Wärmeprodukte / –kissen / Massagegeräte (nicht elektrisch)',
  10000567: 'Muskelstimulatoren / Körperstraffungsprodukte (elektrisch)',
  10000570: 'Mittel zur Insektenabwehr',
  10000572: 'Haustierbetten',
  10000573: 'Feuchttücher',
  10000574: 'Speisefette – tierisch (ohne Kühlung haltbar)',
  10000575: 'Fertigmilchnahrung für Babies (ohne Kühlung haltbar)',
  10000576: 'Pasteten / Paté (tiefgefroren)',
  10000577:
    'Dipsaucen / Würzsaucen / Feinkostsaucen / Aufstriche / Marinaden (tiefgefroren)',
  10000578: 'Fond / Knochen – (ohne Kühlung haltbar)',
  10000579: 'Fond / Knochen – (leicht verderblich)',
  10000580: 'Fond / Knochen (tiefgefroren)',
  10000581: 'Glasuren / Tortenguss (ohne Kühlung haltbar)',
  10000583: 'Salatsaucen / Dips (tiefgefroren)',
  10000584: 'Kräuterzigaretten – tabak– und nikotinfrei',
  10000585: 'Speisefette – pflanzlich (leicht verderblich)',
  10000586: 'Chutneys / Relishes (tiefgefroren)',
  10000587: 'Chutneys / Relishes (leicht verderblich)',
  10000588: 'Alkoholische Getränke, nicht auf Traubenbasis – ohne Kohlensäure',
  10000589: 'Alkoholische Sirups und Magenbitter',
  10000590: 'Lebensmittel / Getränke / Tabakwaren – Mischpackungen',
  10000591: 'Alkoholische Getränke – Mischpackungen',
  10000592: 'Kaffee / Tee / Ersatzprodukte – Mischpackungen',
  10000593: 'Alkoholfreie Getränke Mischpackungen – nicht trinkfertig',
  10000594: 'Alkoholfreie Getränke Mischpackungen – trinkfertig',
  10000595: 'Back– / Kochmischungen / Zutaten – Mischpackungen',
  10000596: 'Kekse / Gebäck – Mischpackungen',
  10000597: 'Süße Backwaren – Mischpackungen',
  10000598: 'Brot / Backwaren – Mischpackungen',
  10000599: 'Getreide / Mehl – Mischpackungen',
  10000600: 'Verarbeitete Getreideprodukte – Mischpackungen',
  10000601: 'Getreide– / Korn– / Hülsenfruchtprodukte – Mischpackungen',
  10000602: 'Süßwaren – Mischpackungen',
  10000603: 'Zucker / Zuckerersatzstoffe – Mischpackungen',
  10000604: 'Früchte / Nüsse / Samen Mischpackungen',
  10000605:
    'Obst / Gemüse / Nüsse / Samen bearbeitet / verarbeitet – Mischpackungen',
  10000607:
    'Milch / Butter / Sahne / Käse / Eier / Ersatzprodukte – Mischpackungen',
  10000608: 'Speisefett – Mischpackungen',
  10000609: 'Speiseöl / Speisefett Mischpackungen',
  10000610: 'Baby– / Kleinkindernahrung – Mischpackungen',
  10000611: 'Desserts / Dessertgarnierungen – Mischpackungen',
  10000612: 'Snacks / Knabberartikel – Mischpackungen',
  10000613: 'Bearbeitete / Verarbeitete Nahrungsmittel – Mischpackungen',
  10000614: 'Fisch / Meeresfrüchte Mischpackungen',
  10000615: 'Kräuter / Gewürze / Extrakte – Mischpackungen',
  10000616:
    'Eingelegtes Gemüse / Relishes / Chutneys / Oliven – Mischpackungen',
  10000617: 'Saucen / Aufstriche / Dips / Würzsaucen – Mischpackungen',
  10000618: 'Essig / Kochweine – Mischpackungen',
  10000619: 'Gewürze / Konservierungsstoffe / Extrakte – Mischpackungen',
  10000620: 'Tabakprodukte / Rauchzubehör – Mischpackungen',
  10000621: 'Süße Brotaufstriche – Mischpackungen',
  10000622: 'Süßwaren / Süßungsmittel –  Mischpackungen',
  10000623: 'Getränke – Mischpackungen',
  10000624: 'Segmentübergreifende Sets',
  10000626:
    'Fisch / Meeresfrüchte – Mischungen – bearbeitet / verarbeitet (tiefgefroren)',
  10000627:
    'Fisch / Meeresfrüchte – Mischungen – bearbeitet / verarbeitet (leicht verderblich)',
  10000628:
    'Fisch / Meeresfrüchte – Mischungen – bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000629:
    'Fisch / Meeresfrüchte – Mischungen – nicht bearbeitet / verarbeitet (tiefgefroren)',
  10000630:
    'Fisch / Meeresfrüchte – Mischungen – nicht bearbeitet / verarbeitet (leicht verderblich)',
  10000631:
    'Fisch / Meeresfrüchte – Mischungen – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  10000634: 'Baby–Überwachung (nicht elektrisch)',
  10000635: 'Einweggeschirr',
  10000636: 'Hand–Geschirrspülmittel',
  10000637: 'Sonnenbrillen – Fertigbrillen',
  10000638: 'Brillengläser',
  10000639: 'Brillengestelle',
  10000640:
    'Haustiertrainings– / –Führungshilfen / –Zubehör (nicht elektrisch)',
  10000641: 'Haustierspielzeug (nicht elektrisch)',
  10000643: 'Haustierkleidung',
  10000647: 'Heimdiagnostik – Sets',
  10000648: 'Diagnostik – Tests – Sets',
  10000649: 'Gesundheitsförderung – Sets',
  10000650: 'Diätunterstützung – Sets',
  10000651: 'Vitamine / Mineralstoffe / Nahrungsergänzungsmittel – Sets',
  10000652: 'Haustiertrainings– / –Führungshilfen / –Zubehör (elektrisch)',
  10000653: 'Haustierbedarf – Sets',
  10000654: 'Haustierbedarf / Haustiernahrung – Sets',
  10000657: 'Haustierfürsorge / –Hygiene – Sets',
  10000658: 'Haustier-Nahrungsergänzung – Sets',
  10000659: 'Haustierzubehör – Sets',
  10000660: 'Haustierfutter– / –Getränkespender',
  10000661: 'Haustierspielzeug (elektrisch)',
  10000662: 'Haustierbehausungen (mehrweg)',
  10000663: 'Haustierfutter / –getränke – Sets',
  10000664: 'Insekten– / Schädlingsbekämpfungmittel – Sets',
  10000666: 'Schönheit / Körperpflege / Hygieneartikel  – Sets',
  10000668: 'Körpermassagegeräte / Muskelstimulatoren – Sets',
  10000669: 'Kosmetikprodukte – Sets',
  10000671: 'Nagelkosmetik– / Nagelpflegeprodukte – Sets',
  10000672: 'Kosmetik / Parfüms – Sets',
  10000673: 'Gesundheitswesen – Sets',
  10000674: 'Mechanische Verhütungsmittel – Sets',
  10000675: 'Familienplanung – Sets',
  10000676: 'Haarpflege / Haarentfernung – Sets',
  10000677: 'Haarpflegeprodukte – Sets',
  10000678: 'Haarstyling–Geräte (elektrisch)',
  10000679: 'Rasierspiegel / Kosmetikspiegel',
  10000680: 'Haarentfernung / Haarkuren – Sets',
  10000681: 'Geräte / Hilfsmittel zur Medikamentenverabreichung – Sets',
  10000682: 'Rauchentwöhnungshilfen / –Produkte',
  10000683: 'Gesundheitswesen – Behandlung / Hilfsmittel – Sets',
  10000684: 'Erste–Hilfe–Produkte – Sets',
  10000685: 'Fuß– / Beinpflege / – Behandlung – Sets',
  10000686: 'Persönliche Hilfsmittel – Sets',
  10000687: 'Präparate / Hilfsmittel für Sinnesorgane (Augen / Ohren) – Sets',
  10000688: 'Hilfsmittel zur Brillenpflege',
  10000689: 'Brillenzubehör',
  10000690: 'Entwöhnungsbehandlung – Sets',
  10000692: 'Tüten / Beutel für Lebensmittel (einweg)',
  10000693: 'Frischhaltefolie (einweg)',
  10000694: 'Reinigungsmittel / Haushygieneprodukte – Sets',
  10000696: 'Lufterfrischer (elektrisch)',
  10000697: 'Lufterfrischer / Textilerfrischer – Sets',
  10000698: 'Reiniger – Sets',
  10000699: 'Wäschepflegeprodukte – Sets',
  10000700: 'Schuhzubehör – Sets',
  10000701: 'Oberflächenpflege – Sets',
  10000702: 'Reinigungsmittel – Sets',
  10000703: 'Kraftstoffe / Zündmittel – Sets',
  10000704: 'Batterien / Ladegeräte – Sets',
  10000709: 'Inkontinenz–Unterwäsche (einweg)',
  10000710: 'Inkontinenz–Unterwäsche (mehrweg)',
  10000712: 'Hygieneartikel / Mundhygiene – Sets',
  10000713: 'Inkontinenzprodukte – Sets',
  10000714: 'Damenhygiene– / Stillhygieneprodukte – Sets',
  10000715: 'Allgemeine Körperhygieneprodukte – Sets',
  10000716: 'Mundhygieneprodukte – Sets',
  10000717: 'Hautpflegeprodukte – Sets',
  10000719: 'Produkte zur Kühlung von Haut / Gesicht',
  10000721: 'Hautpflegeprodukte – Sets',
  10000722: 'Körperreinigungsprodukte – Sets',
  10000723: 'Bräunungsprodukte – Sets',
  10000724: 'Baby–Trinksauger',
  10000728: 'Baby–Mehrwegwindeln',
  10000730: 'Rasierer – mehrweg (nicht elektrisch)',
  10000731: 'Bräunungsmittel (oral)',
  10000732: 'Babylätzchen',
  10000736: 'Haustierzubehör – sonstige',
  10000737: 'Haustier-Nahrungsergänzung – sonstige',
  10000738: 'Haustierfürsorge / –Hygiene – sonstige',
  10000740: 'Textilerfrischer',
  10000741: 'Gewebeschutzprodukte',
  10000742: 'Wäschestärke / Bügelhilfen',
  10000743: 'Waschzusätze / Bleichmittel / Fleckentferner',
  10000744: 'Weichspüler',
  10000745: 'Lufterfrischer / Textilerfrischer – sonstige',
  10000746: 'Reiniger  – sonstige',
  10000747: 'Wäschepflegeprodukte – sonstige',
  10000749: 'Oberflächenpflege – sonstige',
  10000754: 'Insekten– / Schädlingsbekämpfungmittel – sonstige',
  10000758: 'Körpermassagegeräte / Muskelstimulatoren – Ersatzteile',
  10000759: 'Heizdecken / Wärmekissen / Massagegeräte (elektrisch)',
  10000760: 'Körpermassagegeräte / Muskelstimulatoren – sonstige',
  10000761: 'Kosmetische Farben / Schimmer / Glitter',
  10000762: 'Brust– / Hüftpolster',
  10000763: 'Tattoos (temporär) / Schablonen / Selbstklebender Schmuck',
  10000764: 'Falsche Wimpern',
  10000767: 'Nagelkosmetik / Nagelpflege – Zubehör (elektrisch)',
  10000768: 'Nagelkosmetik– / Nagelpflegeprodukte – Ersatzteile',
  10000769: 'Aromazerstäuber / –diffusoren (nicht elektrisch)',
  10000770: 'Aromazerstäuber / –diffusoren (elektrisch)',
  10000771: 'Ätherische Öle',
  10000772: 'Aromatherapiekissen',
  10000773: 'Basis– / Trägeröle',
  10000774: 'Aromatherapieprodukte – Sets',
  10000775: 'Kosmetikprodukte  – sonstige',
  10000778: 'Nagelkosmetik– / Nagelpflegeprodukte – sonstige',
  10000779: 'Aromatherapieprodukte – sonstige',
  10000780: 'Nagelkosmetik / Nagelpflege – Hilfsmittel  (elektrisch)',
  10000781: 'Mundpflegeprodukte / Zahnbürsten (elektrisch)',
  10000782: 'Mundhygieneprodukte – Ersatzteile',
  10000783: 'Mundhygieneprodukte – sonstige',
  10000784: 'Inkontinenzprodukte – sonstige',
  10000785: 'Damenhygiene– / Stillhygieneprodukte – sonstige',
  10000786: 'Allgemeine Körperhygieneprodukte – sonstige',
  10000787: 'Babyhochstühle',
  10000788: 'Babylaufställe',
  10000789: 'Gitterbetten / Stubenwagen',
  10000790: 'Babymatratzen',
  10000791: 'Baby–Überwachung (elektrisch)',
  10000792: 'Kinder–Autositze / –Sitzerhöhungen',
  10000793: 'Kinderwagen / Buggys',
  10000794: 'Babyreisebetten',
  10000795: 'Babytragebetten / –Körbe / –Wiegen',
  10000796: 'Babygurte / –Geschirre',
  10000797: 'Kinderwagen / Buggy – Zubehör',
  10000800: 'Schaukelliegen / Wippen (nicht elektrisch)',
  10000801: 'Schaukelliegen / Wippen (elektrisch)',
  10000802: 'Türhopser',
  10000803: 'Babyschaukeln',
  10000804: 'Baby–Lauflernhilfen',
  10000805: 'Baby–Spiel– / Transportgeräte – sonstige',
  10000806: 'Anti–Pickel–Pflegegeräte (elektrisch)',
  10000807: 'Sprudelbäder / Badmassagegeräte',
  10000808: 'Gesichtsreinigungsgeräte / Make–Up Entferner (elektrisch)',
  10000809: 'Bräunungsgeräte (elektrisch)',
  10000810: 'Hautpflegeprodukte – Ersatzteile',
  10000811: 'Bräunungsprodukte – Ersatzteile',
  10000812: 'Hautpflegeprodukte – sonstige',
  10000813: 'Körperreinigungsprodukte – sonstige',
  10000814: 'Bräunungsprodukte – sonstige',
  10000820: 'Baby–Fütterungshilfen (elektrisch)',
  10000821: 'Babytöpfchen / –Toilettentrainer',
  10000822: 'Wickeltischauflagen',
  10000823: 'Babyfütterung – Ersatzteile',
  10000825: 'Babyfütterung – sonstige',
  10000827: 'Baby–Badewannen / –Badestühle / –Badeschalen',
  10000828: 'Haarpflege – Geräte / Hilfsmittel (elektrisch)',
  10000829: 'Lockenwickler',
  10000830: 'Produkte zur Epilation / Depilation (elektrisch)',
  10000831: 'Rasierapparate (elektrisch)',
  10000832: 'Haarentfernung / Haarkuren – Ersatzteile',
  10000833: 'Haarpflegeprodukte – Ersatzteile',
  10000834: 'Haarpflegeprodukte – sonstige',
  10000835: 'Haarentfernung / Haarkuren – sonstige',
  10000838: 'Mechanische Verhütungsmittel – sonstige',
  10000841: 'Diätunterstützung – sonstige',
  10000843: 'Diagnostik–Überwachung – sonstige',
  10000844: 'Diagnostik – Tests – sonstige',
  10000846: 'Präparate gegen Reizungen im Genitalbereich',
  10000847: 'Präparate gegen Blasenentzündung',
  10000848: 'Präparate gegen Beschwerden im Rektalbereich',
  10000849:
    'Präparate gegen Beschwerden an der Blase / im Genital– / Rektalbereich – sonstige',
  10000850: 'Harntreibende Mittel / Diuretika',
  10000851: 'Geräte für Einläufe / Darm– / Intimspülungen',
  10000852:
    'Präparate gegen Beschwerden der Blase / im Genital– / Rektalbereich  – Sets',
  10000853: 'Geräte zur Schmerzbekämpfung (elektrisch)',
  10000854: 'Schmerzmittel / Schmerzbekämpfung – sonstige',
  10000855: 'Arthritis– / Rheuma– / Muskel–Schmerzmittel',
  10000856: 'Allgemeine Schmerzmittel',
  10000857: 'Kopfschmerzmittel / Migränemittel',
  10000858: 'Schmerzmittel / Schmerzbekämpfung – Sets',
  10000859: 'Homöopathische Mittel mit einem Wirkstoff',
  10000860: 'Homöopathische Mittel mit mehreren Wirkstoffen',
  10000861: 'Pflanzliche Heilmittel',
  10000862: 'Homöopathische / Pflanzliche Heilmittel – Sets',
  10000863: 'Antazida / Präparate gegen Verdauungsstörungen / Blähungen',
  10000864: 'Durchfallpräparate',
  10000865: 'Gastrointestinale Präparate – sonstige',
  10000866: 'Abführmittel',
  10000867: 'Anti–Wurm–Medikamente',
  10000868: 'Heilmittel gegen Übelkeit und Erbrechen',
  10000869: 'Orale Rehydrationsmittel / Elektrolytmischungen',
  10000870: 'Allgemeine gastrointestinale Präparate / Kombinationspräparate',
  10000871: 'Gastrointestinale Präparate – Sets',
  10000872: 'Schlafmittel',
  10000873: 'Anti–Stress–Mittel / Beruhigungsmittel',
  10000874: 'Schlafmittel / Anti–Stress–Mittel – Sets',
  10000875: 'Einreibemittel / Erkältungssalben',
  10000876: 'Erkältungs– / Husten–Medikamente',
  10000877: 'Inhalatoren / Inhalationsgeräte / Atemgeräte (nicht elektrisch)',
  10000878: 'Inhalatoren / Inhalationsgeräte / Atemgeräte (elektrisch)',
  10000879: 'Nasensprays / –Strips',
  10000880: 'Präparate gegen Halsschmerzen / Rachenentzündung',
  10000881: 'Präparate zur Allergieprävention / –Linderung / Antihistaminika',
  10000882: 'Schwellungshemmende / –lindernde Mittel',
  10000883: 'Luftbefeuchter / Vaporisatoren (nicht elektrisch)',
  10000884: 'Produkte gegen Atemwegserkrankungen / Allergien – Sets',
  10000885: 'Mittel zur Händedesinfektion / Antiseptika',
  10000886: 'Behandlungen gegen Parasitenbefall',
  10000887: 'Präparate gegen Schuppenflechte / Ekzeme / trockene (Kopf–) Haut',
  10000888: 'Behandlungen gegen Haarausfall',
  10000889: 'Präparate zur Linderung von Insektenstichen',
  10000890: 'Präparate gegen Hautpilzerkrankungen',
  10000891:
    'Allgemeine Präparate gegen Erkrankungen / Verletzungen der Haut / Kopfhaut',
  10000892: 'Hilfsmittel gegen Parasitenbefall (nicht elektrisch)',
  10000893: 'Hilfsmittel gegen Parasitenbefall (elektrisch)',
  10000894: 'Reisekrankheitsprävention (medikamentös)',
  10000895: 'Reisekrankheitsprävention (nicht medikamentös)',
  10000896: 'Mittel gegen Reisekrankheit – Sets',
  10000897: 'Reisekrankheitsmittel – sonstige',
  10000898: 'Künstliche Ernährung – Gastrostomie–Sets',
  10000899: 'Enterale Ernährung – Pumpen / Ernährungssets',
  10000900: 'Künstliche Ernährung – Beutel / Behälter',
  10000901: 'Enterale Ernährung – Sonden',
  10000902: 'Geräte / Hilfsmittel zur enteralen Ernährung – sonstige',
  10000903: 'Behandlungen gegen Akne / Rosazea',
  10000904: 'Präparate gegen Warzen / Hühneraugen / Hornhaut',
  10000905:
    'Präparate gegen Erkrankungen / Verletzungen der Haut / Kopfhaut – Sets',
  10000906:
    'Behandlungen gegen Erkrankungen / Verletzungen der Haut / Kopfhaut – sonstige',
  10000907: 'Fuß– / Beinpflege / – Behandlung – sonstige',
  10000908: 'Erste–Hilfe–Produkte – sonstige',
  10000909: 'Giftentfernungsmittel / Antidote',
  10000910: 'Sterilisationsmittel / Desinfektionsalkohol',
  10000911:
    'Präparate / Hilfsmittel für Sinnesorgane (Augen / Ohren) – sonstige',
  10000912: 'Geräte / Hilfsmittel zur Medikamentenverabreichung – Ersatzteile',
  10000914: 'Homöopathische / Pflanzliche Mittel – sonstige',
  10000915: 'Persönliche Hilfsmittel – sonstige',
  10000916: 'Luftbefeuchter / Vaporisatoren (elektrisch)',
  10000917: 'Stimulantien / Aufputschmittel',
  10000918: 'Stimulantien / Aufputschmittel – sonstige',
  10000919: 'Schlafmittel / Anti–Stress–Mittel – sonstige',
  10000920: 'Produkte gegen Atemwegserkrankungen / Allergien – sonstige',
  10000921: 'Geräte / Hilfsmittel zur enteralen Ernährung – Sets',
  10000922: 'Geräte / Hilfsmittel zur Medikamentenverabreichung – sonstige',
  10000923: 'Intim–Gleitmittel',
  10000925: 'E–Books / elektronische Texte',
  10000926: 'Gedruckte Bücher / Schriften',
  10000927: 'Elektronische Zeitungen / Zeitschriften',
  10000928: 'Gedruckte Zeitungen / Zeitschriften',
  10000933: 'Blechblasinstrumente (akustisch / mechanisch)',
  10000934: 'Keyboards / Klaviere (akustisch / mechanisch)',
  10000935: 'Perkussionsinstrumente (akustisch / mechanisch)',
  10000936: 'Saiteninstrumente (akustisch / mechanisch)',
  10000937: 'Holzblasinstrumente (akustisch / mechanisch)',
  10000938: 'Blechblasinstrumente (elektrisch / elektronisch)',
  10000939: 'Musikinstrumente – Zusatzgeräte (elektrisch / elektronisch)',
  10000940: 'Keyboards / Klaviere (elektrisch / elektronisch)',
  10000941: 'Perkussionsinstrumente (elektrisch / elektronisch)',
  10000942: 'Saiteninstrumente (elektrisch / elektronisch)',
  10000943: 'Holzblasinstrumente (elektrisch / elektronisch)',
  10001070: 'Sportschuhe – universal',
  10001071: 'Sportschuhe – spezielle Sportarten',
  10001074: 'Schuheinlagen',
  10001076: 'Stiefel – universal',
  10001077: 'Schuhe – universal',
  10001078: 'Hausschuhe – geschlossen',
  10001079: 'Hausschuhe – offen / halboffen',
  10001080: 'Sicherheits-/ Arbeitsstiefel',
  10001081: 'Sicherheits-/ Arbeitsüberschuhe',
  10001082: 'Sicherheitsschuhe',
  10001083: 'Fußkettchen',
  10001084: 'Armbänder',
  10001085: 'Broschen',
  10001086: 'Manschettenknöpfe',
  10001087: 'Ohrringe / Piercingschmuck',
  10001088: 'Schmuckkästchen /–Beutel',
  10001089: 'Schmuck – Ersatzteile',
  10001090: 'Halsketten / Colliers',
  10001091: 'Anhänger',
  10001092: 'Ringe',
  10001093: 'Diademe',
  10001094: 'Bauch– / Gürteltaschen',
  10001095: 'Aktentaschen',
  10001096: 'Handtaschen / Schultertaschen',
  10001097: 'Gepäck / Taschen / Schirme – Zubehör',
  10001099: 'Gepäck / Koffer / Kleidungsträger',
  10001100: 'Rucksäcke / Reisetaschen',
  10001101: 'Einkaufstaschen / Trolleys',
  10001102: 'Schirme',
  10001103: 'Brieftaschen / Geldbörsen / Taschen für Reisedokumente',
  10001104: 'Armbanduhren / Taschenuhren – Ersatzteile / Zubehör',
  10001105: 'Uhren',
  10001107: 'Computer / PC– / Videospiele – Taschen / Schutzhüllen / Etuis',
  10001108: 'Computer / PC– / Videospiele – Reinigungsprodukte',
  10001109: 'Computer – Docking– / Basis–Stationen',
  10001110:
    'Filter / Abdeckungen für Computer / Monitore / Peripheriegeräte tec.',
  10001111: 'Computer / PC– / Videospiele – Schlösser / Sicherheitsprodukte',
  10001112: 'Computerwerkzeug / –Werkzeugsets',
  10001113: 'Computer – Mauspads / Handgelenkauflagen',
  10001114: 'Eingabestifte für PDAs / Smartphones',
  10001115: 'Kartenlesegeräte',
  10001116: 'Computergehäuse – Zubehör',
  10001117: 'Computergehäuse',
  10001118: 'Computerkomponenten – Ersatzteile / Zubehör',
  10001119: 'Computer – Komponenten – sonstige',
  10001120: 'Computer – Komponenten – Sets',
  10001121: 'Prozessorkühler / Computerkühler',
  10001122: 'Computerspeichermodule',
  10001123: 'Computer–Leiterplatten / Motherboards',
  10001124: 'Computer–Netzteile',
  10001125: 'Computerprozessoren',
  10001126: 'Erweiterungsplatinen / –Karten',
  10001127: 'Optische Laufwerke (lesen / schreiben)',
  10001128: 'Optische Laufwerke (nur lesen)',
  10001129: 'Computerlaufwerke –  Ersatzteile / Zubehör',
  10001130: 'Computerlaufwerke – sonstige',
  10001131: 'Computer–Laufwerke – Sets',
  10001132: 'Diskettenlaufwerke',
  10001133: 'Festplattenlaufwerke',
  10001134: 'Swapper',
  10001135: 'Magnetbandlaufwerke / Bandlaufwerke',
  10001136: 'Zip– / Jaz–Laufwerke',
  10001137: 'Computer– / PC– / Videospiele – Spielesoftware',
  10001138: 'Computer–Software (keine Spiele)',
  10001139: 'Computer– / PC– / Videospiele – Software – sonstige',
  10001140: 'Computer / PC– / Videospiele – Software – Sets',
  10001141: 'Computer –  Ersatzteile / Zubehör',
  10001142: 'Computer – sonstige',
  10001143: 'Elektronische Organiser / Übersetzer',
  10001144: 'Personalcomputer (PCs) –  Desktop / Internet-Terminals',
  10001145: 'Personal Computer (PCs) –  tragbar (Laptop / Notebook)',
  10001146: 'Personal Digital Assitants (PDAs) / WebPads',
  10001147: 'Server',
  10001148: 'Computer / PC– / Videospiele – Steuergeräte',
  10001149: 'Grafiktabletts',
  10001150: 'Computertastaturen',
  10001151: 'Computer–Zeigegeräte / –Steuergeräte (Mäuse / Trackballs)',
  10001152:
    'Computer– / PC– / Videospiele – Steuer– / Eingabegeräte –  Ersatzteile / Zubehör',
  10001153: 'Computer– / Videospiel–Monitore',
  10001154: 'Computerlautsprecher / Minilautsprecher',
  10001155:
    'Computer– / PC– / Videospiele – Peripheriegeräte – Ersatzteile / Zubehör',
  10001156: 'Druckerverbrauchsmaterial',
  10001158: 'Drucker',
  10001159:
    'Computer–Projektionssysteme / Beamer / Videoprojektoren / interaktive Bildschirme',
  10001160: 'Scanner (Datenerfassung)',
  10001161: 'Webcams',
  10001162: 'Firewalls',
  10001163: 'Gateways',
  10001164: 'Modems',
  10001165: 'Netzwerk Access Points',
  10001166: 'Netzwerk– / USB–Hubs',
  10001167: 'Netzwerkkarten',
  10001168: 'Netzwerk–Router',
  10001169: 'Netzwerk–Switches',
  10001170: 'Computer – Netzwerkausstattung – sonstige',
  10001171: 'Computer – Netzwerk–Ausstattung – Sets',
  10001172: 'Computer – Netzwerkausstattung – Ersatzteile / Zubehör',
  10001173: 'Repeater',
  10001174: 'Rufnummernanzeigen',
  10001177: 'Telefonhalterungen',
  10001178: 'Handytaschen',
  10001181: 'Freisprechanlagen / Headsets',
  10001182: 'Handyschalen',
  10001183: 'Mobiltelefon (Handy) – Strahlenschutzprodukte',
  10001184: 'Anrufbeantworter',
  10001185: 'Konferenzsysteme',
  10001186: 'Faxgeräte',
  10001188:
    'Kommunikationsgeräte – Festnetz / kabelgebunden – Pre–Paid–Karten / Telefonkarten',
  10001189: 'Sprechanlagen / Haustelefone',
  10001190: 'Telefonanlagen / Telefonzentralen',
  10001191: 'Telefone',
  10001192: 'Funkkommunikationsgeräte',
  10001193: 'GPS–Empfänger',
  10001194: 'GPS–Software',
  10001195: 'Prepaid–Karten für Mobiltelefone',
  10001196: 'SIM–Karten / Dual–SIM–Adapter für Mobiltelefone',
  10001197: 'Software für Mobiltelefone',
  10001198: 'Mobiltelefone (Handys) / Smartphones',
  10001199: 'Funkmeldeempfänger (Pager)',
  10001200: 'Funkgeräte / Walkie–Talkies',
  10001201: 'Geschenkverpackung',
  10001202: 'Geschenkverpackung / Zubehör – sonstige',
  10001203: 'Geschenkverpackung – Zubehör',
  10001204: 'Geschenkverpackung / Zubehör – Sets',
  10001205: 'Glückwunschkarten / Geschenkpapier / Partyartikel – Sets',
  10001206: 'Glückwunschkartenhalter / –Displays',
  10001207: 'Glückwunschkarten / Einladungskarten – sonstige',
  10001208: 'Glückwunschkarten / Einladungskarten – Sets',
  10001209: 'Glückwunschkarten / Einladungskarten',
  10001212: 'Einladungsblöcke / Notizblöcke',
  10001213: 'Postkarten',
  10001214: 'Ballons',
  10001215: 'Konfetti',
  10001216: 'Feuerwerksartikel',
  10001217: 'Party– / Dekorationsartikel',
  10001218: 'Party– / Dekorationsartikel – Sets',
  10001220: 'Knallbonbons',
  10001221: 'Partyhüte',
  10001222: 'Tischfeuerwerke / Party Popper',
  10001223: 'Piñatas',
  10001224: 'Luftschlangen / Girlanden / Grußketten',
  10001225: 'Tinte',
  10001226: 'Korrekturmittel',
  10001228: 'Schreib– / Gestaltungsutensilien / Hilfsmittel  – sonstige',
  10001229: 'Schreibutensilien  – Ersatzteile',
  10001230: 'Schreib– / Gestaltungsutensilien / Hilfsmittel  – Sets',
  10001231: 'Lineale / Zeichenhilfsmittel',
  10001232: 'Spitzer (nicht elektrisch)',
  10001233: 'Spitzer (elektrisch)',
  10001234: 'Bleistifte',
  10001235: 'Schreibgeräte / Kugelschreiber / Füller',
  10001236: 'Schablonen',
  10001241: 'Stempel (nicht elektrisch)',
  10001242: 'Taschenrechner / Währungsumrechner (elektrisch)',
  10001243: 'Registrierkassen / Kassen (elektrisch)',
  10001245: 'Adressiermaschinen',
  10001246: 'Laminiermaschinen – Verbrauchsmaterial',
  10001247: 'Laminiermaschinen (elektrisch)',
  10001248: 'Büromaschinen – sonstige',
  10001250: 'Büromaschinen – Sets',
  10001251: 'Fotokopierer – Verbrauchsmaterial',
  10001252: 'Fotokopierer',
  10001253: 'Schreibmaschinen (nicht elektrisch)',
  10001254: 'Schreibmaschinen (elektrisch)',
  10001255: 'Kalender / Planer',
  10001256: 'Kontaktbücher / –Blöcke',
  10001257: 'Planungs– / Organisationshilfsmittel – sonstige',
  10001258: 'Planungs– / Organisationshilfsmittel – Ersatzteile / Zubehör',
  10001259: 'Planungs– / Organisationshilfsmittel – Sets',
  10001260: 'Organizer / Terminkalender (nicht elektrisch / elektronisch)',
  10001261: 'Briefumschläge / Versandtaschen',
  10001262: 'Frankiermaschinen',
  10001263: 'Falz– / Kuvertier– / Schließmaschinen',
  10001264: 'Brieföffner (nicht elektrisch)',
  10001265: 'Brieföffnungsmaschinen (elektrisch)',
  10001266: 'Versandrollen / Versandkartons',
  10001267: 'Briefwaagen (nicht elektrisch)',
  10001268: 'Briefwaagen (elektrisch)',
  10001269: 'Versandmaterialien / Postbearbeitung – Zubehör',
  10001270: 'Versandmaterialien / Postbearbeitung / Zubehör  – sonstige',
  10001272: 'Versandmaterialien / Postbearbeitung / Zubehör – Sets',
  10001273: 'Packhilfsmittel',
  10001275: 'Flipchart–Ständer',
  10001276: 'Zeigestöcke (nicht elektrisch)',
  10001277: 'Pointer (elektrisch)',
  10001278: 'Moderationtafeln / Weißwandtafeln / Pinnwände (nicht elektrisch)',
  10001280: 'Präsentationsmaterialien / –Geräte – sonstige',
  10001281: 'Präsentationsmaterialien / –Geräte – Zubehör',
  10001283: 'Präsentationsmaterialien / –Geräte – Sets',
  10001286: 'Bindezubehör',
  10001287: 'Bindemaschinen (nicht elektrisch)',
  10001288: 'Bindemaschinen (elektrisch)',
  10001289: 'Büro– / Heft– / Aktenklammern (Bürobedarf)',
  10001292: 'Klebstoffe (Bürobedarf)',
  10001295:
    'Bürobedarf – Klebemittel / Bindemaschinen / Heftmaschinen – sonstige',
  10001297: 'Bürobedarf – Klebemittel / Bindemaschinen / Heftmaschinen – Sets',
  10001298: 'Enthefter (Bürobedarf)',
  10001299: 'Heftergeräte (nicht elektrisch) (Bürobedarf)',
  10001300: 'Heftmaschinen (elektrisch) (Bürobedarf)',
  10001302: 'Papierschneidemaschinen',
  10001304: 'Papiere / Kartone – blanko',
  10001305: 'Geschäftsformulare / Geschäftspapier – vorbedruckt',
  10001306: 'Papierschneidemaschinen – sonstige',
  10001308: 'Papierschneidemaschinen – Sets',
  10001309: 'Aktenvernichter (nicht elektrisch)',
  10001311: 'Locher (nicht elektrisch)',
  10001312: 'Locher (elektrisch)',
  10001313: 'Aufkleber / Coupons / Etiketten',
  10001314: 'Folien / Acetatfolien',
  10001316: 'Geldkasetten / Geld–Plastikhülsen',
  10001318: 'Ordner / Hefter / Mappen / Ablagesysteme (Bürobedarf)',
  10001320: 'Behälter für Bürokleinartikel  / Schreibtischzubehör (Bürobedarf)',
  10001321: 'Bürobedarf – Aufbewahrung / Archivierung – sonstige',
  10001322: 'Bürobedarf – Aufbewahrung / Archivierung – Ersatzteile / Zubehör',
  10001323: 'Bürobedarf – Aufbewahrung / Archivierung – Sets',
  10001325: 'Schreibwaren / Bürobedarf / Büromaschinen – Sets',
  10001326: 'Gürtel / Hosenträger / Kummerbunde',
  10001327: 'Taschentücher (Stoff)',
  10001328: 'Handschuhe',
  10001329: 'Kopfbedeckungen',
  10001330: 'Halsbekleidung',
  10001331: 'Bekleidungsschmuck / Anstecker / Abzeichen / Schnallen',
  10001332: 'Overalls / Einteiler / Bodysuits',
  10001333: 'Kleider',
  10001334: 'Röcke',
  10001335: 'Hosen (lang / kurz)',
  10001338: 'Bademäntel / Morgenmäntel',
  10001339: 'Nachthemden / Schlafanzugoberteile',
  10001340: 'Schlafmützen / Schlafmasken',
  10001341: 'Schlafanzughosen (kurz / lang)',
  10001342: 'Sportbekleidung – Ganzkörperbekleidung',
  10001343: 'Sportbekleidung – Beinbekleidung',
  10001344: 'Sportbekleidung – Oberkörperbekleidung',
  10001345: 'Büstenhalter / Mieder / Korsetts',
  10001346: 'Ganzkörper–Unterwäsche',
  10001347: 'Unterhosen / Slips / Boxershorts',
  10001348: 'Socken / Strümpfe',
  10001349: 'Unterhemden / Unterkleider',
  10001350: 'Jacken / Blazer / Strickjacken / Westen',
  10001351: 'Pullover / Sweatshirts',
  10001352: 'Hemden / Blusen / Polohemden / T–Shirts',
  10001354: 'Bekleidung – Accessoires / Zubehör– Sets',
  10001355: 'Ganzkörperbekleidung – Sets',
  10001356: 'Beinbekleidung – Sets',
  10001358: 'Nachtwäsche – Sets',
  10001359: 'Sportbekleidung – Sets',
  10001360: 'Unterwäsche / Strumpfwaren –  Sets',
  10001361: 'Oberkörperbekleidung – Sets',
  10001362: 'Computer– / PC– / Videospiele – Zubehör – sonstige',
  10001363: 'Computer / PC– / Videospiele – Zubehör – Sets',
  10001364:
    'Computer– / PC– / Videospiele – Steuer– / Eingabegeräte – sonstige',
  10001365: 'Computer / PC– / Videospiele – Steuer– / Eingabegeräte – Sets',
  10001366: 'Computer– / PC– / Videospiele – Peripheriegeräte – sonstige',
  10001367: 'Computer / PC– / Videospiele – Peripheriegeräte – Sets',
  10001370: 'Computer / PC– / Videospiele – Sets',
  10001375: 'Musikinstrumente – sonstige (akustisch / mechanisch)',
  10001377: 'Musikinstrumente – sonstige (elektrisch / elektronisch)',
  10001379: 'Kommunikationsgeräte – Zubehör – sonstige',
  10001380: 'Kommunikationsgeräte – Zubehör – Sets',
  10001382: 'Kommunikationsgeräte / Dienstleistungen – Sets',
  10001383: 'Kommunikationsgeräte – festnetz–/ kabelgebunden – sonstige',
  10001384: 'Kommunikationsgeräte – Festnetz / kabelgebunden – Sets',
  10001385:
    'Kommunikationsgeräte / Dienstleistungen  – Mobilfunk / drahtlos – sonstige',
  10001386:
    'Kommunikationsgeräte / Dienstleistungen  – Mobilfunk / drahtlos – Sets',
  10001387: 'Schmuck – sonstige',
  10001388: 'Schmuck – Sets',
  10001389: 'Persönliche Accessoires – Sets',
  10001390: 'Taschen / Gepäck / Schirme – sonstige',
  10001391: 'Taschen / Gepäck / Schirme – Sets',
  10001392: 'Armbanduhren / Taschenuhren – sonstige',
  10001394: 'Schutzkleidung – Ganzkörperbekleidung',
  10001395: 'Schutzhandschuhe',
  10001397: 'Schutzkleidung – Beinbekleidung',
  10001398: 'Schutzkleidung – Oberkörperbekleidung',
  10001400: 'Fernseher',
  10001401: 'Fernseh–Video–Kombinationen',
  10001402: 'Fernseher (tragbar)',
  10001403: 'Fernseher – Sets',
  10001404: 'Fernseher – Ersatzteile / Zubehör',
  10001405: 'Fernseher – sonstige',
  10001406: 'Camcorder / Videokameras',
  10001407: 'DVD-/BluRay-Player / Rekorder',
  10001408: 'Video–Kombinationsgeräte',
  10001409: 'Set–Top–Boxen / Satellitenempfänger',
  10001410: 'Video–Festplattenrekorder',
  10001411: 'Antennen',
  10001412: 'Videorekorder / Videoplayer',
  10001413: 'Video–Aufnahmegeräte / Wiedergabegeräte – Sets',
  10001414: 'Video–Aufnahmegeräte / Wiedergabegeräte – Ersatzteile / Zubehör',
  10001416: 'CD–Player (tragbar)',
  10001417: 'Mini–Disc–Player (tragbar)',
  10001418: 'MP3–Player (tragbar)',
  10001419: 'Audio–Kassettenspieler (tragbar)',
  10001420: 'DVD–Player (tragbar)',
  10001421: 'Digitale Video–Player (tragbar)',
  10001422: 'Radios (tragbar)',
  10001423: 'Radio–Rekorder (tragbar)',
  10001424: 'Radiowecker / Uhrenradios',
  10001425: 'Diktiergeräte',
  10001426: 'Audio / Video – Geräte (tragbar) – Sets',
  10001427: 'Audio / Video – Geräte (tragbar) – Ersatzteile / Zubehör',
  10001428: 'Audio / Video – Geräte (tragbar) – sonstige',
  10001429: 'Verstärker / Vorverstärker',
  10001430: 'Stereoanlagen / Kompaktanlagen',
  10001431: 'Heimkinosysteme',
  10001432: 'Kassettendecks',
  10001433: 'CD–Player / CD–Rekorder',
  10001434: 'Mini–Disc–Geräte (Heim–Audio)',
  10001435: 'Lautsprecher / Boxen',
  10001436: 'Lautsprechersysteme / Surround–Systeme',
  10001437: 'Receiver / Tuner / Radios',
  10001439: 'Plattenspieler',
  10001440: 'Jukeboxen / Musikboxen',
  10001441: 'Karaokemaschinen',
  10001442: 'Audio– / Videomischpulte',
  10001443: 'Audio–Effektgeräte',
  10001444: 'CD–Turntables',
  10001446: 'Heim–Audio – Geräte – Sets',
  10001447: 'Heim–Audio – Geräte – Ersatzteile / Zubehör',
  10001448: 'Heim–Audio – Geräte – sonstige',
  10001449: 'Audiokassetten (unbespielt)',
  10001450: 'CDs / MDs (unbespielt)',
  10001451: 'DVDs (unbespielt)',
  10001452: 'Speicherkarten / Memorysticks',
  10001455: 'Videokassetten (unbespielt)',
  10001456: 'Disketten',
  10001457: 'Beschreibbare Medien – Sets',
  10001458: 'Beschreibbare Medien – sonstige',
  10001459: 'CDs/MDs (bespielt)',
  10001460: 'DVDs (bespielt)',
  10001462: 'Schallplatten – bespielt',
  10001463: 'Bespielte Videokassetten',
  10001464: 'Audiokassetten (bespielt)',
  10001465: 'Bespielte Medien – Sets',
  10001466: 'Bespielte Medien – sonstige',
  10001467: 'Kopfhörer',
  10001468: 'Signalverstärker',
  10001469: 'TV–Funkübertragungs–Systeme',
  10001470: 'Universal–Fernbedienungen',
  10001472: 'Audio– / Video–Switch–Boxen',
  10001475: 'Video–Kassettenadapter',
  10001476: 'Mikrofone',
  10001477: 'Audio / Video – Zubehör – Ständer / Konsolen / Halter',
  10001478: 'Audio / Video – Zubehör – Taschen / Boxen / Hüllen / Etuis',
  10001479: 'Geräte für Internet via Fernseher',
  10001480: 'Audio / Video – Zubehör – Reinigungsprodukte',
  10001482: 'Audio / Video – Zubehör – Sets',
  10001483: 'Audio / Video – Zubehör – Ersatzteile',
  10001484: 'Audio / Video – Zubehör – sonstige',
  10001485: 'Audio– / Video–Geräte / Zubehör – Sets',
  10001486: 'Analoge Fotokameras',
  10001487: 'Digitalkameras',
  10001489: 'Blitzgeräte',
  10001490: 'Fotokamera–Filme',
  10001491: 'Wechselobjektive',
  10001492: 'Diaprojektoren',
  10001493: 'Dias',
  10001494: 'Fotografie – Ersatzteile / Zubehör',
  10001495: 'Fotoalben / Fotowürfel',
  10001496: 'Fotografie – Sets',
  10001498: 'Fotografie – sonstige',
  10001499: 'Ferngläser',
  10001501: 'Fernrohre / Teleskope',
  10001502: 'Mikroskope',
  10001504: 'Optik – Sets',
  10001505: 'Optik – Ersatzteile / Zubehör',
  10001506: 'Optik – sonstige',
  10001507: 'Fotochemikalien',
  10001508: 'Foto–Vergrößerungsgeräte',
  10001510: 'Fotopapier',
  10001511: 'Foto–Trocknungszubehör',
  10001512: 'Dunkelkammerbeleuchtung / Rotlichtleuchten',
  10001513: 'Fotoschalen / Wascher / Entwicklungstanks / –Spiralen',
  10001514: 'Fotolabor–Geräte / –Zubehör – Sets',
  10001515: 'Fotolabor–Geräte / –Zubehör – Ersatzteile / Zubehör',
  10001516: 'Fotolabor–Geräte / –Zubehör – sonstige',
  10001517: 'Kfz–Navigationssysteme',
  10001518: 'Kfz–Monitore',
  10001519: 'Kfz–DVD–Player',
  10001520: 'Kfz–Videoplayer',
  10001521: 'Kfz–Fernseher / –Videoempfangsgeräte',
  10001522: 'Kfz–Video / –Navigation – Sets',
  10001523: 'Kfz–Video / –Navigation – Ersatzteile / Zubehör',
  10001524: 'Kfz–Video / –Navigation – sonstige',
  10001525: 'Kfz–Audio – Headunits (Steuerungseinheiten)',
  10001526: 'Kfz–Audio – Autoradios',
  10001527: 'Kfz–Audio – CD–Spieler / –Wechsler',
  10001528: 'Kfz–Audio – MD–Spieler / –Wechsler',
  10001529: 'Kfz–Audio – Lautsprecher',
  10001530: 'Kfz–Audio – Verstärker',
  10001531: 'Kfz–Audio – Antennen',
  10001532: 'Kfz–Audio – Sets',
  10001533: 'Kfz–Audio – Ersatzteile / Zubehör',
  10001534: 'Kfz–Audio – sonstige',
  10001674: 'Pinsel / Malspachtel / Farbapplikatoren (Künstlerbedarf)',
  10001676: 'Farben (Künstlerbedarf)',
  10001677: 'Pastellkreiden / Wachsmalstifte / Zeichenkohle / Buntstifte',
  10001678: 'Grundierungen / Oberflächenbehandlungsmittel',
  10001679: 'Leinwände / grundierte Holzplatten',
  10001680: 'Farbpaletten (Künstlerbedarf)',
  10001681: 'Staffeleien',
  10001682: 'Künstlerbedarf – Zubehör',
  10001683: 'Sandkunst–Bedarf',
  10001684: 'Mal– / Zeichenbedarf – Sets',
  10001685: 'Mal– / Zeichenbedarf – sonstige',
  10001686: 'Airbrushpistolen (elektrisch)',
  10001688: 'Airbrush–Geräte – Ersatzteile / Zubehör',
  10001689: 'Airbrushbedarf – Sets',
  10001690: 'Airbrushbedarf – sonstige',
  10001691: 'Bildhauer– / Töpfermaterialien',
  10001692: 'Bildhauerwerkzeuge (nicht elektrisch / pneumatisch)',
  10001693: 'Bildhauerwerkzeuge (elektrisch / pneumatisch)',
  10001694: 'Brennöfen',
  10001695: 'Töpferscheiben (elektrisch)',
  10001696: 'Töpferscheiben (nicht elektrisch)',
  10001697: 'Bildhauer– / Töpferbedarf – Sets',
  10001698: 'Bildhauer– / Töpferbedarf – sonstige',
  10001699: 'Handarbeitsbedarf – Stoffe / Textilien',
  10001700: 'Schnüre / Schleifen / Kordeln / Bänder',
  10001701: 'Fäden / Garne',
  10001702: 'Handarbeitswerkzeuge – maschinell / manuell',
  10001705: 'Handarbeitsbedarf – Markierungsmittel',
  10001706: 'Nähmaschinen / Strickmaschinen (nicht elektrisch)',
  10001707: 'Nähmaschinen / Strickmaschinen (elektrisch)',
  10001710: 'Handarbeitsbedarf – Verschlüsse',
  10001711: 'Puppenbedarf – Zubehör',
  10001712: 'Handarbeitsbedarf – Aufbewahrungsboxen / –Kästchen',
  10001713: 'Handarbeitsschablonen / –Vorlagen',
  10001714: 'Handarbeitsbedarf – Zubehör',
  10001715: 'Handarbeitsbedarf / Puppenbedarf – Sets',
  10001716: 'Handarbeitsbedarf / Puppenbedarf – sonstige',
  10001717: 'Schmuckbedarf – Materialien',
  10001718: 'Schmuckbedarf – Zubehör',
  10001719: 'Schmuckbedarf – Sets',
  10001720: 'Schmuckbedarf – sonstige',
  10001721: 'Korbflechterei–Bedarf – Materialien',
  10001722: 'Korbflechterei–Werkzeuge (nicht elektrisch)',
  10001723: 'Korbflechterei–Bedarf – Zubehör',
  10001724: 'Korbflechterei–Bedarf – Sets',
  10001725: 'Korbflechterei–Bedarf – sonstige',
  10001726: 'Papierbastel–Werkzeuge (nicht elektrisch)',
  10001727: 'Papier– / Karten–Bastelbedarf – Zubehör',
  10001729: 'Papier– / Karten–Bastelbedarf – Sets',
  10001730: 'Papier– / Karten–Bastelbedarf – sonstige',
  10001731: 'Glas– / Emaillier– / Einlegearbeiten – Bastelmaterialien',
  10001732: 'Glaskunst / –Bläserei – Werkzeuge (elektrische) / Brenner',
  10001734: 'Glas– / Emaillier– / Einlegearbeiten–Bastelbedarf – Sets',
  10001735: 'Glas– / Emaillier– / Einlegearbeiten–Bastelbedarf – sonstige',
  10001736: 'Kerzen– / Seifenherstellungs–Bastelmaterialien',
  10001737: 'Kerzen– / Seifenherstellungs–Gussformen',
  10001738: 'Kerzen– / Seifenwerkzeuge (nicht elektrisch)',
  10001739: 'Kerzen– / Seifenwerkzeuge (elektrisch)',
  10001740: 'Kerzen– / Seifen–Bastelbedarf – Sets',
  10001741: 'Kerzen– / Seifen–Bastelbedarf – sonstige',
  10001742: 'Brandmalerei– / Gravierwerkzeuge (elektrisch)',
  10001743: 'Brandmalerei– / Gravierwerkzeuge (nicht elektrisch)',
  10001744: 'Brandmalerei– / Gravier–Bedarf – Ersatzteile / Zubehör',
  10001746: 'Brandmalerei– / Gravier–Bedarf – sonstige',
  10001748: 'Druckerbedarf – Werkzeuge',
  10001749: 'Druckpressen (elektrisch)',
  10001750: 'Druckpressen (nicht elektrisch)',
  10001752: 'Drucker–Bedarf – Sets',
  10001753: 'Drucker–Bedarf – sonstige',
  10001754: 'Spinn– / Webmaschinen (elektrisch)',
  10001755: 'Spinngeräte / Webstühle (nicht elektrisch)',
  10001756: 'Spinn– / Webfasern / –Garne',
  10001757: 'Spinn– / Webbedarf – Ersatzteile / Zubehör',
  10001758: 'Spinn– / Webbedarf – sonstige',
  10001759: 'Spinn– / Webbedarf – Sets',
  10001760: 'Künstler– / Kunsthandwerks– / Bastel– / Handarbeitsbedarf – Sets',
  10001761: 'Müllbeutel / –säcke',
  10001762: 'Wurfsportartikel',
  10001763: 'Laufsportartikel',
  10001764: 'Springsportartikel',
  10001766: 'Leichtathletik–Artikel –  Sets',
  10001767: 'Leichtathletik–Artikel –  sonstige',
  10001768: 'Sportbälle',
  10001769: 'Pucks',
  10001770: 'Federbälle',
  10001771: 'Frisbees',
  10001772: 'Bumerangs',
  10001774: 'Sportbälle / Pucks / Federbälle / Frisbees / Bumerangs – Sets',
  10001775: 'Sportbälle / Pucks / Federbälle / Frisbees / Bumerangs – sonstige',
  10001776: 'Schläger für Racketsportarten',
  10001778: 'Racketsportartikel – Ersatzteile / Zubehör',
  10001779: 'Racketsportartikel – Sets',
  10001780: 'Schläger / Stöcke',
  10001787: 'Schläger / Stöcke – sonstige',
  10001790: 'Schlitten',
  10001792: 'Ski / Skiboards / Snowboards',
  10001794: 'Curlingsteine',
  10001795: 'Wintersportausrüstung – Ersatzteile / Zubehör',
  10001796: 'Wintersportausrüstung – Sets',
  10001797: 'Wintersportausrüstung – sonstige',
  10001798: 'Trekking– / Bergsteigerausrüstung',
  10001805: 'Trekking– / Bergsteigerausrüstung – sonstige',
  10001806: 'Schlagsport– / Tritt–Trainingshilfen',
  10001807: 'Kampfkunstausrüstung',
  10001809: 'Kampfsportausrüstung – Sets',
  10001810: 'Räder (nicht angetrieben)',
  10001811: 'Räder – Ersatzteile',
  10001812: 'Radsportausrüstung – Sets',
  10001813: 'Radsportausrüstung – sonstige',
  10001814: 'Heimtrainer (elektrisch)',
  10001815: 'Heimtrainer (nicht elektrisch)',
  10001816: 'Freihanteln / Hanteln',
  10001819: 'Fitnessaccessoires',
  10001822: 'Fitnesskontrollgeräte / Pulsmesser',
  10001823: 'Fitnessausrüstung – Ersatzteile / Zubehör',
  10001824: 'Fitnessausrüstung – Sets',
  10001825: 'Fitnessausrüstung – sonstige',
  10001826: 'Rhythmische Sportgymnastik – Ausrüstung',
  10001827: 'Turn– und Gymnastikgeräte',
  10001829: 'Gymnastikausrüstung – Sets',
  10001830: 'Gymnastikausrüstung – sonstige',
  10001831: 'Drachen / Kites',
  10001832: 'Fallschirme',
  10001834: 'Kiting / Fallschirmspringen – Boards / Buggys (nicht angetrieben)',
  10001835: 'Kiting– / Fallschirmsprung–Ausrüstung – Zubehör',
  10001837: 'Kiting– / Fallschirmsprung–Ausrüstung – Sets',
  10001838: 'Kiting – / Fallschirmsprung–Ausrüstung – sonstige',
  10001840: 'Skateboards (nicht angetrieben)',
  10001841: 'Skateboardausrüstung – Ersatzteile / Zubehör',
  10001842: 'Roller– / Skateboardausrüstung – Sets',
  10001843: 'Roller– / Skateboardausrüstung – sonstige',
  10001844: 'Wasserski / Wakeboards',
  10001845: 'Wasserski / Wakeboards – Ersatzteile / Zubehör',
  10001847: 'Schwimm–Trainingshilfen',
  10001848: 'Tauchausrüstung',
  10001852: 'Schwimm– / Surf– / Tauchausrüstung – Ersatzteile / Zubehör',
  10001853: 'Schwimm– / Surf– / Tauchausrüstung – Sets',
  10001854: 'Schwimm– / Surf– / Tauchausrüstung – sonstige',
  10001855: 'Sporttische',
  10001859: 'Sporttische – sonstige',
  10001860: 'Darts',
  10001862: 'Bogen',
  10001863: 'Pfeile',
  10001865: 'Zielscheiben (elektrisch)',
  10001866: 'Zielscheiben (nicht elektrisch)',
  10001867: 'Bogensportausrüstung – Ersatzteile / Zubehör',
  10001868: 'Bogensportausrüstung – Sets',
  10001869: 'Bogensport–Ausrüstung – sonstige',
  10001870: 'Handfeuerwaffen / Pistolen',
  10001871: 'Gewehre',
  10001872: 'Schrotflinten',
  10001873: 'Luftgewehre',
  10001874: 'Schusswaffenmunition',
  10001877: 'Schießsportwaffen – Ersatzteile / Zubehör',
  10001878: 'Schießsport–Ausrüstung – Sets',
  10001879: 'Schießsport–Ausrüstung  – sonstige',
  10001880: 'Köder / Lockmittel / Lockpfeifen',
  10001883: 'Zerwirk–Ausrüstung',
  10001885: 'Jagdsportzubehör – Sets',
  10001886: 'Jagdsportzubehör – sonstige',
  10001887: 'Wasserfahrzeuge',
  10001889: 'Wasserfahrzeuge – Ersatzteile / Zubehör',
  10001890: 'Wassersportgeräte (ohne Antrieb) und Ausrüstung – Sets',
  10001891: 'Wassersportgeräte (ohne Antrieb) und Ausrüstung – sonstige',
  10001892: 'Sportartikel – Taschen / Behälter / Abdeckungen',
  10001893: 'Sporttore / Netze',
  10001894: 'Sporttore / Netze – Zubehör',
  10001896: 'Sportmarkierungsausrüstung',
  10001897: 'Kegel / Cricket Stumps',
  10001898: 'Sportartikel – Regale / Halter',
  10001899: 'Sportauswertungsausrüstung (nicht elektrisch)',
  10001900: 'Sportmatten',
  10001902: 'Sportartikel – Zubehör  – Sets',
  10001903: 'Sportartikel – Zubehör  – sonstige',
  10001904: 'Sportmundschutz',
  10001905: 'Sportschutzbrillen / Augenmasken',
  10001907: 'Sportschutzausrüstung  – Polster / Schutzvorrichtungen',
  10001909: 'Fitnessgürtel',
  10001911: 'Sportschutzausrüstung  – Sets',
  10001912: 'Sportschutzausrüstung  – sonstige',
  10001913: 'Angelruten',
  10001914: 'Angelrollen',
  10001915: 'Angelköder / Fliegen',
  10001916: 'Angelhaken',
  10001917: 'Schwimmer / Posen',
  10001918: 'Netze / Kescher',
  10001920: 'Angelschnüre',
  10001921: 'Angelruten  – Zubehör',
  10001922: 'Angelausrüstung – Sets',
  10001923: 'Angelausrüstung – sonstige',
  10001928: 'Müllverdichter / Müllpressen',
  10001929: 'Küchenabfall–Zerkleinerer',
  10001930: 'Abfallentsorgung / Abfallverdichtung – sonstige',
  10001931: 'Abfallentsorgung / Abfallverdichtung – Ersatzteile / Zubehör',
  10001938: 'Eiswürfelmaschinen',
  10001939: 'Weinkühlschränke',
  10001940: 'Kühl– / Warmhalte–Kombinationen',
  10001941: 'Kühlgeräte / Gefriergeräte – sonstige',
  10001942: 'Kühlgeräte / Gefriergeräte – Ersatzteile / Zubehör',
  10001950: 'Backöfen',
  10001951: 'Kochfelder',
  10001952: 'Mikrowellengeräte',
  10001953: 'Kochgeräte – sonstige',
  10001954: 'Kochgeräte – Ersatzteile / Zubehör',
  10001955: 'Wärmeschubladen',
  10001956: 'Servierwagen / Bankettwagen (beheizt)',
  10001957: 'Warmhaltegräte – sonstige',
  10001958: 'Warmhaltegräte – Ersatzteile / Zubehör',
  10001959: 'Waschmaschinen',
  10001961: 'Waschtrockner',
  10001962: 'Waschmaschinen / Wäschetrockner – sonstige',
  10001963: 'Waschmaschinen / Wäschetrockner – Ersatzteile / Zubehör',
  10001964: 'Spülmaschinen',
  10001965: 'Geschirr–Reinigungsgeräte – sonstige',
  10001966: 'Geschirr–Reinigungsgeräte – Ersatzteile / Zubehör',
  10001967: 'Toaster',
  10001968: 'Mini–Backöfen',
  10001969: 'Elektrogrills',
  10001970: 'Sandwichtoaster / Waffeleisen',
  10001971: 'Pfannkuchen– / Donutgeräte',
  10001972: 'Racletteöfen (elektrisch)',
  10001974: 'Grills / Rotisserieöfen ( elektrisch)',
  10001975: 'Slow Cooker / Hot Pots / Kokotten',
  10001976: 'Schnellkochtöpfe (elektrisch)',
  10001977: 'Reiskocher',
  10001978: 'Multi–Kocher (elektrisch)',
  10001979: 'Pastakocher (elektrisch)',
  10001980: 'Eierkocher',
  10001981: 'Fritteusen',
  10001982: 'Woks (elektrisch)',
  10001983: 'Brotbackmaschinen',
  10001984: 'Popcornmaschinen',
  10001985: 'Pizzageräte',
  10001986: 'Fonduegeräte (elektrisch)',
  10001987: 'Tajinen (elektrisch)',
  10001988: 'Mexican Diners (elektrisch)',
  10001989: 'Paellapfannen (elektrisch)',
  10001990: 'Heißer–Stein–Grills (elektrisch)',
  10001991: 'Kochgeräte – Sets (elektrisch)',
  10001998: 'Messer (elektrisch)',
  10002000: 'Dosenöffner (elektrisch)',
  10002002: 'Messerschärfer (elektrisch)',
  10002003: 'Vakuumgeräte (elektrisch)',
  10002004: 'Fleischwölfe (elektrisch)',
  10002005: 'Reiben (elektrisch)',
  10002006: 'Kaffeemühlen (elektrisch)',
  10002007: 'Entsafter (elektrisch)',
  10002011: 'Heißgetränkemaschinen',
  10002012: 'Wasserkocher (elektrisch)',
  10002013: 'Eismaschinen (elektrisch)',
  10002014: 'Joghurtmaschinen',
  10002015: 'Buttermaschinen (elektrisch)',
  10002016: 'Wassersprudler',
  10002018: 'Dörrautomaten (elektrisch)',
  10002019: 'Zuckerwattemaschinen',
  10002020: 'Geräte zur Essens– / Getränkezubereitung – sonstige',
  10002021: 'Geräte zur Essens– / Getränkezubereitung – Ersatzteile / Zubehör',
  10002022: 'Geräte zur Essens– / Getränkezubereitung – Sets',
  10002023: 'Bügeleisen / Dampfbügler (elektrisch)',
  10002024: 'Bügelbretter (elektrisch)',
  10002025: 'Bügelpressen',
  10002026: 'Wäschepflegegeräte – sonstige',
  10002027: 'Wäschepflegegeräte – Ersatzteile / Zubehör',
  10002028: 'Staubsauger',
  10002029: 'Bürstkehrer / Teppichkehrer (elektrisch)',
  10002030: 'Bohnermaschinen / Teppichreiniger',
  10002031: 'Dampfreiniger',
  10002032: 'Reinigungsgeräte – sonstige',
  10002033: 'Reinigungsgeräte – Ersatzteile / Zubehör',
  10002034: 'Koch– / Wärmekleingeräte – sonstige',
  10002035: 'Koch– / Wärmekleingeräte – Ersatzteile / Zubehör (elektrisch)',
  10002069: 'Zelte',
  10002070: 'Wetterschutz– / Zelterweiterungen',
  10002071: 'Zeltpflegemittel / Reparatursets',
  10002072: 'Zelte – Zubehör',
  10002073: 'Zelte / Wetterschutz – sonstige',
  10002074: 'Zelte / Wetterschutz – Sets',
  10002075: 'Zeltheizungen',
  10002076: 'Campinglaternen',
  10002077: 'Campingausrüstung – Heizung / Beleuchtung – sonstige',
  10002078: 'Campingausrüstung – Heizung / Beleuchtung – Sets',
  10002079: 'Campingbetten / Isomatten',
  10002080: 'Schlafsäcke',
  10002081: 'Camping–Sitzmöbel',
  10002083: 'Camping–Aufbewahrungsmöglichkeiten / Zeltmöbel',
  10002084: 'Campingtische',
  10002085: 'Campingmöbel – sonstige',
  10002086: 'Campingmöbel – Sets',
  10002087: 'Campingkocher / Grills / Campingöfen',
  10002088: 'Campingausrüstung – Wasseraufbewahrung / Wasserfilter',
  10002091: 'Kühltaschen / –Boxen',
  10002092: 'Camping–Kochgeschirr',
  10002093:
    'Campingausrüstung – Kochen / Essen / Trinken – Ersatzteile / Zubehör',
  10002094: 'Campingausrüstung – Kochen / Essen / Trinken – sonstige',
  10002095: 'Campingausrüstung – Kochen / Essen / Trinken – Sets',
  10002096: 'Campingtoiletten (nicht elektrisch)',
  10002097: 'Campingduschen',
  10002098:
    'Campingausrüstung – Körperhygiene / Sanitär – Ersatzteile / Zubehör',
  10002099: 'Campingausrüstung – Körperhygiene / Sanitär – sonstige',
  10002100: 'Campingausrüstung – Körperhygiene / Sanitär – Sets',
  10002101: 'Camping – Sets',
  10002102: 'Bekleidung – Sets',
  10002103: 'Druckmedien / Textmedien – Sets',
  10002117: 'Schubladen / Schubladenschränke',
  10002118: 'Garderoben / Garderobenschränke',
  10002121: 'Küche – Aufbewahrung – Regale / Halter / Spender',
  10002122: 'Lebensmittel– / Getränkebehälter',
  10002123: 'Haushalt / Küche – Aufbewahrung – Sets',
  10002124: 'Haushalt / Küche – Aufbewahrung – sonstige',
  10002125: 'Abfalleimer',
  10002127: 'Wasserfilter / Wasserfilter–Kartuschen',
  10002128: 'Getränke–Dekorationszubehör (nicht essbar)',
  10002129: 'Kessel (nicht elektrisch)',
  10002130: 'Flaschenverschlüsse / Ausgießer',
  10002131: 'Teekannen / Cafetieren / Kannen für heiße Getränke',
  10002133: 'Mühlen / Entsafter / Eis–Crusher (nicht elektrisch)',
  10002134: 'Getränke – Zubereitung  / Behälter – Sets',
  10002135: 'Getränke – Zubereitung  / Behälter – sonstige',
  10002136: 'Kurzzeitwecker / Eieruhren (nicht elektrisch)',
  10002139: 'Messbecher / –Löffel',
  10002140: 'Küchenthermometer / Bratenthermometer',
  10002141: 'Küchen–Messgeräte – Sets',
  10002142: 'Küchen–Messgeräte – sonstige',
  10002143: 'Küchenwaagen (nicht elektrisch)',
  10002144: 'Töpfe für Bratgeschirr / Pfannen / Woks / Kokotten',
  10002146: 'Seiher / Siebe',
  10002147: 'Schneide– / Hackbretter',
  10002148:
    'Fleischwölfe / Kartoffelpressen / Nudelmaschinen (nicht elektrisch)',
  10002149: 'Kuchen– / Gebäck–Dekoration / –Zubehör (nicht essbar)',
  10002150: 'Backformen / feuerfeste Formen / Grillzubehör (mehrweg)',
  10002151: 'Kochgeschirr / Backformen – Sets',
  10002152: 'Kochgeschirr / Backformen – sonstige',
  10002153: 'Teller (mehrweg)',
  10002154: 'Schüsseln (mehrweg)',
  10002155: 'Becher / Tassen (mehrweg)',
  10002158: 'Servierkannen / –krüge / Karaffen',
  10002159: 'Serviertabletts',
  10002160: 'Servierwagen (nicht elektrisch)',
  10002161: 'Speisen– / Getränkewärmer (nicht elektrisch)',
  10002162: 'Eiskübel / Weinkühler (nicht elektrisch)',
  10002163: 'Salz– / Pfeffer– / Gewürzmühlen (nicht elektrisch)',
  10002165: 'Essensstände / –Auslagen',
  10002168: 'Küchenmesser / Hackbeile',
  10002169: 'Entkerner / Schäler',
  10002170: 'Pfannenwender / Kellen / Schöpflöffel',
  10002171: 'Zangen / Pinzetten / Klopfer / Stampfer / Schneebesen',
  10002172: 'Schneidemaschinen / Reiben / Ausstechformen',
  10002173: 'Nudelhölzer',
  10002174: 'Bratspieße / Spieße',
  10002175: 'Flaschen– / Dosenöffner / Nussknacker / sonstige Öffner',
  10002176: 'Multifunktions–Küchengeräte',
  10002177: 'Essenszubereitung  – Geräte / Hilfsmittel – Sets',
  10002178: 'Essenszubereitung  – Geräte / Hilfsmittel – sonstige',
  10002183: 'Tafel– / Küchengeräte – Sets',
  10002184: 'Regale / Regalsysteme',
  10002185: 'Aktenschränke / Büroschränke',
  10002186: 'TV– & Phonomöbel',
  10002187: 'Kisten / Körbe / Truhen',
  10002188: 'Ablageleisten / –Halterungen',
  10002189: 'Platzspar– / Ordnungssysteme',
  10002190: 'Raumteiler / Paravents / Bürotrennwände',
  10002191: 'Aufbewahrungs– / Ergänzungsmöbel / Raumteiler – Sets',
  10002192: 'Stühle / Hocker / Bürositzmöbel (elektrisch)',
  10002193: 'Stühle / Hocker / Bürositzmöbel (nicht elektrisch)',
  10002194: 'Sofas (elektrisch)',
  10002195: 'Sofas (nicht elektrisch)',
  10002196: 'Funktionssofas / Sofabetten',
  10002197: 'Sitzsäcke / Puffs / Ottomanen',
  10002198: 'Aufblasbare Sitzmöbel',
  10002199: 'Fußstützen',
  10002200: 'Sitzmöbel / Polstermöbel – Sets',
  10002201: 'Sitzmöbel / Polstermöbel – sonstige',
  10002202: 'Tische',
  10002203: 'Schreibtische / Computertische',
  10002205: 'Tische / Schreibtische – sonstige',
  10002206: 'Tische / Schreibtische – Sets',
  10002207: 'Bettkästen / Bettgestelle',
  10002208: 'Betten (elektrisch verstellbar)',
  10002209: 'Betten (manuell verstellbar)',
  10002210: 'Matratzen',
  10002211: 'Aufblasbare Betten / Wasserbetten',
  10002212: 'Betten / Matratzen – sonstige',
  10002213: 'Betten / Matratzen – Sets',
  10002214: 'Vorhänge',
  10002215: 'Rollvorhänge / Innenrollos (textil)',
  10002216: 'Möbelüberwürfe / Tischdecken',
  10002217: 'Kissen',
  10002218: 'Teppiche / Läufer /  Matten (ohne Teppichboden)',
  10002219: 'Handtücher / Hauswäsche',
  10002220: 'Heimtextilien – textile Wohn– / Büroeinrichtung – Sets',
  10002221: 'Heimtextilien – textile Wohn– / Büroeinrichtung – sonstige',
  10002222: 'Daunendecken / Steppdecken / Matratzenauflagen',
  10002223: 'Bettbezüge',
  10002224: 'Decken / Überwürfe (nicht beheizt)',
  10002225: 'Kopfkissen',
  10002226: 'Kopfkissenbezüge',
  10002227: 'Bettlaken / Bettvolants',
  10002228: 'Matratzen– / Kopfkissen– / Bettdecken – Schutzbezüge',
  10002229: 'Bettwaren – Sets',
  10002230: 'Bettwaren – sonstige',
  10002231: 'Dekorationsgegenstände',
  10002232: 'Künstliche Blumen / Pflanzen / Bäume',
  10002233: 'Vasen',
  10002234: 'Dekorative Magnete / Aufkleber / Fensteraufkleber',
  10002235: 'Mobiles / Traumfänger / Windspiele',
  10002236: 'Saisondekorationen (nicht elektrisch)',
  10002237: 'Saisondekorationen (elektrisch)',
  10002238: 'Dekorationsgegenstände – Sets',
  10002240: 'Gemälde / Zeichnungen',
  10002241: 'Poster / Kunstdrucke',
  10002243: 'Fotografien',
  10002245: 'Spiegel',
  10002246: 'Bilderrahmen',
  10002247: 'Bilder / Spiegel / Bilderrahmen – Sets',
  10002248: 'Bilder / Spiegel / Bilderrahmen – sonstige',
  10002249: 'Kerzenhalter / Zubehör',
  10002252: 'Uhren',
  10002423: 'Mund– / Rachenmittel',
  10002424: 'Unterröcke / Petticoats / Unterkleider',
  10002425: 'Strumpfhosen / Nylonstrümpfe',
  10002426: 'Strumpfhalter / Strumpfbänder',
  10002429: 'Wandverkleidung – Rollen (Tapeten / Wandbekleidungen)',
  10002431: 'Wandverkleidung – Kacheln / Fliesen',
  10002432: 'Wand– / Decken–Verkleidung – Zubehör',
  10002433: 'Wandverkleidung – Tafeln / Platten',
  10002441: 'Wand– / Decken–Verkleidung – sonstige',
  10002442: 'Wand– / Decken–Verkleidung – Sets',
  10002443: 'Bodenbeläge – Keramik– / Porzellan–Fliesen',
  10002444: 'Bodenbeläge – Zubehör',
  10002446: 'Teppiche / Teppichböden',
  10002447: 'Bodenbeläge – Massivdielen / Massivparkett',
  10002448: 'Bodenbeläge – Kunststoff / Gummi / Linoleum',
  10002449: 'Kork– / Bambus–Bodenbeläge',
  10002450: 'Bodenbeläge – Stein / Marmor',
  10002451: 'Laminatbodenbeläge',
  10002452: 'Bodenbeläge – sonstige',
  10002453: 'Bodenbeläge – Sets',
  10002454: 'Dämmplatten / –Rollen / –Decken',
  10002455: 'Hartschaum–Dämmplatten (innen)',
  10002456: 'Loses Dämmmaterial / Dämm–Sprühschaum',
  10002460: 'Isolierung / Dämmstoffe – sonstige',
  10002461: 'Isolierung / Dämmstoffe – Sets',
  10002462: 'Spezialfarben',
  10002466: 'Holzanstriche / –Beschichtungen',
  10002481: 'Mal– / Streichwerkzeuge – Ersatzteile',
  10002490: 'Abdeckfolien / Abdeckvliese',
  10002501: 'Farb– / Lack–Entferner / Reinigungsmittel',
  10002504: 'Malerbedarf – Sets',
  10002505: 'Malerbedarf – sonstige',
  10002506: 'Baustoffe / Bauelemente / Baubedarf – Sets',
  10002507: 'Fertigtreppen',
  10002512: 'Treppenantritt– / Treppenaustrittpfosten',
  10002515: 'Dachboden– / Mezzanintreppen',
  10002518: 'Steine – Pflastersteine',
  10002521: 'Betonzuschlagstoffe (Schotter / Kies)',
  10002522: 'Betonmischungen (Trockenmischungen)',
  10002525: 'Bausteine / Ziegel',
  10002526: 'Zement',
  10002527: 'Stuck',
  10002528: 'Putze',
  10002529: 'Kalk (Do–ityourself)',
  10002530: 'Pfeiler / Säulen (tragend)',
  10002532: 'Abstandsscheibe / Abstandshalter',
  10002533: 'Bodentragwerke',
  10002534: 'I–Träger',
  10002535: 'Bauholz (Hartholz)',
  10002536: 'Bauholz (Weichhholz)',
  10002537: 'Holzwerkstoffe / Schichtholz (tragend)',
  10002538: 'Sperrholz– / OSB–Platten und –Produkte',
  10002540: 'Gipskartonplatten / Faserzementplatten',
  10002542: 'Fenstersysteme / Doppelfenster – Massivholz',
  10002543: 'Fensterrahmen',
  10002544: 'Dachfenster – ohne Holzrahmen (Kunststoff– / Aluminiumfenster)',
  10002547: 'Fensterfolie',
  10002548: 'Fensterschlösser / –riegel',
  10002550: 'Fenster–Fliegengitter',
  10002551: 'Markisen (elektrisch)',
  10002552: 'Fenstergriffe',
  10002553: 'Wetterschutz–Zusatzfenster',
  10002554: 'Kellerlichtschächte',
  10002557: 'Gegengewichts–Feder–Systeme für Schiebefenster',
  10002567: 'Innentüren',
  10002568: 'Garagentore / –Türen',
  10002569: 'Terrassentüren',
  10002570: 'Haustüren / Außentüren',
  10002572: 'Türschilder',
  10002573: 'Türgriffe / –Knäufe/ –Hebel',
  10002574: 'Türschließer',
  10002575: 'Türdichtungsmaterial gegen Wettereinflüsse',
  10002577: 'Klappen / Türen für Hunde / Katzen',
  10002578: 'Briefkästen',
  10002579: 'Hausnummern /–Buchstaben',
  10002581: 'Türklopfer',
  10002584: 'Flachglas',
  10002585: 'Bidets',
  10002586: 'Toiletten',
  10002587: 'Urinale',
  10002588: 'Urinal–Sichtschutzwände',
  10002589: 'Toiletten– / Urinale– / Wasserkästen',
  10002590: 'Badewannen– / Duschmodule',
  10002592: 'Waschbecken / Spülbecken',
  10002593: 'Waschbecken – Unterschrank –Kombinationen',
  10002595: 'Badewannen',
  10002596: 'Badewannen – mit Düsen (Hot Tubs / Whirlpools)',
  10002597: 'Fertigduschen',
  10002599: 'Duschwannen',
  10002600: 'Badewannen– / Duschtüren',
  10002601: 'Badewannen– / Dusch–Abtrennnungen',
  10002602: 'Wasserhähne / Armaturen',
  10002608: 'Duschköpfe',
  10002609: 'Waschbecken / Spülbecken – Sockel',
  10002610: 'Badezimmergarnituren',
  10002611: 'Zerkleinerer',
  10002612: 'Sanitärkeramik / Sanitärausstattung – Ersatzteile / Zubehör',
  10002614: 'Sanitärkeramik / Sanitärausstattung – Sets',
  10002623: 'Temperaturalarm für die Dusche',
  10002624: 'Badelifte',
  10002627: 'Badezimmerausstattung – Sets',
  10002646: 'Wassertanks',
  10002648: 'Wasseraufbereitung (Do–it–yourself)',
  10002649: 'Ablagerungsinhibitoren',
  10002650: 'Wasserspeicher / –aufbereitung – Zubehör / Ersatzteile',
  10002652: 'Wasserspeicher / –aufbereitung – Sets',
  10002653: 'Heizungssteuerungen',
  10002654: 'Radiatoren / Heizkörper',
  10002657: 'Heizelemente',
  10002658: 'Haushaltsboiler / Heizöfen / Warmwasserspeicher',
  10002660: 'Zentralheizung – Ersatzteile / Zubehör',
  10002662: 'Heizungstechnik – Sets',
  10002663: 'Rasen / bodennahe–Drainagesysteme – Zubehör',
  10002664: 'Dachrinnen / Drainagen – Sets',
  10002665: 'Dachrinnen – Teile / Zubehör',
  10002666: 'Dachrinnen / Drainagen – sonstige',
  10002668: 'Terrassengeländer / –Teile',
  10002669: 'Terassenbodenplatten – Verbundstoffe',
  10002670: 'Terrassenboden–Zubehör',
  10002671: 'Terrassengeländer– / Bodensysteme–Verbundstoffe',
  10002672: 'Terrassenentwässerungs–Systeme',
  10002673: 'Geländer / Terrassenbaubedarf – sonstige',
  10002674: 'Geländer / Terrassenbaubedarf – Sets',
  10002677: 'Außenverkleidungen',
  10002683: 'Dachziegel / Dachschindeln / Schindeln',
  10002684: 'Dachpappe (Rollen)',
  10002686: 'Bedachungsplatten / Wellplatten',
  10002687: 'Dachmembranen',
  10002688: 'Dachbeschichtungen',
  10002689: 'Dichtbleche / Anschlußbleche',
  10002692: 'Dachbaustoffe – sonstige',
  10002693: 'Dachbaustoffe – Sets',
  10002713: 'Gummistopfen / Karosserieflicken',
  10002720: 'Schleifpasten / Polituren / Kratzerentferner',
  10002723: 'Lackverdünner / Trockungsverzögerer',
  10002726: 'Ersatzzierleisten / Verkleidungsteile / Anbauteile',
  10002727: 'Dichtleisten / Gummidichtungen (Tür / Fenster)',
  10002728: 'Pinstriping (Zierlinierung)',
  10002733: 'Ladungssicherungs–Hilfsmittel',
  10002734: 'Dachträger– / Heckträgersysteme',
  10002743: 'Ladeflächenerweiterungen',
  10002746: 'PKW–Auffahrrampen / Hebebühnen',
  10002748: 'Aufbewahrungsboxen / –Kästen / –Körbe (Innenraum)',
  10002750: 'Transportvorrichtungen – sonstige',
  10002757:
    'Scheibenpflegemittel – Antibeschlag / Regenabweiser / Scheibenenteiser',
  10002764: 'Reifenpflege – Reinigungsmittel / Schaum / Politur',
  10002767: 'Karosseriepflege – Reinigungsmittel / Wachse / Schutzpolituren',
  10002773: 'Felgenpflege – Reinigungsmittel / Politur',
  10002776: 'Kfz–Pflegemittel – sonstige',
  10002777: 'Kfz–Pflegemittel – Sets',
  10002778: 'Bremsenreiniger',
  10002779: 'Vergaser–Reiniger / Additive – Sprays',
  10002780: 'Vergaser–Reiniger / Additive – Flaschen',
  10002781: 'Motoreiniger',
  10002799: 'Getriebeöl',
  10002800: 'Getriebeöl – sonstige',
  10002801: 'Getriebeöl – Sets',
  10002817: 'Auspuff–Reparaturzubehör',
  10002820: 'Kraftstofftank / –leitung–Reparatursets',
  10002821: 'Kühlerreparaturhilfsmittel / Reparatursets',
  10002822: 'Rückspiegelreparaturhilfsmittel / Reparatursets',
  10002823: 'Scheibenheizungsreparaturhilfsmittel / Reparatursets',
  10002824: 'Scheiben–Reparatursets',
  10002825: 'Kfz–Instandhaltungs– / Reparaturmittel – sonstige',
  10002826: 'Reservekraftstoffhilfen',
  10002829: 'Einparkhilfen',
  10002830: 'Notbeleuchtung / Warnblinkleuchten',
  10002833: 'Warntafeln / –dreiecke',
  10002834: 'Pannenhilfesets',
  10002835: 'Kfz–Sicherheit – sonstige',
  10002836: 'Kfz–Sicherheit – Sets',
  10002837: 'Autositze',
  10002838: 'Autositzbezüge',
  10002839: 'Autositzkissen',
  10002840: 'Sicherheitsgurte / Gurtverlängerungen',
  10002841: 'Sicherheitsgurtpolster',
  10002842: 'Kopf– / Nacken–Stützkissen',
  10002843: 'Autositzzubehör',
  10002844: 'Mittelkonsolen',
  10002845: 'Automüllbeutel / –Eimer',
  10002846: 'Aufbewahrungsfächer (innen) – sonstige',
  10002847: 'Autoaschenbecher',
  10002848: 'Autouhren',
  10002849: 'Auto–Kleiderbügel',
  10002850: 'Autokompasse',
  10002851: 'Autogetränkehalter',
  10002852: 'Schlüsselhalter / –fächer',
  10002853: 'Essens– / Getränketabletts',
  10002854: 'Kartenleselampen',
  10002855: 'Autothermometer',
  10002856: 'Autokombianzeigegeräte',
  10002857: 'Autoventilatoren',
  10002858: 'Auto–Kühl– / Wärme–Geräte',
  10002859: 'Windschutzscheiben–Abdeckungen',
  10002860: 'Scheibentönungen',
  10002861: 'Sonnenblenden',
  10002862: 'Lenkräder',
  10002863: 'Lenkradbezüge',
  10002864: 'Lenkradzubehör',
  10002865: 'Auto–Ersatzteppiche',
  10002866: 'Türeinstiegsleisten',
  10002867: 'Fußmatten',
  10002868: 'Kofferraum–Matten',
  10002869: 'Kfz–Innenausstattung – Fußraum / Kofferraum – sonstige',
  10002870: 'Armaturenbrett–Dekorsets',
  10002871: 'Armaturenbrett–Auflagen / –Bezüge',
  10002872: 'Instrumentenhalter / Instrumentenblenden',
  10002873: 'Zusatzinstrumente / –halter',
  10002875: 'Schalthebelknäufe / –Griffe',
  10002876: 'Schalthebelmanschetten / –Kits',
  10002877: 'Pedalauflagen / –Sets',
  10002878: 'Autodekorzubehör – Knöpfe / Schalter',
  10002879: 'Autodekorzubehör – Griffe / Kurbeln',
  10002880: 'Autodekorzubehör – sonstige',
  10002881: 'Dachhimmel / –Sets',
  10002882: 'Kfz–Innenausstattung – Dekoration – Sets',
  10002883: 'Kfz–Innenausstattung – Dekoration – sonstige',
  10002884: 'Trittbretter',
  10002885: 'Schweller– / Flankenschutz',
  10002886: 'Einstiegshilfen',
  10002887: 'Stoßstangen',
  10002888: 'Frontschutzbügel / Personenschutzbügel',
  10002889: 'Rammbügel',
  10002890: 'Dekorfrontgrills',
  10002891: 'Frontgrill–Einsätze',
  10002892: 'Unterfahrschutzbleche',
  10002893: 'Motorhaubenspoiler',
  10002894: 'Sonnenschuten für Frontscheibe',
  10002895: 'Seitenfenster–Sonnen– / Windschutz',
  10002896: 'Heckscheiben–Sonnen– / Windschutz / Dach–Sonnenblenden',
  10002897: 'Schiebedach–Sonnen– / Windschutz',
  10002898: 'Dachspoiler / Kabinenspoiler für Pick–ups',
  10002899: 'Spritzschutz / Schmutzfänger',
  10002900: 'Fahrzeugabdeckungen',
  10002901: 'Türschutzleisten',
  10002902: 'Scheinwerferabdeckungen',
  10002903: 'Kennzeichenhalterungen',
  10002904: 'Kennzeichenrahmen / –halterungen – Dekor',
  10002905: 'Reserveradabdeckungen',
  10002906: 'Lackschutzfolien',
  10002907: 'LKW–Ausstattung / –Zubehörteile',
  10002908: 'Cabriodächer – Ersatzteile / Zubehör',
  10002909: 'Abdeckungen /  Blenden – sonstige',
  10002910: 'Dachfenster / Sonnendächer',
  10002911: 'Lufthutzen',
  10002912: 'Spoiler',
  10002913: 'Lüftungsgitter / Luftschlitze',
  10002914: 'Kotflügelverbreiterungen',
  10002915: 'Seitenfensterrahmen / –Verkleidungen',
  10002916: 'Tuning–Motorhauben',
  10002919: 'Scheinwerfer / Rückleuchten – Blenden',
  10002920: 'Dekor–Embleme',
  10002922: 'Karosseriestyling / –Tuning – sonstige',
  10002923: 'Karosseriestyling / –Tuning – Sets',
  10002924: 'Reifen',
  10002926: 'Felgen',
  10002928: 'Reifenluftpumpen (manuell)',
  10002929: 'Auto–Kompressoren',
  10002930: 'Reifenreparatursets',
  10002931: 'Radzubehör',
  10002932: 'Reifenfüller  – chemisch',
  10002933: 'Radkappen',
  10002934: 'Bremscheibenabdeckungen',
  10002935: 'Radzierringe',
  10002940: 'Autowaschsysteme (elektrisch)',
  10002944: 'Poliermaschinen',
  10002949: 'Reinigungszubehör / Innenraumdüfte – sonstige',
  10002950: 'Reinigungszubehör / Innenraumdüfte – Sets',
  10002959: 'Anhängerkupplungen',
  10002960: 'Anhängerkupplungs–Komplettsets',
  10002961: 'Anhängerkupplungs–Erweiterungen',
  10002962: 'Adapter für Träger an Anhängerkupplungen',
  10002963: 'Anhängerkupplungs–Sicherungen',
  10002964: 'Abschleppseile / –Bänder',
  10002965: 'Abschlepphaken',
  10002966: 'Abschleppstangen',
  10002967: 'Abschlepp– / Kupplungs–Verriegelungen',
  10002968: 'Anhängerkupplung–Schutzkappen',
  10002969: 'Anhängerkupplungs–Trittbretter',
  10002970: 'Zusatzaußenspiegel / Wohnwagenspiegel',
  10002971: 'Anhänger – Sicherungsketten / –Kabel',
  10002972: 'Kupplungskugelköpfe',
  10002973: 'Zugstangen / Kupplungsträger',
  10002974: 'Abschleppzubehör  – Schwerlast',
  10002976: 'Abschleppzubehör / Anhängerkupplungen – sonstige',
  10002977: 'Abschleppzubehör / Anhängerkupplungen – Sets',
  10002978: 'Anhänger–Anschlussstecker / –Steckdosen',
  10002979: 'Bremsensteuerungen',
  10002980: 'Motoroptimierungsmodule für Anhänger– / Abschleppbetrieb',
  10002981: 'Anschlussadapter',
  10002982: 'Verkabelungssets / Kabelbäume',
  10002984: 'Abschleppleuchten',
  10002985: 'Abschleppzubehör / Anhängerkupplungen – Elektrik – sonstige',
  10002986: 'Abschleppzubehör / Anhängerkupplungen – Elektrik –  Sets',
  10002987: 'Anhänger– Stützräder / Fallstützen',
  10002988: 'Zugkugelkupplungen / Zugösen (Anhänger)',
  10002989: 'Anhängerbremsen',
  10002990: 'Radlager–Schutzvorrichtungen',
  10002991: 'Anhänger–Beleuchtung / –Reflektoren',
  10002992: 'Nivelliergeräte',
  10002993: 'Anhänger',
  10002994: 'Anhängerteile',
  10002995: 'Anhänger / Anhängerzubehör – Sets',
  10002996: 'Anhänger / Anhängerzubehör – sonstige',
  10002998: 'Kfz–Seilwinden',
  10002999: 'Kfz–Seilwindenteile / –Komponenten',
  10003000: 'Kfz–Seilwinden / Seilwindenzubehör – sonstige',
  10003001: 'Kfz–Seilwinden / Seilwindenzubehör – Sets',
  10003004: 'Kfz–Alarmanlagen',
  10003008: 'Fahrzeug–Ortungssysteme',
  10003009: 'Diebstahlsicherungen – sonstige',
  10003010: 'Diebstahlsicherungen – Sets',
  10003011: 'Scheibenwischerblätter',
  10003012: 'Scheibenwischergummis',
  10003013: 'Scheibenwischer / Scheibenwischerteile – sonstige',
  10003014: 'Scheibenwischer / Scheibenwischerteile – Sets',
  10003018: 'Zündkerzen – sonstige',
  10003019: 'Zündkerzen – Sets',
  10003022: 'Luftfilter',
  10003024: 'Getriebeölfilter',
  10003026: 'Kfz–Filterzubehör',
  10003028: 'Sportluftfilter–Kits / –Zubehör',
  10003029: 'Kfz–Filter – sonstige',
  10003030: 'Kfz–Filter – Sets',
  10003031: 'Frontscheinwerfer',
  10003034: 'Kfz–Ersatzbirnen / –leuchtmittel',
  10003036: 'Nebelscheinwerfer / Nebelschlussleuchten',
  10003037: 'Rückfahrleuchten',
  10003038: 'Fahrlichtleuchten',
  10003041: 'Abstands– / Begrenzungs– / Standlichtleuchten',
  10003042: 'Lichtsirenen',
  10003044: 'Bremsleuchten / Blinkleuchten / Schlussleuchten',
  10003045: 'Ersatzgläser / Streuscheiben für Kfz–Leuchten',
  10003046: 'Reflektoren für Kfz–Leuchten',
  10003047: 'Kfz–Leuchten / Leuchtmittel – sonstige',
  10003048: 'Kfz–Leuchten / Leuchtmittel – Sets',
  10003049: 'Frontscheinwerfer – Komplettsets',
  10003050: 'Rückleuchten – Komplettsets',
  10003052: 'Kfz–Beleuchtung / –scheinwerfer – sonstige',
  10003054: 'Kfz–Unterbodenbeleuchtungen',
  10003055: 'Kfz–Stroboskopleuchten',
  10003056: 'Kfz–Dekorbeleuchtung – Accent Lighting',
  10003057: 'Kfz–Dekorbeleuchtung – sonstige',
  10003058: 'Kfz–Dekorbeleuchtung – Sets',
  10003067: 'Kfz–Sicherungen',
  10003074: 'Autosteckdosen',
  10003080: 'Kfz–Kabelbündler / Spiralschläuche',
  10003081: 'Zigarettenanzünder / Zigarettenanzünder–Adapter',
  10003083: 'Kfz–Elektrik – Sets',
  10003084: 'Kfz–Elektrik – sonstige',
  10003092: 'Ölfilterschlüssel',
  10003095: 'Ablassschrauben',
  10003097: 'Kfz–Betriebsflüssigkeits–Wechsel – Sets / Zubehör',
  10003099: 'Kfz–Betriebsflüssigkeits–Mischer',
  10003105: 'Kfz–Betriebsflüssigkeits–Handhabung – sonstige',
  10003106: 'Kfz–Betriebsflüssigkeits–Handhabung – Sets',
  10003113: 'Ölschutzmatten',
  10003114: 'Kfz–Betriebsflüssigkeits–Wechselzubehör – sonstige',
  10003115: 'Kfz–Betriebsflüssigkeits–Wechselzubehör – Sets',
  10003142: 'Scheibenwischerarme',
  10003143: 'Scheibenwischermuffen',
  10003144: 'Scheibenwischermotoren',
  10003145: 'Scheibenwischermotoren–  Motorkerne',
  10003146: 'Wischwasserdüsen',
  10003147: 'Wischwasserpumpen',
  10003149: 'Wischwasserschläuche',
  10003150: 'Scheibenwischerteile – sonstige',
  10003151: 'Scheibenwischerteile – Sets',
  10003156: 'Schleifpapier / Schmirgelpapier',
  10003157: 'Schleifpads / Stahlwolle',
  10003159: 'Schmirgelleinen / Schleifgewebe',
  10003162: 'Mineralische Abrasivstoffe',
  10003163: 'Schleifmittel – sonstige',
  10003164: 'Schleifmittel – Sets',
  10003165: 'Seilspanner',
  10003166: 'Ösen / Verstärkungsringe',
  10003167: 'Seile / Ketten / Kabel',
  10003168: 'Federn',
  10003170: 'Wälz– und Gleitlager / Buchsen',
  10003171: 'Haken',
  10003173: 'Rohre',
  10003179: 'Dübel',
  10003180: 'Unterlegscheiben',
  10003181: 'Schrauben',
  10003182: 'Nägel/Bolzen',
  10003183: 'Krampen',
  10003184: 'Gewindemuttern',
  10003185: 'Gewindeschrauben / Gewindestangen',
  10003186: 'Halter / Bügel',
  10003187: 'Arretierungen / Schnäpper',
  10003190: 'Nieten',
  10003191: 'Türscharniere',
  10003194: 'Befestigungsmaterial – sonstige',
  10003195: 'Befestigungsmaterial – Sets',
  10003196: 'Gardinenstangen',
  10003197: 'Gardinenschienen / –leisten',
  10003201: 'Vorhänge – Teile / Zubehör – sonstige',
  10003202: 'Vorhänge – Teile / Zubehör – Sets',
  10003203: 'Fugenmörtel',
  10003204: 'Dichtungsmittel',
  10003205: 'Spachtelmasse',
  10003206: 'Klebebänder / Abdeckbänder (Do–it–yourself)',
  10003207: 'Kleber / Klebstoffe / Leim',
  10003208: 'Fugendichtmasse',
  10003210: 'Dichtungs– / Füll– / Klebemittel – sonstige',
  10003211: 'Dichtungs– / Füll– / Klebemittel – Sets',
  10003213: 'Folie/Schichten für den Teich / Wasserspiele',
  10003215: 'Wasserspiele / Bachläufe',
  10003216:
    'Filtersysteme (elektrisch) für Pools / Gartenteiche / Wasserspiele',
  10003218: 'Neblegräte für Teiche / Wasserspiele',
  10003219: 'UV–Wasserklärer für Pools / Gartenteiche / Wasserspiele',
  10003220: 'Belüftungsgeräte für Teiche',
  10003221: 'Chemikalien zur Teich– / Poolpflege',
  10003222: 'Drainagenrohre für Pools / Gartenteiche / Wasserspiele',
  10003223: 'Schutzabdeckungen für Pools / Gartenteiche / Wasserspiele',
  10003224: 'Pools / Gartenteiche / Wasserspiele – Sets',
  10003225: 'Pools / Gartenteiche / Wasserspiele – sonstige',
  10003227: 'Unkrautvernichtungsmittel (Herbizide)',
  10003234: 'Pflanzen– / Boden–Dünger',
  10003235: 'Mulch',
  10003236: 'Gartenerde / Humus',
  10003237: 'Wasser– / Bodenanalyse–Geräte (elektrisch)',
  10003238: 'Wasser– / Bodenanalyse–Produkte / –geräte (nicht elektrisch)',
  10003239: 'Pflanzenschutzmittel – Sets',
  10003240: 'Pflanzenschutzmittel – sonstige',
  10003242: 'Gartenstühle',
  10003243: 'Gartenliegen',
  10003245: 'Gartentische',
  10003246: 'Gartenfußstützen / –bänke',
  10003248: 'Gartenbänke',
  10003249: 'Hollywoodschaukeln / Schaukelbänke',
  10003250: 'Hängematten',
  10003251: 'Gartenmöbel / –Ausstattung – Ersatzteile / Zubehör',
  10003252: 'Gartenmöbel / –Ausstattung – Sets',
  10003253: 'Gartenmöbel / –Ausstattung – sonstige',
  10003254: 'Garteschläuche',
  10003255: 'Gartenschlauchverbinder / –kupplungen / –adapter',
  10003256: 'Schlauchhalter – fest installiert',
  10003257: 'Schlauchhalter / Schlauchwagen – mobil',
  10003262:
    'Spritzen / Brausen / Sprinkler / Regner (mit Schlauchanschluß für Düngung / Pflanzenschutz)',
  10003264: 'Bewässerungssysteme',
  10003267: 'Gießkannen',
  10003268: 'Garten–Wasserbehälter / Regentonnen / Wassertanks',
  10003270: 'Spritzen / Brausen / Sprinkler / Regner (manuell)',
  10003271: 'Spritzen / Brausen / Sprinkler / Regner (elektrisch)',
  10003272: 'Gartenbewässerungsprodukte – Sets',
  10003273: 'Gartenbewässerungsprodukte – Ersatzteile / Zubehör',
  10003274: 'Gartenbewässerungsprodukte – sonstige',
  10003276: 'Steuerungsgeräte für Bewässerungssysteme',
  10003277: 'Zaunelemenete / –latten',
  10003278: 'Zaunpfosten',
  10003279: 'Zaunstreben / Zaunhalterungen / Pfostenanker',
  10003280: 'Garten– / Beeteinfassungen',
  10003281: 'Zaunnetze / Maschendraht',
  10003283: 'Elektrozäune / Funkzäune',
  10003284: 'Rankgitter',
  10003285: 'Band–/Stacheldrahtzäune',
  10003286: 'Gartentore (nicht elektrisch)',
  10003287: 'Gartentore (elektrisch)',
  10003288: 'Gartenzäune / Garteneinfriedeungen  – Sets',
  10003289: 'Gartenzäune / Garteneinfriedeungen – sonstige',
  10003290: 'Blumenzwiebeln / Pflanzenknollen / Wurzelstöcke – sonstige',
  10003291: 'Samen / Sporen',
  10003305: 'Pflanzen – Sets',
  10003308: 'Kompostbehälter / Wurmkisten',
  10003311: 'Gartenabfallsysteme / Komposter – sonstige',
  10003313: 'Pflanzengefäße / Blumenkübel / Balkonkästen',
  10003314: 'Gartenabfallbehälter',
  10003315: 'Garten– / Teichdekoration',
  10003316: 'Pflanzenständer / –treppen / –regale',
  10003321: 'Garten–Vordächer / –Schutzdächer / Sonnensegel',
  10003323: 'Außenheizungen (elektrisch)',
  10003324: 'Außenheizungen (nicht elektrisch)',
  10003328: 'Grillgeräte',
  10003330: 'Gartenküchen',
  10003332: 'Wärmeschubladen (Außenbereich)',
  10003334: 'Gartengrillgeräte / Außenheizungen – Sets',
  10003335: 'Gartengrillgeräte / Außenheizungen – sonstige',
  10003336: 'Gartengrillgeräte / Außenheizungen – Ersatzteile / Zubehör',
  10003338: 'Laubsauger / –bläser',
  10003341: 'Schneefräsen (angetrieben)',
  10003347: 'Rasenvertikutierer / Bodenlüfter (angetrieben)',
  10003351: 'Häcksler / Schredder / Mulcher (angetrieben)',
  10003352: 'Gartengroßgeräte – Zubehör',
  10003353: 'Rasenmäher / Rasenlüfter (mit Antrieb)',
  10003355: 'Rasentrimmer / Rasenkanterschneider (angetrieben)',
  10003359: 'Kettensägen (angetrieben)',
  10003365: 'Erdbohrer (angetrieben)',
  10003367: 'Holzspalter (angetrieben)',
  10003368: 'Baumstumpffräsen / Baumstumpfentferner (angetrieben)',
  10003370: 'Bodenverfestiger / Vibrationsstampfer (angetrieben)',
  10003373: 'Kultivatoren / Ackerfräsen / Bodenfräsen (angetrieben)',
  10003375: 'Hochdruckreiniger (angetrieben)',
  10003376: 'Gartenkarren (mit Antrieb)',
  10003377: 'Rasenkehrer / Streuer (nicht elektrisch)',
  10003379: 'Gartenscheren (nicht angetrieben)',
  10003380: 'Astscheren / Baumscheren',
  10003381: 'Gartenscheren',
  10003383: 'Äxte',
  10003384: 'Sicheln / Sensen',
  10003385: 'Spalthammer',
  10003386: 'Garteneggen',
  10003387: 'Rasenmäher / Rasenlüfter (handbetrieben)',
  10003388: 'Gartenhacken',
  10003389: 'Kantenstecher (nicht angetrieben)',
  10003390: 'Schaufeln / Spaten',
  10003391: 'Gartengabeln',
  10003392: 'Kellen',
  10003393: 'Rasenlüfter (nicht angetrieben)',
  10003394: 'Rasenwalzen (handbetrieben)',
  10003395: 'Bodenverfestiger / Handrammen (nicht angetrieben)',
  10003396: 'Gartensiebe',
  10003397: 'Kultivatoren / Gartenfräsen (nicht angetrieben)',
  10003398: 'Blumenzwiebel–Pflanzautomaten',
  10003399: 'Rechen',
  10003400: 'Gartenabfall–Brennöfen',
  10003401: 'Unkrautverbrenner / Abflammgeräte',
  10003402: 'Motorbetriebene Gartengeräte – Ersatzteile / Zubehör',
  10003403: 'Rasensäcke / Laubsäcke',
  10003404: 'Gartenkarren / Schubkarren (nicht angetrieben)',
  10003405: 'Anzuchttöpfe',
  10003406: 'Gartenhocker / –kniebänke',
  10003407: 'Motorbetriebene Gartengeräte – Sets',
  10003408: 'Motorbetriebene Gartengeräte – sonstige',
  10003409: 'Gewächshäuser (komplett)',
  10003411: 'Schuppen / Gerätehäuser',
  10003412: 'Garten–Pavillons',
  10003414: 'Gartenlauben / Gartenbögen',
  10003415: 'Wintergärten',
  10003416: 'Pagoden (Gartendekoration)',
  10003417: 'Markisen',
  10003418: 'Gartenhäuser / Gewächshäuser / Pavillons – sonstige',
  10003419: 'Gartenhäuser / Gewächshäuser / Pavillons – Ersatzteile / Zubehör',
  10003421: 'Frühbeete / Zimmergewächshäuser / Glasglocken',
  10003427: 'Blitzdetektoren  (elektrisch)',
  10003430: 'Windmesser (Anemometer) (nicht elektrisch)',
  10003432: 'Psychrometer (elektrisch)',
  10003433: 'Pyranometer / Solarimeter (elektrisch)',
  10003434: 'Verdunstungsmesser (Evaporimeter)  (elektrisch)',
  10003435: 'Heliometer / Sonnenscheinautographen (elektrisch)',
  10003436: 'Helligkeitsmesser (Photometer) (elektrisch)',
  10003437: 'Hygrometer (nicht elektrisch)',
  10003440: 'Gartenthermometer (nicht elektrisch)',
  10003441: 'Barometer (nicht elektrisch)',
  10003443: 'Barographen (nicht elekrisch)',
  10003444: 'Wetterrstationen (nicht elektrisch)',
  10003446: 'Windsäcke / Wetterfahnen',
  10003447: 'Niederschlagsmesser (nicht elektrisch)',
  10003451: 'Garten–Wetterstationen / –messgeräte – Ersatzteile / Zubehör',
  10003452: 'Garten–Wetterstationen / –messgeräte – sonstige',
  10003453: 'Garten–Wetterstationen / –messgeräte – Sets',
  10003454: 'Zirkel (Do–it–yourself)',
  10003455: 'Maßstäbe / Lineale (Do–it–yourself)',
  10003458: 'Maßbänder (Do–it–yourself)',
  10003459: 'Mikrometer',
  10003461: 'Messräder',
  10003463: 'Schieblehren / Messschieber (Do–it–yourself)',
  10003464: 'Winkel (Do–it–yourself)',
  10003465: 'Wasserwaagen / Richtwaagen',
  10003466: 'Lote / Senkbleie',
  10003468: 'Werkbänke',
  10003470: 'Sägeböcke / Gerüstböcke',
  10003473: 'Arbeitsbühnen / Baugerüste',
  10003476: 'Spachtel',
  10003479: 'Kombinations–Schneidewerkzeuge (nicht elektrisch)',
  10003480: 'Rohrschneider (nicht elektrisch)',
  10003481: 'Bolzen–/ Kettenschneider',
  10003482: 'Drahtschneider / Seitenschneider',
  10003483: 'Fliesenschneider (nicht elektrisch)',
  10003485: 'Glasschneider (nicht elektrisch)',
  10003486: 'Blechscheren / Knabber / Nibbler (nicht elektrisch)',
  10003487: 'Stanzer',
  10003488: 'Meißel / Beitel / Stemmeisen',
  10003489: 'Nageltreiber / Senkköpfe',
  10003490: 'Ahlen',
  10003491: 'Hohlmeißel / Hohlbeitel',
  10003492: 'Messer / Cutter (Hobby / DIY) (nicht elektrisch)',
  10003495: 'Nagelzieher',
  10003496: 'Schubkarren  (nicht elektrisch)',
  10003497: 'Handkarren / Rollwagen',
  10003498: 'Saugheber',
  10003499: 'Brech– / Stemmeisen / Brechstangen',
  10003500: 'Hämmer (Do–it–yourself)',
  10003501: 'Hämmer / Schlägel / Beile – Ersatzteile / Zubehör',
  10003502: 'Heftapparate / Nagelpistolen (nicht elektrisch)',
  10003504: 'Handhefthammer (nicht elektrisch)',
  10003505: 'Nietwerkzeuge',
  10003507: 'Nageln / Heften / Befestigung Werkzeuge – Ersatzteile / Zubehör',
  10003508: 'Schraubenschlüssel / Steckschlüssel',
  10003527:
    'Schraubenschlüssel / Steckschlüssel / Schraubwerkzeuge – Ersatzteile / Zubehör',
  10003528: 'Schraubenzieher (nicht elektrisch)',
  10003530: 'Schraubenzieher – Sets',
  10003532: 'Schneidende und trennende Zangen',
  10003533: 'Feilen',
  10003534: 'Raspeln',
  10003535: 'Schraubzwingen / Spannwerkzeuge',
  10003536: 'Schraubstöcke',
  10003537: 'Sapnnwerkzeuge – Ersatzteile / Zubehör',
  10003538: 'Handschleifer',
  10003539: 'Schärfhilfen',
  10003540: 'Werkzeugschärfer  (nicht elektrisch)',
  10003541: 'Handbohrer',
  10003542: 'Handbohrer  – Ersatzteile / Zubehör',
  10003543: 'Schabmesser',
  10003544: 'Hobel',
  10003545: 'Oberflächen–Formwerkzeuge',
  10003546: 'Oberflächen–Formwerkzeuge  – Verbrauchsartikel',
  10003547: 'Maurer– und Glättekellen / Reibebretter',
  10003548: 'Rohrbiegemaschine',
  10003549: 'Bördelwerkzeug',
  10003550: 'Schneideisen (nicht elektrisch)',
  10003551: 'Schneideisen / Gewindebohrer – Sets',
  10003552: 'Ambosse (Do–it–yourself)',
  10003555: 'Druckluftkompressoren – mobil',
  10003562: 'Schraubenausdreher',
  10003563: 'Mutternsprenger',
  10003564: 'Rohrreinigungsspiralen ( nicht elektrisch)',
  10003565: 'Saugglocken',
  10003572: 'Rollböcke',
  10003573: 'Gipspaletten (Plaster Hawks)',
  10003576: 'Stifte / Malkreiden (Do–it–yourself)',
  10003578: 'Werkstattwagen',
  10003586: 'Schutzbrillen',
  10003594: 'Fugenkellen',
  10003596: 'Nass–Sägen / Fliesen– / Glassägen',
  10003597: 'Bandsägen – stationär',
  10003598: 'Schleifböcke',
  10003601: 'Tischkreissägen – stationär',
  10003602: 'Dekupiersägen – stationär',
  10003603: 'Radialkreissägen',
  10003604: 'Hobelmaschinen',
  10003605: 'Drehmaschinen – stationär (elektrisch)',
  10003608: 'Elektrowerkzeuge – stationär – Ersatzteile / Zubehör',
  10003609: 'Tellerschleifer',
  10003610: 'Spindelschleifmaschinen',
  10003611: 'Kombinierte Schleifmaschinen (Band/Teller)',
  10003613: 'Standbohrmaschinen / Stemmmaschinen',
  10003615: 'Hobel',
  10003616: 'Abrichthobelmaschine – mobil',
  10003618: 'Distanz– / Längenmesser (elektrisch)',
  10003619: 'Winkelmesser (elektrisch)',
  10003620: 'Laser–Wasserwaagen',
  10003626: 'Kantenfräser',
  10003627: 'Tischkreissägen – mobil',
  10003629: 'Säbelsägen',
  10003631: 'Stichsägen (elektrisch)',
  10003632: 'Knabber / Nibbler (Blech) (elektrisch)',
  10003638: 'Heißdrahtschneidemaschinen',
  10003639: 'Gewindeschneider',
  10003640: 'Rohrschneider (elektrisch)',
  10003641: 'Handkreissägen',
  10003642: 'Rohrgewindeschneider (nicht elektrisch)',
  10003643: 'Meißel / Beitel (elektrisch)',
  10003644: 'Winkelschleifer',
  10003645: 'Trennwerkzeuge',
  10003647: 'Geradschleifer',
  10003648: 'Oberflächen–Schleifmaschinen',
  10003649: 'Löt– / Hartlötkolben',
  10003651: 'Lichtbogenschweißgeräte',
  10003653: 'Bohrmaschinen (elektrisch)',
  10003654: 'Bohrschrauber/Rotationswerkzeuge (elektrisch)',
  10003655: 'Schlagschrauber',
  10003656: 'Kraftschrauber',
  10003657: 'Schnellbauschrauber',
  10003658: 'Kombinationsbohrer (elektrisch)',
  10003659: 'Schlagbohrmaschinen',
  10003660: 'Bohrhämmer',
  10003662: 'Heißluftpistolen',
  10003663: 'Fettpressen (elektrisch)',
  10003664: 'Fugenpistolen (elektrisch)',
  10003665: 'Hefter / Tacker (elektrisch)',
  10003666: 'Nagelpistolen (elektrisch)',
  10003668: 'Bandschleifmaschinen – stationär',
  10003669: 'Poliermaschinen',
  10003672: 'Dreiecksschleifer',
  10003674: 'Werkzeugschränke',
  10003676: 'Werkzeugkästen / -koffer',
  10003677: 'Taschen / Etuis für Werkzeuge',
  10003678: 'Werkzeuggürtel / Gürteltaschen',
  10003679: 'Flaschenzüge / Seilwinden',
  10003680:
    'Elektrowerkzeuge  – Hebe–/Transportgeräte –  Ersatzteile / Zubehör',
  10003682: 'Werkzeuge / Maschinen (elektrisch) – Sets',
  10003685: 'Kfz–Audio / Kfz–Video / Kfz–Navigation – Sets',
  10003686: 'Fotografie / Optik – Sets',
  10003688: 'Sportartikel – Sets',
  10003689: 'Alkoholische Getränke, nicht auf Traubenbasis – mit Kohlensäure',
  10003690: 'Herde (Kochfeld– / Backofenkombinationen)',
  10003691: 'Dampfgarer',
  10003692: 'Wäscheschleudern / Wäschetrockner',
  10003694: 'Kühlschränke',
  10003695: 'Kühl– / Gefrierkombinationen',
  10003698: 'Gefrierschränke',
  10003704: 'Schutzkleidung – Zubehör',
  10003705: 'Schutzkleidung – Sets',
  10003707: 'Sportbekleidung – Handschuhe',
  10003708: 'Sportbekleidung – Kopfbedeckungen',
  10003709: 'Sportbekleidung – Strumpfwaren',
  10003710: 'Getränkekühlschränke – sonstige',
  10003711: 'Schuhputzmaschinen / Schuhpflegegeräte',
  10003712: 'Wasserspender – freistehend',
  10003713: 'Wasserspender (Tischgeräte)',
  10003714: 'Sträucher / Bäume',
  10003718: 'Dual–Discs (bespielt)',
  10003729: 'Abrichthobelmaschinen – stationär',
  10003730: 'Tisch–Hobelmaschinen – stationär',
  10003737: 'Oberfräsen',
  10003738: 'Kapp- / Gehrungssägen – mobil',
  10003741: 'Rohrreinigungsspiralen (elektrisch)',
  10003742: 'Bandschleifmaschinen – mobil',
  10003744: 'Schweißbrenner / Lötlampen',
  10003746: 'Stoßmaschinen – stationär',
  10003747: 'Elektrowerkzeuge – handgeführt / mobil – Ersatzteile / Zubehör',
  10003749: 'Elektrowerkzeuge  – Hebe–/Transportgeräte – sonstige',
  10003750: 'Elektrowerkzeuge – handgeführt / mobil – sonstige',
  10003751: 'Elektrowerkzeuge – stationär – sonstige',
  10003752: 'Kfz–Lufterfrischer (elektrisch)',
  10003753: 'Kfz–Lufterfrischer (nicht elektrisch)',
  10003755: 'Schlösser / Lenkrad– / Pedalsicherungen',
  10003757: 'Eiskratzer',
  10003758: 'Hupen / Sirenen',
  10003759: 'Kfz–Suchscheinwerfer',
  10003760: 'Kfz–Sicherheit – Ersatzteile / Zubehör',
  10003761: 'Karosseriereparatur – sonstige',
  10003762: 'Flüssigkeitsfilter',
  10003763: 'Zündkerzen',
  10003764: 'Scheibenwischflüssigkeit',
  10003765: 'Poliermittel',
  10003766: 'Estrich',
  10003767: 'Gardinenstangen – Zubehör',
  10003771: 'Schreibwaren / Bürobedarf / Büromaschinen / Partyartikel –Sets',
  10003773: 'Camping–Essgeschirr',
  10003774: 'Kfz–Sicherheitsrückspiegel',
  10003775: 'Reiniger für elektrische Kfz–Teile',
  10003776: 'Lupen',
  10003777: 'Audio / Video / Foto – Sets',
  10003778: 'Ahlen / Stanzer / Nageltreiber – Sets',
  10003779:
    'Kommunikationsgeräte / Dienstleistungen  – Mobilfunk / drahtlos – Ersatzteile',
  10003787: 'Meißel / Beitel / Hohlmeißel  – Sets',
  10003788: 'Gummihammer / Holzhammer / Kunststoffhammer (Do–it–yourself)',
  10003789: 'Beile / Äxte (Do–it–yourself)',
  10003790: 'Aufbewahrungs– / Ergänzungsmöbel – sonstige',
  10003791:
    'Hämmer / Beile / Gummihammer – Holzhammer – Kunststoffhammer – Sets',
  10003795: 'Schraubenschlüssel / Steckschlüssel / Schraubwerkzeuge – Sets',
  10003796: 'Schraubenschlüssel / Steckschlüssel – Sets',
  10003797:
    'Schraubenschlüssel / Steckschlüssel / Ratschen – Verlängerungen / Griffe',
  10003799: 'Handsägen',
  10003800: 'Sägeblätter für Handsägen',
  10003801: 'Handsägen  – Ersatzteile / Zubehör',
  10003807: 'Hobel / Feilen / Raspeln  – Sets',
  10003808: 'Gewindebohrer (nicht elektrisch)',
  10003813: 'Heimtextilien – Sets',
  10003814: 'Wohn– / Büromöbel – Sets',
  10003816: 'Dekorative Wohnaccessoires – Sets',
  10003817: 'Spielkonsolen – stationär',
  10003818: 'Spielkonsolen – tragbar',
  10003819: 'Spielkonsolen – Ersatzteile',
  10003821: 'Leitern',
  10003822: 'Trage– / Hebe– / Klettergeräte – Ersatzteile / Zubehör',
  10003823: 'Messer / Cutter (nicht elektrisch) – Ersatzteile / Zubehör',
  10003824: 'Messerklingen (Hobby / DIY)',
  10003825: 'Schraubenzieher – sonstige',
  10003826: 'Schraubenzieher – Ersatzteile / Zubehör',
  10003827: 'Inbusschüssel / Innensechskantschraubendreher',
  10003834: 'Karosseriereparatur – Sets',
  10003839: 'Scheibenwischerabdeckungen',
  10003841: 'Rasenwalzen (mit Antrieb)',
  10003842: 'Erdbohrer (nicht angetrieben)',
  10003843: 'Gartenscheren (angetrieben)',
  10003844: 'Lochschaufeln / Pfahllochbohrer (nicht angetrieben)',
  10003846: 'Brechstangen (Garten)',
  10003852: 'Gemüsepflanzen / Speisepilze',
  10003854: 'Pflanzen – gemischte Trays',
  10003857: 'Garten–Wasserpumpen',
  10003859: 'Pflanztunnel',
  10003861: 'Pfahllochbohrer (angetrieben)',
  10003862: 'Keile',
  10003863: 'Spitzhacken',
  10003864: 'Garten–Handwerkzeuge – Ersatzteile / Zubehör',
  10003865: 'Garten–Handwerkzeuge – sonstige',
  10003866: 'Garten–Handwerkzeuge – Sets',
  10003867: 'Applikatoren / Bodenspritzen (nicht angetrieben)',
  10003868: 'Rasen / Laubsackständer / –halter',
  10003869: 'Applikatoren / Bodenspritzen (angetrieben)',
  10003870: 'Heckenscheren (angetrieben)',
  10003872: 'Gartengroßgeräte – sonstige',
  10003873: 'Gartengroßgeräte – Sets',
  10003874: 'Wand– / Deckenfarben / Grundierungen (Haushalt)',
  10003884: 'Wandverkleidungswerkzeuge / Tapetenablösegeräte – elektrisch',
  10003887: 'Gartenanalyse–Produkte – sonstige',
  10003889: 'Gartenanalyse–Produkte – Ersatzteile / Zubehör',
  10003890: 'Gewächshausgerüste / –rahmen',
  10003891: 'Gartenhäuser / Gewächshäuser / Pavillons – Sets',
  10003894: 'Steine – Mauersteine',
  10003896: 'Spachtelgips',
  10003897: 'Sand (Do–ityourself)',
  10003898: 'Asphalt– / Beton–Reparaturbaustoffe',
  10003899: 'Betonzusatzstoffe / –Mittel  – Bindemittel',
  10003900: 'Betonzusatzstoffe / –Mittel  – Färbemittel / Farbstoffe',
  10003901: 'Betonzusatzstoffe / –Mittel – Luftporenbildner',
  10003902: 'Fertigmörtel (Trockenmischungen)',
  10003903: 'Asphalt-/Zement-/Maurerhandwerk – Sets',
  10003904: 'Mineralische Baustoffe / Asphaltbaustoffe – sonstige',
  10003906: 'Türschwellen',
  10003914: 'Schlüssel',
  10003916: 'Kombinationstüren Wetter– / Insektenschutz – Ersatzteile',
  10003918: 'Tür–Beschläge / Zubehör – sonstige',
  10003919: 'Türbeschläge / Zubehör – Sets',
  10003920: 'Kombinationstüren Wetter– / Insektenschutz',
  10003921: 'Kellerschachttüren',
  10003923: 'Türen – sonstige',
  10003924: 'Türen – Sets',
  10003925: 'Glasbausteine',
  10003926: 'Dekorglas–Einsätze',
  10003927: 'Balken / Träger (tragend)',
  10003932: 'Bauholz / Täfelungen / Gipsbaustoffe – sonstige',
  10003933: 'Bauholz / Täfelungen / Gipsbaustoffe – Sets',
  10003934: 'Profilleisten (nicht aus Holz)',
  10003935: 'Profilleisten (aus Holz)',
  10003939: 'Ornamente / Zubehör für Zargen / Profilleisten',
  10003942: 'Tragende Komponenten / Bauelemente – sonstige',
  10003943: 'Tragende Komponenten / Bauelemente – Ersatzteile / Zubehör',
  10003944: 'Fenster – Teile / Zubehör – Sets',
  10003946: 'Einfachfenster – Massivholz',
  10003955: 'Ablaufstutzen (Dachrinnen / Drainage)',
  10003956: 'Fallrohre – Teile / Zubehör',
  10003959: 'Treppengeländer–Systeme (aus Holz)',
  10003960: 'Treppengeländer–Systeme (nicht aus Holz)',
  10003961: 'Balustraden–/Geländer–Systeme (nicht aus Holz)',
  10003962: 'Balustraden–/Geländer–Systeme (Holz)',
  10003966: 'Kragsteine / Giebel',
  10003968: 'Fensterläden',
  10003969: 'Steinfurniere / Holzfurniere für Außenverkleidung',
  10003974: 'Dachstroh / Reet',
  10003977: 'Dachbaustoffe – Zubehör',
  10003980: 'Deckenplatten / Deckenfliesen',
  10003981: 'Leichtbaudeckensysteme',
  10003982: 'Klimaanlagen – fest installiert',
  10003984: 'Klimatisierungsgeräte / Ventilatoren – Ersatzteile / Zubehör',
  10003985: 'Klimatisierungsgeräte / Ventilatoren – Sets',
  10003988: 'Luftreinigungs / –Ionisierungsgeräte – fest installiert',
  10003990: 'Luftentfeuchtungsgeräte – fest installiert',
  10003992: 'Elektrowärmegeräte / Heizlüfter / Heizstrahler – mobil',
  10003993: 'Luftbefeuchtungsgeräte – fest installiert',
  10003994: 'Sanitär– Heizungs– und Klimatechnik – Sets',
  10003995: 'Deckenventilatoren',
  10003996: 'Ventilatoren für Luftführungsanlagen',
  10003997: 'Luftführungsanlagen',
  10003998: 'Absauggebläse / Dunstabzugshauben',
  10004002: 'Thermostate',
  10004003: 'Fußbodenheizungssysteme',
  10004006: 'Entkalker (Do–it–yourself)',
  10004008: 'Wasserenthärter (Do–it–yourself)',
  10004012: 'Wasserzähler',
  10004016: 'Wasserfiltersysteme',
  10004022: 'Anschlüsse / Verbindungsleitungen',
  10004024: 'Ventile / Anschlussstücke',
  10004026: 'Anti–Rutsch–Klebestreifen für die Dusche',
  10004027: 'Badesitze',
  10004028: 'Wannengriffe',
  10004029: 'Badewannen– / Duschmodule mit Düsen',
  10004032: 'Badewannen– / Duschablagen – fest installiert',
  10004033: 'Handtuchstangen / –ringe  – fest installiert',
  10004034:
    'Seifen– / Lotion– Desinfektionsmittelspender /  – fest installiert',
  10004044: 'Massageduschen',
  10004049: 'Abwassertanks / Klärbehälter',
  10004054: 'Sanitärrohre / Rohrleitungen / Sanitärrohrsysteme',
  10004055: 'Pumpen',
  10004057: 'Rohre – Ersatzteile / Zubehör',
  10004058: 'Wasser- / Gasversorgung – Sets',
  10004062: 'Toilettensitze / –deckel',
  10004063: 'Klimatisierungsgeräte, multifunktionell – fest installiert',
  10004064: 'Fensterventilatoren',
  10004096: 'Kampfsportausrüstung – sonstige',
  10004097: 'Racketsportartikel – sonstige',
  10004098: 'Fechtsportausrüstung (elektrisch)',
  10004099: 'Camping–Wasserkocher',
  10004100: 'Campingtoiletten (elektrisch)',
  10004101: 'Uhren – Ersatzteile / Zubehör',
  10004102: 'Gartentraktoren',
  10004103: 'Hörbücher',
  10004104: 'Hörzeitschriften / –Zeitungen',
  10004105: 'Gedruckte Karten',
  10004106: 'Elektronische Karten',
  10004107: 'Bücher  – Sets',
  10004108: 'Zeitungen / Zeitschriften  – Sets',
  10004109: 'Pflanzenschutzmittel gegen Pilzbefall (Fungizide)',
  10004110: 'Gartenerde / Dünger – sonstige',
  10004111: 'Sportauswertungsausrüstung (elektrisch)',
  10004112: 'Fechtsportausrüstung (nicht elektrisch)',
  10004113: 'Sportbekleidung – Halsbekleidung',
  10004114: 'Sportbekleidung – Gürtel',
  10004115: 'Sportbekleidung – Abzeichen / Schnallen',
  10004116: 'Blechblasinstrumente – Zubehör (nicht elektrisch)',
  10004117: 'Keyboard / Klavier – Zubehör (elektrisch)',
  10004118: 'Perkussionsinstrumente – Zubehör (nicht elektrisch)',
  10004119: 'Saiteninstrumente – Zubehör (nicht elektrisch)',
  10004120: 'Holzblasinstrumente – Zubehör (nicht elektrisch)',
  10004121: 'Musikinstrumente – Koffer / Taschen / Abdeckungen',
  10004122: 'Musikinstrumente – Reinigungsprodukte',
  10004123: 'Metronome / Stimmer (elektrisch)',
  10004124: 'Musikinstrumente – Halter / Ständer / Marschgabeln',
  10004125: 'Metronome / Stimmer (nicht elektrisch)',
  10004126: 'Musikinstrumente / Zubehör – Sets',
  10004127: 'Musikinstrumente – Zubehör – Sets',
  10004128: 'Musikinstrumente – Zubehör – sonstige',
  10005095: 'Tische / Schreibtische – Ersatzteile / Zubehör',
  10005096: 'Betten – Ersatzteile / Zubehör',
  10005097: 'Stühle / Bürositzmöbel – Ersatzteile / Zubehör',
  10005098: 'Aufbewahrungs– / Ergänzungsmöbel – Ersatzteile / Zubehör',
  10005100: 'Werkstatteinrichtungen – Ersatzteile / Zubehör',
  10005101: 'Werkstatteinrichtungen – sonstige',
  10005102: 'Werkzeugaufbewahrung – sonstige',
  10005104: 'Werkzeugaufbewahrung – Sets',
  10005105: 'Atemschutzausrüstungen (elektrisch)',
  10005106: 'Atemschutzausrüstungen (nicht elektrisch)',
  10005107: 'Gehörschutz (elektrisch)',
  10005108: 'Gehörschutz (nicht elektrisch)',
  10005109: 'Schutzhelme / Schweißhelme (elektrisch)',
  10005110: 'Schweißhelme (nicht elektrisch)',
  10005111: 'Schutzhelme',
  10005112: 'Gesichtsschilde',
  10005115: 'Persönliche Schutzausrüstung – Ersatzteile / Zubehör',
  10005116: 'Persönliche Schutzausrüstung – sonstige',
  10005117: 'Persönliche Schutzausrüstung – Sets',
  10005118: 'Haftnotizen / Papierwürfel',
  10005119: 'Aktenvernichter (elektrisch)',
  10005120: 'Bürobedarf – Papiere / Kartone / Folien – sonstige',
  10005121: 'Bürobedarf – Papiere / Kartone / Folien – Sets',
  10005122: 'Steuerplakettenhalter',
  10005124: 'Schleifmittel – Ersatzteile / Zubehör',
  10005125: 'Buch–Schutzumschläge',
  10005126: 'Klebebänder (Bürobedarf)',
  10005127: 'Reinigungszubehör / Innenraumdüfte – Ersatzteile / Zubehör',
  10005128: 'Dachboxen',
  10005129: 'Diebstahlsicherungen – Ersatzteile / Zubehör',
  10005130: 'Transportvorrichtungen – Ersatzteile / Zubehör',
  10005131: 'Kfz–Elektrik – Ersatzteile / Zubehör',
  10005132: 'Kfz–Schalter',
  10005133: 'Brettspiele (nicht elektrisch)',
  10005134: 'Brettspiele (elektrisch)',
  10005135:
    'Brettspiele / Kartenspiele / Geduldspiele / Puzzles – Ersatzteile / Zubehör',
  10005136: 'Brettspiele / Kartenspiele / Geduldspiele / Puzzles – sonstige',
  10005137: 'Brettspiele / Kartenspiele / Geduldspiele / Puzzles – Sets',
  10005138: 'Kartenspiele (nicht elektrisch)',
  10005139: 'Kartenspiele (elektrisch)',
  10005140: 'Puzzles / Geduldspiele (nicht elektrisch)',
  10005141: 'Puzzles / Geduldspiele (elektrisch)',
  10005142: 'Puppen / Stofftiere (nicht elektrisch)',
  10005143: 'Puppen / Stofftiere (elektrisch)',
  10005144: 'Puppen / Marionetten / Stofftiere – sonstige',
  10005145: 'Marionetten / Handpuppen',
  10005146: 'Schönheits– / Kosmetikzubehör für Puppen',
  10005147: 'Puppenhäuser / –Ausstattung',
  10005148: 'Puppenbekleidung',
  10005149: 'Puppenmöbel',
  10005150: 'Puppen– / Marionetten– / Stofftier–Zubehör – sonstige',
  10005151: 'Puppen– / Marionetten– / Stofftier–Zubehör – Sets',
  10005152: 'Puppentheater',
  10005153: 'Pädagogische – / Lern – Baby–/Kinderspielzeug (nicht elektrisch)',
  10005154: 'Pädagogische – / Lern–Baby–/Kinderspielzeug (elektrisch)',
  10005155: 'Badespielzeuge',
  10005156: 'Kommunikationsspielzeuge (nicht elektrisch)',
  10005157: 'Kommunikationsspielzeuge (elektrisch)',
  10005158: 'Spielzeugcomputer',
  10005159: 'Lern– / Entwicklungsspielzeuge – sonstige',
  10005160: 'Lern– / Entwicklungsspielzeuge – Sets',
  10005161: 'Schiebe– / Ziehspielzeuge (nicht elektrisch)',
  10005162: 'Schiebe– / Ziehspielzeuge (elektrisch)',
  10005163: 'Wissenschaftliche Spielzeuge (nicht elektrisch)',
  10005164: 'Wissenschaftliche Spielzeuge (elektrisch)',
  10005165: 'Kreisel / Jojos',
  10005166: 'Bauklötze (nicht elektrisch)',
  10005167: 'Bauklötze (elektrisch)',
  10005168: 'Modellbau (nicht elektrisch)',
  10005169: 'Modellbau (elektrisch)',
  10005170: 'Optische Spielzeuge (nicht elektrisch)',
  10005171: 'Optische Spielzeuge (elektrisch)',
  10005172: 'Kostüme',
  10005173: 'Kostüme / Kostümzubehör – sonstige',
  10005174: 'Kostüme / Kostümzubehör – Sets',
  10005175: 'Kostüme (nicht elektrisch) – Zubehör',
  10005176: 'Kostüme (elektrisch) – Zubehör',
  10005177: 'Musikspielzeuge (nicht elektrisch)',
  10005178: 'Musikspielzeuge (elektrisch)',
  10005179: 'Musikspielzeuge – sonstige',
  10005180: 'Spielzeuge / Spielgeräte für Garten und Spielplatz – sonstige',
  10005181: 'Spielzeuge für Innen und Außen',
  10005182: 'Spielgeräte für Garten und Spielplatz',
  10005183: 'Tischspiele (nicht elektrisch)',
  10005184: 'Tischspiele (elektrisch)',
  10005185: 'Tischspiele – sonstige',
  10005186: 'Spielzeuge / Spiele – Sets',
  10005187: 'Kinderfahrzeuge (nicht elektrisch)',
  10005188: 'Kinderfahrzeuge (elektrisch)',
  10005189: 'Kinderfahrzeuge – sonstige',
  10005190: 'Auto– / Modelleisenbahn–Sets (nicht elektrisch)',
  10005191: 'Auto– / Modelleisenbahnsets (elektrisch)',
  10005192: 'Auto– / Modelleisenbahnsets – Ersatzteile / Zubehör',
  10005193: 'Spielzeugfahrzeuge / Miniaturen (nicht elektrisch)',
  10005194: 'Spielzeugverkehrsmittel / nicht zum Aufsitzen (elektrisch)',
  10005195: 'Spielzeugfahrzeuge – sonstige',
  10005196: 'Spielzeugfahrzeuge – Sets',
  10005197: 'Decken (beheizt)',
  10005198: 'Wasseraufbereitungsmittel',
  10005199: 'Schränke / Sideboards / Vitrinen',
  10005200: 'Reisenecessaire / Kosmetikkoffer',
  10005201: 'Messerschärfer (nicht elektrisch)',
  10005204: 'Megafone',
  10005205: 'Kfz–Audio – Kassettenspieler / –Wechsler',
  10005206: 'Schreibtischunterlagen',
  10005207: 'Fotoalben – Ersatzteile / Zubehör',
  10005208: 'Wassertest–Kits',
  10005209: 'Haushalt / Küche – Aufbewahrung – Ersatzteile / Zubehör',
  10005210: 'Serviettenringe',
  10005211: 'Generatoren',
  10005213: 'Klebepistolen (elektrisch)',
  10005214: 'Zement– / Mörtelmischmaschinen',
  10005215: 'Außenlampen / Fackeln / Laternen (elektrisch)',
  10005216: 'Außenlampen / Fackeln / Laternen (nicht elektrisch)',
  10005217: 'Gartenbeleuchtung – Ersatzteile / Zubehör',
  10005218: 'Gartenbeleuchtung – sonstige',
  10005219: 'Sonnenschirme',
  10005220: 'Rankhilfen / Pflanzenhalter',
  10005221: 'Schubkarren – elektrisch',
  10005223: 'Kreissägen',
  10005224:
    'Produkte / Gerichte auf Ei-Basis – nicht verzehrbereit (tiefgefroren)',
  10005225:
    'Produkte / Gerichte auf Ei-Basis  – nicht verzehrbereit (leicht verderblich)',
  10005226:
    'Produkte / Gerichte auf Ei-Basis – nicht verzehrbereit (ohne Kühlung haltbar)',
  10005227:
    'Produkte / Gerichte auf Basis von Molkerei– / Ei–Erzeugnissen – verzehrbereit (leicht verderblich)',
  10005228:
    'Produkte / Gerichte auf Basis von Molkerei- / Ei-Erzeugnissen – verzehrbereit (ohne Kühlung haltbar)',
  10005229: 'Multifunktionsgeräte (Büromaschinen)',
  10005230: 'Druckluftkompressoren – stationär',
  10005231: 'Bandsägen – mobil',
  10005232: 'Kfz–Batterien',
  10005233: 'Kfz–Batteriezubehör',
  10005234: 'Frostschutzmittel / Kühlerflüssigkeiten',
  10005241: 'Wegfahrsperren',
  10005248: 'Tellerschleifer / Exzenterschleifer',
  10005249: 'Applikatoren / Bürsten',
  10005250: 'Rollenspiel–Spielzeuge – Küchenspielzeuge',
  10005252: 'Steckschlüsselsätze',
  10005253: 'Poolbedarf',
  10005254: 'Schrankfolie / Schrankpapier',
  10005255: 'Kraftstoffzusätze / Additive',
  10005256: 'Brennstoff–Pumpen (nicht elektrisch)',
  10005257: 'Brennstoff–Pumpen (elektrisch)',
  10005258: 'Gasflaschen / –kanister (leer)',
  10005262: 'Brennstoffe / Kraftstoffzusätze – Sets',
  10005263: 'Flüssige Brennstoffe',
  10005264: 'Gasförmige Brennstoffe',
  10005265: 'Gelförmige Brennstoffe',
  10005266: 'Feste Brennstoffe',
  10005267: 'Schmieröle',
  10005268: 'Schmierfette',
  10005269: 'Schmierwachse',
  10005270: 'Schmierstoffprodukte – Sets',
  10005272: 'Frostschutzmittel / Kühlflüssigkeiten',
  10005273: 'Korrosionsschutzmittel',
  10005275: 'Schutzmittel  – Sets',
  10005276: 'Schmierstoffbehälter / –spender (leer)',
  10005277: 'Auffangwannen',
  10005280: 'Schmierstoffe / Schutzmittel – Aufbewahrung – Sets',
  10005281: 'Schmieröl– / Flüssigkeitspumpen (manuell)',
  10005282: 'Schmieröl– / Flüssigkeitspumpen (elektrisch)',
  10005283: 'Schmierstoffe / Schutzmittel – Sets',
  10005284: 'Einfachfenster – mit Holzverkleidung',
  10005285: 'Einfachfenster – ohne Holzrahmen (Kunststoff– / Aluminiumfenster)',
  10005286:
    'Fenstersysteme / Doppelfenster – ohne Holzrahmen (Kunststoff– / Aluminiumfenster)',
  10005287: 'Fenstersysteme / Doppelfenster – mit Holzverkleidung',
  10005288: 'Lichtröhren',
  10005289: 'Dachfenster – mit Holzrahmen',
  10005290: 'Fenster – sonstige',
  10005291: 'Markisen (handbetrieben)',
  10005292: 'Fenster – Teile / Zubehör – sonstige',
  10005293: 'Fenster–Ersatzschiebeflügel (nicht aus Holz)',
  10005294: 'Fenster–Ersatzschiebeflügel (aus Holz)',
  10005295: 'Erkerfenster – Massivholz',
  10005296: 'Erkerfenster – ohne Holzrahmen (Kunststoff– / Aluminiumfenster)',
  10005297: 'Erkerfenster – mit Holzverkleidung',
  10005298: 'Fenster–Bedienvorrichtungen',
  10005306: 'Flaschen / Behälter / Kanister für flüssige Brennstoffe (leer)',
  10005316: 'Wetterstationen (elektrisch)',
  10005317: 'Klimaanlagen – mobil',
  10005318: 'Windmesser (Anemometer)  (elektrisch)',
  10005319: 'Gartenthermometer (elektrisch)',
  10005320: 'Niederschlagsmesser (elektrisch)',
  10005321: 'Schweißsprays / Schweißpaste',
  10005322: 'Dunstabzugshauben',
  10005323: 'Hygrometer (elektrisch)',
  10005331: 'Luftbefeuchter – mobil',
  10005332: 'Luftentfeuchter – mobil (elektrisch)',
  10005333: 'Luftionisierer – mobil',
  10005334: 'Luftkühler – mobil',
  10005335: 'Klimageräte – multifunktionell – mobil',
  10005336: 'Luftreiniger – mobil',
  10005337: 'Ventilatoren – mobil',
  10005342: 'Wärmebarrieren / Hitzeschilde',
  10005343: 'Dämmplatten (außen)',
  10005345: 'Isolierung / Dämmstoffe – Befestigungen',
  10005355: 'Weichholz–Bretter',
  10005356: 'Schmierstoffe – Sets',
  10005357: 'Eiscrusher / Eiswürfelbereiter (elektrisch)',
  10005358: 'Plätzchenpressen (elektrisch)',
  10005359: 'Warmhalteplatten (elektrisch)',
  10005360: 'Blattglanzprodukte',
  10005361: 'Briefkästen (Garten)',
  10005362: 'Tierabwehrmittel / –abschreckungsmittel – nicht elektrisch',
  10005365: 'Kurzzeitwecker / Eieruhren (elektrisch)',
  10005366: 'Blume / Pflanzen – Zubehör',
  10005367: 'Regale / Arbeitsflächen für Gartengeräte / Gartenarbeit',
  10005368: 'Gartenabfallsysteme / Komposter – Ersatzteile / Zubehör',
  10005369: 'Treibhausheizungen / –ventilatoren',
  10005370: 'Bodenbläge – Mehrschichtparkett',
  10005371: 'Büroscheren',
  10005372: 'Zeichenbretter (Künstlerbedarf)',
  10005373: 'Tragbare Alarmvorrichtungen',
  10005374: 'Notsignalpfeifen',
  10005375: 'Schlüsselring–Alarmsysteme',
  10005376: 'Gepäckalarmsysteme',
  10005377: 'Sicherheits–Leuchtgeschosse / –Leuchtkugeln / –Signale',
  10005378: 'Sicherheitsleuchten',
  10005379: 'Selbstverteigigungs–Sprays',
  10005380: 'Elekroschocker',
  10005381: 'Tragbare schnurlose Webcams (inverse Überwachung)',
  10005382: 'Persönliche Schutzvorrichtungen  – Sets',
  10005383: 'Feuerhemmer / Funkenlöscher',
  10005384: 'Feuerleitern / Notrutschen',
  10005385: 'Öffentlicher Feueralarmsysteme',
  10005386: 'Brandschutzhauben / Atemschutzgeräte',
  10005387: 'Brandschutz– / Chemikaliensicherheitsprodukte  – Sets',
  10005388: 'Drucklufthörner / Nebelhörner',
  10005389: 'Rettungsringe / Schwimmwesten / Schutzanzüge',
  10005390: 'Rettungsfloße / Rettungsbojen / Rettungskissen',
  10005391: 'Blitzableiter und Zubehör',
  10005392: 'Sandsäcke / Wasserbarrieren',
  10005393: 'Sturmschutzräume',
  10005394: 'Ortungssysteme / Transponder',
  10005395: 'Wetter–/Naturkatstrophen–Sicherheitsprodukte  – Sets',
  10005396: 'Einbruchswarnanlagen / Alarmanlagen',
  10005397: 'Gas- / Hitze- / Rauchmelder',
  10005398: 'Zugangskontroll–Sicherheitssysteme',
  10005399: 'Tür– / Tor–Gegensprechanlagen',
  10005400: 'Tür– / Tor– / Fenster – Sicherungen',
  10005401: 'Türketten',
  10005402: 'Tür- / Tor-Spione',
  10005403: 'Sicherheitstüren / -tore',
  10005405: 'Fenstergitter / Rolläden (Einbruchsicherungen)',
  10005406: 'Türen- / Fenster- / Grundstücks-Sicherheitsprodukte – Sets',
  10005407: 'Feuerdecken',
  10005408: 'Feuerlöscher – druckbefüllt',
  10005409: 'Feuerlöschschläuche',
  10005410: 'Brandschutz  – Sets',
  10005411: 'Abhörausrüstung / Aufspürgeräte für Abhörausrüstungen',
  10005412: 'Licht– / Bewegungs– / Geräuschmelder',
  10005413: 'Sicherheitsbeleuchtung',
  10005414: 'Überwachungskameras / Videosystemer',
  10005415: 'Gebäude–Überwachungsausrüstung – Sets',
  10005416: 'Safes / Panzerschränke',
  10005417: 'Sicherheit / Schutz / Überwachung – Gebäude – Sets',
  10005418: 'Sicherheit / Schutz / Überwachung – Sets',
  10005424: 'Stangen / Pfähle / Stäbe',
  10005425: 'Treppen – Ersatzteile / Montageteile',
  10005426: 'Lebensmittelpinsel / Ölzerstäuber / Speisepipetten',
  10005427: 'Eierbecher',
  10005428: 'Türpfosten / Fensterpfosten',
  10005429: 'Küchentrichter',
  10005430: 'Speiseformen / Puddingformen / Eisformen',
  10005431: 'Dekorative Elemente / Treppenteile – sonstige',
  10005432: 'Dekorative Elemente / Treppenteile – Sets',
  10005434: 'Plätzchenpressen / Garnierspritzen (nicht elektrisch)',
  10005435: 'Milchaufschäumer (nicht elekrisch)',
  10005436: 'Partytröten',
  10005437: 'Möbelrollen / Filzgleiter / Gleitblöcke',
  10005438: 'Computerhalterungen / –Ständer',
  10005439: 'Frisierpuppen (nicht elektrisch)',
  10005440: 'Frisierpuppen (elektrisch)',
  10005441: 'Kinderfahrzeuge – Zubehör',
  10005442: 'Spielzeug–Zeichenbretter / Zubehör',
  10005443: 'Scherzartikel',
  10005444: 'Klebstoffentferner',
  10005445: 'Overhead Projektoren',
  10005446: 'Insekten',
  10005447: 'Arachnide (Spinnen / Skorpione)',
  10005448: 'Ringelwürmer (Würmer)',
  10005449: 'Weichtiere',
  10005450: 'Krustentiere',
  10005451: 'Schwämme',
  10005452: 'Seesterne / Seeigel',
  10005453: 'Quallen',
  10005454: 'Korallen / Seeanemonen',
  10005455: 'Nagetiere',
  10005456: 'Fische',
  10005457: 'Vögel',
  10005458: 'Amphibien',
  10005459: 'Primaten',
  10005460: 'Katzen',
  10005461: 'Rinder (Vieh)',
  10005462: 'Ziegen',
  10005463: 'Pferde / Esel (Equidae)',
  10005464: 'Schweine',
  10005465: 'Schafe (Ovis)',
  10005466: 'Reptilien',
  10005467: 'Beuteltiere',
  10005468: 'Hasen / Kaninchen (Lagomorpha)',
  10005469: 'Wale / Delfine / Schweinswale (Cetacea)',
  10005470: 'Flachen– / Getränkedosenkühler (Überzieher)',
  10005471: 'Türzubehör',
  10005472: 'Notfalldecken / –schlafsäcke',
  10005473: 'Alarmsysteme  – Ersatzteile / Zubehör',
  10005474: 'Streusalz / Antifrost–Produkte',
  10005475: 'Wirbellose Tiere – sonstige',
  10005476: 'Wirbeltiere – sonstige',
  10005478: 'Kamin und Kamineifassungen / –simse',
  10005479: 'Durchlauferhitzer',
  10005480: 'Siphons (Geruchsverschluss)',
  10005481: 'Starter / Vorschaltgeräte',
  10005496: 'Adapter',
  10005505: 'Abdeckungen / Blenden (Elektroinstallation)',
  10005541: 'Elektrodrähte',
  10005546: 'Erdungsbänder / –Seile',
  10005559: 'Verlängerungskabel / Kabeltrommeln',
  10005560: 'Türklingeln / –Glocken / –Summer',
  10005567: 'Steckdosen / Steckerbuchsen / Ausgänge',
  10005568: 'Verteiler / Splitter',
  10005570: 'Relais / Schaltschütze',
  10005571: 'Kabel–Einziehhilfen',
  10005572: 'Elektrische Verbindung – Sets',
  10005573: 'Steckverbinder / Kabelschuhe',
  10005575: 'Stromschienen / Stromschienensysteme',
  10005576: 'Leitungsschutzschalter / Sicherungsautomaten',
  10005577: 'Elektrische Verteilung – Zubehör / Halterungen',
  10005583: 'Sicherungskästen / Verteilerkästen',
  10005585: 'Überspannungsschutz',
  10005586: 'Schalter',
  10005588: 'Anschlussleisten / Klemmleisten',
  10005599: 'Multimeter',
  10005622: 'Kondensatoren',
  10005625: 'Hunde',
  10005626: 'Absorptionsmittel (Do–it–yourself)',
  10005627: 'Anti–Ermüdungshilfen (Do–it–yourself)',
  10005628: 'Anti–Rutschhilfen (Do–it–yourself)',
  10005630: 'Sicherheitsnetze / Vorhänge / Absperrungen',
  10005631: 'Schutzvorrichtungen – Ersatzteile / Zubehör',
  10005632: 'Mineralische Baustoffe / Asphaltbaustoffe – Ersatzteile / Zubehör',
  10005633: 'Lampenfassungen',
  10005634: 'Dimmer',
  10005635: 'Lampenschirme',
  10005636: 'Lampenfüße / Lampenständer',
  10005637: 'Lampenhalter',
  10005638: 'Glühbirnenwechsler',
  10005639: 'Leuchten – festinstalliert',
  10005640: 'Glasfaserleuchten',
  10005641: 'Leuchten – freistehend',
  10005642: 'Taschenlampen (elektrisch)',
  10005643: 'Elektrische Laternen – mobil',
  10005644: 'Lichterketten / Lichtschläuche',
  10005645: 'Handwerkzeuge / Arbeitsgeräte – Sets',
  10005646: 'Schutzvorrichtungen – sonstige',
  10005647: 'Kabelkanäle / –Führungsschienen',
  10005648: 'Kabelkennzeichnungen / –Beschriftungen',
  10005649: 'Kabelrollen',
  10005650: 'Kabelmäntel / –Schutzumhüllungen',
  10005651: 'Kabelschellen / Durchführungstüllen / Kabelbinder',
  10005653: 'Mal– und Lackiergeräte – elektrisch',
  10005654: 'Mal– / Streichwerkzeuge – manuell',
  10005655: 'Farbzusätze',
  10005656: 'Mal– / Streichwerkzeuge – Zubehör',
  10005657: 'Holzschutzlasuren / –Mittel',
  10005658: 'Rohreinfriergeräte',
  10005659: 'Dachstühle',
  10005660: 'Kabelkanal / Kabelführung – Verbindungen / Befestigungen',
  10005661: 'Schaltkreis–Baugruppen / integrierte Schaltkreise',
  10005662: 'Elektronische Bauelemente (aktiv und passiv)',
  10005667: 'Zubehör für elektronische Schaltungen',
  10005668: 'Ablaufgitter (Dachrinnen / Drainage)',
  10005669: 'Arbeitsleuchte / Werkstattleuchte / Handlampe – mobil',
  10005670: 'Befestigungsmaterial – Zubehör',
  10005672: 'Wand– / Deckenverkleidungs–Werkzeuge (nicht elektrisch)',
  10005673: 'Tor– / Garagentor–Öffnungssysteme',
  10005674: 'Kabelkennzeichnung / –Beschriftung –  Zubehör',
  10005675: 'Kochgeschirr / Backformen – Ersatzteile / Zubehör',
  10005676: 'Schreibmaschinen – Verbrauchsmaterial',
  10005677: 'Faxgeräte – Verbrauchsmaterialien',
  10005678: 'Gartenzäune / Garteneinfriedeungen  – Zubehör',
  10005679: 'Flaschenzüge',
  10005680: 'Telefon–Reinigungstücher',
  10005681: 'Kommunikationsgeräte – Festnetz / kabelgebunden – Zubehör',
  10005682: 'Zeitschaltuhren / Control Panels',
  10005683: 'Computer / PC– / Videospiele – Massenspeicher',
  10005684: 'Rollenspiel–Spielzeuge – Haushalts– / Gärtner– / DIY–Spielzeuge',
  10005685: 'Rollenspiel–Spielzeuge – Kaufladen / Büro / Berufe',
  10005686: 'Digitalstifte',
  10005687: 'Lacke',
  10005688: 'Raffhaken / Drapierhaken',
  10005689: 'Wassereis– / Slushmaschinen (elektrisch)',
  10005690: 'Schokoladenbrunnen (elektrisch)',
  10005691: 'Korkenzieher / Flaschenöffner (elektrisch)',
  10005692: 'Dekorationsgegenstände – Zubehör',
  10005693: 'Salz– / Pfefferstreuer',
  10005694: 'Mehlsiebe / Zuckerstreuer',
  10005695: 'Küchenwaagen (elektrisch)',
  10005697: 'Klimageräte (mobil) – Ersatzteile / Zubehör',
  10005700: 'Digitale Bilderrahmen',
  10005701: 'Küchenschüsseln',
  10005702: 'Pumpen (Handpumpen)',
  10005703: 'Pumpen (elektrisch)',
  10005704: 'Hot Dog–Rollengrills',
  10005705: 'Außenverkleidungszubehör',
  10005706: 'Farbsiebe',
  10005707: 'Markierkreiden / Maurerschnüre',
  10005708: 'Pinsel / Farbrollen / Applikatoren (Haushalt)',
  10005709: 'Sicherheitsspiegel',
  10005710: 'Lautsprecher (tragbar)',
  10005711: 'Personal Broadcasting–Geräte',
  10005712: 'Spielzeugcomputer–Zubehör',
  10005713: 'Schaumstoff–Bastelmaterialien',
  10005714: 'Trichter (Do–it–yourself)',
  10005715: 'Drahtbürsten',
  10005716: 'Winkellehren',
  10005717: 'Raumheizgeräte',
  10005718: 'Nutfräsmaschinen',
  10005719: 'Gartendekorationsartikel',
  10005720: 'Montage– / Werkstatt–Rollbretter',
  10005721: 'Latten',
  10005722: 'Kantenschutzprodukte',
  10005723: 'Werkstatt–Putzlappen / -Putztücher',
  10005724: 'Masker (Abdeckfolien– / –Papiere mit Klebeband)',
  10005725: 'Sicherheits–Absperrbänder',
  10005726: 'Analog– / Digital–Wandler',
  10005727: 'Lippenbalsame',
  10005728: 'Kfz–Radarfallendetektoren',
  10005729: 'Bodenabdeckung / Landschaftsbau– / Mulchfolien',
  10005730:
    'Geräte für kreative Wandgestaltung (Wisch– / Marmorier– / Tupftechnik)',
  10005731:
    'Sockelverkleidungen (Haus)  / Umrandungen für Wohnwagen / Mobilheime',
  10005732: 'Wohnwagen / Wohnmobil – Montage– / Aufstell–Zubehör',
  10005733: 'Rohr–Dämmungen / Rohr–Umhüllungen',
  10005735: 'Video–Splitter / –Verteiler',
  10005736: 'Rauscharmer Signalumsetzer (LNB)',
  10005738: 'TV–Empfang / Installation – Zubehör',
  10005739: 'TV–Empfang / Installation – Sets',
  10005740: 'DECT–Repeater (Signalverstärker)',
  10005741: 'Computer / PC– / Videospiele – Headsets (Kopfhörer mit Mikrofon)',
  10005742: 'Spannungsmesser / Testgeräte',
  10005743: 'Drehplatten / Drehteller',
  10005744: 'Audio / Video – Zubehör – Beschriftungssysteme',
  10005745: 'Freisprechanlagen / Headsets – Ersatzteile / Zubehör',
  10005746: 'Vibrationsdämpfer (Audio)',
  10005747: 'MP3–Dockingstationen',
  10005748: 'Speicherkartenrekorder',
  10005749: 'Kfz–GPS–Antennen',
  10005750: 'Blitzgeräte–Zubehör',
  10005751: 'Dias – Ersatzteile / Zubehör',
  10005752: 'Dia–Magazine / –Boxen',
  10005753: 'Studioblitze',
  10005754: 'Computerkabel',
  10005755: 'Fotokamera–Filter',
  10005756: 'Schlüsselringe',
  10005757: 'Audiovisuelle Kabel',
  10005758: 'Telekommunikationskabel',
  10005759: 'Satelliteninstallationskabel',
  10005760: 'Satelliten–Empfangszubehör',
  10005761: 'Klimaanlagen–Kältemittel',
  10005762: 'Staubsaugerbeutel',
  10005763: 'Spielkonsolen – Zubehör',
  10005764: 'Batterieaufbewahrungsboxen',
  10005765: 'FM–Transmitter (tragbar)',
  10005766: 'Projektionstische',
  10005767: 'Rindfleisch – bearbeitet / verarbeitet',
  10005768: 'Bison– / Büffelfleisch – bearbeitet / verarbeitet',
  10005769: 'Huhn – bearbeitet / verarbeitet',
  10005770:
    'Hirsch (Wildfleisch) mit Ausnahme von Rehwild  – bearbeitet / verarbeitet',
  10005771: 'Ente – bearbeitet / verarbeitet',
  10005772: 'Frosch – bearbeitet / verarbeitet',
  10005773: 'Ziegenfleisch – bearbeitet / verarbeitet',
  10005774: 'Pferdefleisch – bearbeitet / verarbeitet',
  10005776: 'Landschnecken – bearbeitet / verarbeitet',
  10005777: 'Lama / Alpaka – bearbeitet / verarbeitet',
  10005778:
    'Verschiedene Fleisch– / Geflügelarten – Mischungen – bearbeitet / verarbeitet',
  10005779: 'Straußenfleisch – bearbeitet / verarbeitet',
  10005780: 'Fasan – bearbeitet / verarbeitet',
  10005781: 'Schweinefleisch – bearbeitet / verarbeitet',
  10005782: 'Kaninchen – bearbeitet / verarbeitet',
  10005783: 'Sonstige Fleisch– / Geflügelarten – bearbeitet / verarbeitet',
  10005784: 'Truthahn – bearbeitet / verarbeitet',
  10005785: 'Kalbfleisch – bearbeitet / verarbeitet',
  10005786: 'Rindfleisch – nicht bearbeitet / verarbeitet',
  10005787: 'Bison– / Büffelfleisch – nicht bearbeitet / verarbeitet',
  10005788: 'Huhn – nicht bearbeitet / verarbeitet',
  10005789:
    'Hirsch (Wildfleisch) mit der Ausnahme von Rehwild – nicht bearbeitet / verarbeitet',
  10005790: 'Ente – nicht bearbeitet / verarbeitet',
  10005791: 'Frosch – nicht bearbeitet / verarbeitet',
  10005792: 'Ziegenfleisch – nicht bearbeitet / verarbeitet',
  10005793: 'Pferdefleisch – nicht bearbeitet / verarbeitet',
  10005795: 'Landschnecken – nicht bearbeitet / verarbeitet',
  10005796: 'Lama / Alpaka – nicht bearbeitet / verarbeitet',
  10005797:
    'Verschiedene Fleisch– / Geflügelarten – Mischungen – nicht bearbeitet / verarbeitet',
  10005798: 'Straußenfleisch – nicht bearbeitet / verarbeitet',
  10005799: 'Fasan – nicht bearbeitet / verarbeitet',
  10005800: 'Schweinefleisch – nicht bearbeitet / verarbeitet',
  10005801: 'Kaninchenfleisch – nicht bearbeitet / verarbeitet',
  10005802:
    'Sonstige Fleisch– / Geflügelarten – nicht bearbeitet / verarbeitet',
  10005803: 'Truthahn– nicht bearbeitet / verarbeitet',
  10005804: 'Kalbfleisch – nicht bearbeitet / verarbeitet',
  10005805: 'Druckluft–Farbspritzpistolen / Sprühvorrichtungen',
  10005806: 'Frästische',
  10005807: 'PA–Anlagen / Beschallungsanlagen (tragbar)',
  10005808: 'USB–Audio–Schnittstellen',
  10005809: 'Lichteffektgeräte / Lichtorgeln',
  10005810: 'Bartheken',
  10005811: 'Bürstkehrer / Teppichkehrer (nicht elektrisch)',
  10005812: 'Entfernungsmesser (Sport)',
  10005813: 'Elektronische Gutscheinkarten',
  10005814: 'Scooter/Skateboards/Hoverboards (angetrieben)',
  10005815: 'Räder (angetrieben)',
  10005816: 'Fahnen / Flaggen',
  10005817: 'Tragetaschen (einweg)',
  10005818: 'Rad–Unterlegkeile',
  10005819: 'Laderampen / Laderampenzubehör',
  10005820: 'Kfz–Warnflaggen / Kfz–Fahnenstangen',
  10005821: 'Kfz–Sicherheits–Schlauchbrücken',
  10005822: 'Karamell– / Schokoäpfel',
  10005823: 'Fleischersatz (tiefgefroren)',
  10005824: 'Fleischersatz (leicht verderblich)',
  10005825: 'Fleischersatz (ohne Kühlung haltbar)',
  10005826:
    'Produkte / Gerichte auf Basis von Molkereierzeugnissen – nicht verzehrbereit (leicht verderblich)',
  10005827:
    'Produkte / Gerichte auf Basis von Molkereierzeugnissen  – nicht verzehrbereit (tiefgefroren)',
  10005828: 'Kfz–Audio – Subwoofer',
  10005829:
    'Kombinationssysteme für Satellitenempfang / terrestrischen Empfang',
  10005830: 'Dampfbügelstationen',
  10005831: 'USB Internet–Sticks',
  10005832: 'Sonstige Würste (Fleisch / Geflügel) – bearbeitet / verarbeitet',
  10005833: 'Würste (Rindfleisch) – bearbeitet / verarbeitet',
  10005834: 'Würste (Hühnerfleisch) – bearbeitet / verarbeitet',
  10005835: 'Würste (Lamm– / Hammelfleisch) – bearbeitet / verarbeitet',
  10005836: 'Würste aus verschiedenen Fleischsorten – bearbeitet / verarbeitet',
  10005837: 'Würste (Truthahnfleisch) – bearbeitet / verarbeitet',
  10005838: 'Würste (Kalbfleisch) – bearbeitet / verarbeitet',
  10005839:
    'Kombinationsgeräte Zahnbürste / Munddusche / Aufbewahrung (elektrisch)',
  10005840: 'Würste (Schweinefleisch) – bearbeitet / verarbeitet',
  10005841: 'AV–Receiver',
  10005842: 'Mobile Speicherstationen für Digitalfotos / Fotofestplatten',
  10005843: 'Videoeditor',
  10005844: 'Medizinprodukte',
  10005845: 'Arzneimittel',
  10005846: 'Fässer / Tonnen / Kegs (leer)',
  10005847: 'Fässer (zylindrisch) (leer)',
  10005848: 'Lager- / Transportboxen / -kisten (leer)',
  10005849: 'Lager– / Transportkisten (offen) / –steigen / –verschläge (leer)',
  10005850: 'Lager– / Transport–Trays (leer)',
  10005851: 'Flaschen (leer)',
  10005852: 'Gasflaschen / Gaszylinder / Zylinder (transportabel) (leer)',
  10005853: 'Lager– / Transporttanks (leer)',
  10005854: 'Paletten',
  10005855: 'Plattformwagen / Möbelhunde',
  10005856: 'Zwischenlagen (für Paletten)',
  10005857: 'Palettenaufsatzrahmen',
  10005858: 'Rollwagen / Paketwagen',
  10005859: 'ISO–Container / Ocean Intermodal Freight Container (leer)',
  10005860: 'Luftfrachtcontainer (leer)',
  10005861: 'Bigbags (Flexible Bulk Container) (leer)',
  10005862: 'Rigid Intermediate Bulk Container (IBC) (leer)',
  10005863: 'Rückflussverhinderer–Testgeräte',
  10005864: 'Sicherheitsventile / Vakuumbrecher',
  10005865: 'Rückflussverhinderer – Teile / Zubehör',
  10005866: 'Rückflussverhinderer',
  10005867: 'Rohrflansche',
  10005868: 'Party–Trinkbrunnen (elektrisch)',
  10005869: 'Balkensucher / Balkenortungsgeräte',
  10005870: 'Fischfinder',
  10005872: 'Nautische Navigationsgeräte',
  10005873: 'Nautische Navigation – Software',
  10005874: 'Nautische Navigation – Radarsysteme',
  10005875: 'Solaranlagen',
  10005876: 'Grapefruits',
  10005877: 'Pampelmusen',
  10005878: 'Pomelos / Honigpomelos',
  10005879: 'Sweeties / Oroblancos',
  10005880: 'Tangelos',
  10005881: 'Uglis',
  10005882: 'Zitronen',
  10005883: 'Echte Limetten',
  10005884: 'Limetten',
  10005885: 'Limequats',
  10005886: 'Clementinen',
  10005887: 'Satsumas',
  10005888: 'Tangerinen / andere Manderinen',
  10005889: 'Orangen',
  10005893: 'Schreibhefte',
  10005894: 'Haushalts–Handschuhe',
  10005895: 'Apfel–Bananen',
  10005896: 'Baby–Bananen',
  10005897: 'Bananen (Cavendish)',
  10005898: 'Kochbananen',
  10005899: 'Rote Bananen',
  10005900: 'Äpfel',
  10005901: 'Japanische Wollmispeln',
  10005902: 'Nashis',
  10005903: 'Birnen',
  10005905: 'Aprikosen',
  10005907: 'Sauerkirschen',
  10005908: 'Süßkirschen',
  10005909: 'Kriechen–Pflaumen / Hafer–Pflaumen',
  10005910: 'Mirabellen',
  10005911: 'Nektarinen',
  10005912: 'Pfirsiche',
  10005913: 'Edel–Pflaumen / Renekloden',
  10005914: 'Chinesische Pflaumen',
  10005915: 'Plumcots',
  10005916: 'Kernobst-Hybride',
  10005917: 'Zwetschgen',
  10005918: 'Tafeltrauben',
  10005921: 'Erdbeeren',
  10005922: 'Wald–Erdbeeren',
  10005923: 'Brombeeren',
  10005924: 'Boysenbeeren / Kratzbeeren',
  10005925: 'Moltebeeren',
  10005927: 'Himbeeren',
  10005928: 'Wild–Blaubeeren / Wild–Heidelbeeren',
  10005929: 'Amerikanische Heidelbeeren / Kulturheidelbeeren',
  10005930: 'Cranberries',
  10005932: 'Stachelbeeren',
  10005934: 'Jostabeeren',
  10005935: 'Ananas',
  10005937: 'Kiwis',
  10005938: 'Kiwibeeren, Scharfzähnige Strahlengriffel',
  10005939: 'Cherimoyas',
  10005940: 'Zuckeräpfel / Zimtäpfel',
  10005941: 'Netzannonen',
  10005942: 'Stachelannonen / Guanabanas',
  10005946: 'Kakis',
  10005948:
    'Amerikanische Persimone / Amerikanische Kakipflaume / Virginia Kakis',
  10005949: 'Barbadinen',
  10005950: 'Curubas / Bananenpassionsfrucht',
  10005951: 'Süße Granadillen',
  10005952: 'Gelbe Passionsfrüchte / Maracuyas',
  10005953: 'Purpur–Grenadillen',
  10005954: 'Formosa–Papayas',
  10005955: 'Berg–Papaya',
  10005956: 'Gelbe Pithayas',
  10005957: 'Süße Pitahayas / Drachenfrüchte',
  10005959: 'Datteln',
  10005960: 'Feigen',
  10005961: 'Karambolen',
  10005963: 'Bilimbis',
  10005964: 'Litschis',
  10005965: 'Physalis / Kapstachelbeeren',
  10005966: 'Rambutan',
  10005967: 'Kaktusfeigen',
  10005968: 'Mangostane',
  10005969: 'Mangos',
  10005970: 'Granatäpfel',
  10005971: 'Guaven',
  10005972: 'Durianfrüchte',
  10005973: 'Brotfrüchte',
  10005974: 'Jackfrüchte',
  10005976: 'Gartenbohnen / Grüne Bohnen',
  10005979: 'Feuerbohnen',
  10005980: 'Ackerbohnen',
  10005981: 'Riesenbohnen',
  10005982: 'Mondbohnen / Limabohnen',
  10005984: 'Erbsen',
  10005985: 'Zuckererbsen',
  10005986: 'Johannisbrotschote / Carob',
  10005987: 'Blumenkohl',
  10005988: 'Brokkoli',
  10005996: 'Rosenkohl',
  10005997: 'Rotkohl',
  10005999: 'Weißkohl',
  10006000: 'Wirsingkohl',
  10006003: 'Knoblauch',
  10006004: 'Acker–Knoblauch',
  10006005: 'Lauchzwiebeln / Frühlingszwiebeln',
  10006006: 'Zwiebeln',
  10006007: 'Perlzwiebeln',
  10006009: 'Schalotten',
  10006014: 'Gurken',
  10006015: 'Zucchini / Gartenkürbisse',
  10006031: 'Austern–Seitlinge',
  10006032: 'Morcheln',
  10006033: 'Pfifferlinge / Eierschwammerln',
  10006034: 'Shiitake–Pilze',
  10006035: 'Steinpilze',
  10006036: 'Trüffel',
  10006037: 'Wassermelonen',
  10006038: 'Kürbis / Riesenkürbisse',
  10006040: 'Bärlauch',
  10006041: 'Basilikum',
  10006044: 'Beifuß',
  10006045: 'Sommer–Bohnenkraut',
  10006046: 'Winterbohnenkraut',
  10006047: 'Borretsch',
  10006048: 'Brunnenkresse',
  10006049: 'Dill',
  10006050: 'Engelwurz',
  10006051: 'Estragon',
  10006052: 'Fenchel',
  10006053: 'Kerbel',
  10006054: 'Koriander',
  10006055: 'Kresse',
  10006056: 'Kümmel',
  10006057: 'Liebstöckel',
  10006058: 'Lorbeer',
  10006059: 'Majoran',
  10006060: 'Türkischer Oregano',
  10006061: 'Zitronenmelisse',
  10006063: 'Minze',
  10006065: 'Süßdolde / Myrrhenkerbel',
  10006066: 'Oregano',
  10006071: 'Anis / Bibernellen / Pimpinellen',
  10006072: 'Rosmarin',
  10006074: 'Schnittlauch',
  10006075: 'Thymian',
  10006076: 'Zitronenthymian',
  10006077: 'Ysop',
  10006078: 'Zitronenverbene',
  10006079: 'Kopfsalat (Buttersalat)',
  10006085: 'Romanasalat / Römersalat',
  10006086: 'Feldsalat',
  10006088: 'Rauke / Rukola',
  10006089: 'Grün vom Löwenzahn',
  10006090: 'Sauerampfer',
  10006091: 'Spinat',
  10006092: 'Portulak',
  10006093: 'Chicorée (Brüsseler Endivie)',
  10006094: 'Radicchio Rosso',
  10006095: 'Eskariol',
  10006097: 'Endivie (kraus)',
  10006100: 'Gemüsepaprika (spitz)',
  10006102: 'Chilischoten',
  10006104: 'Kartoffeln',
  10006107: 'Taros',
  10006108: 'Kassavas / Manioks',
  10006109: 'Lila Tannia',
  10006110: 'Weiße Tannia',
  10006111: 'Süßkartoffeln',
  10006112: 'Yamswurzeln',
  10006113: 'Ingwer',
  10006114: 'Radieschen',
  10006115: 'Speise–Rettiche / Winter–Rettiche',
  10006116: 'Mairüben',
  10006117: 'Rübenblätter / Rübstiele',
  10006118: 'Steckrüben / Schmalzrüben (Kohlrüben)',
  10006119: 'Teltower Rübchen',
  10006120: 'Weiße Rüben',
  10006121: 'Rüben / Rote Beete',
  10006122: 'Möhren / Karotten',
  10006123: 'Knollensellerie',
  10006124: 'Meerrettich / Kren',
  10006125: 'Topinaburen',
  10006126: 'Pastinaken',
  10006127: 'Petersilienwurzeln (Hamburg)',
  10006128: 'Auberginen',
  10006129: 'Spargel',
  10006130: 'Artischocken',
  10006131: 'Sellerie',
  10006133: 'Lauch / Porree',
  10006134: 'Rhabarber',
  10006135: 'Kardonen',
  10006136: 'Palmherzen',
  10006137: 'Bambussprossen',
  10006143: 'Chinakohl',
  10006144: 'Grünkohl',
  10006145: 'Pak–Choi',
  10006146: 'Kohlrabi',
  10006147: 'Zuckermais',
  10006148: 'Okra',
  10006155: 'Endivie (breite Blätter)',
  10006157: 'Gemeiner Kultur–Champignons',
  10006158: 'Spargelbohnen',
  10006159: 'Zitronengras',
  10006160: 'Feijoas',
  10006161: 'Kirschtomaten – länglich',
  10006162: 'Kirschtomaten – rund',
  10006163: 'Tomaten – länglich',
  10006164: 'Tomaten – gerippt',
  10006165: 'Tomaten – rund',
  10006166: 'Tomaten – Mischpackungen',
  10006167: 'Cocktail–Avocados',
  10006168: 'Hass–Avocados – raue Schale',
  10006169: 'Fuerte–Avocados – glatte Schale',
  10006171: 'Gemüse – nicht bearbeitet / verarbeitet (frisch) – Mischpackungen',
  10006172: 'Obst – nicht bearbeitet / verarbeitet (frisch) – Mischpackungen',
  10006173: 'Quitten',
  10006190: 'Gemüsepaprika (stumpf zulaufend)',
  10006191: 'Gemüsepaprika (keilförmig zulaufend)',
  10006192: 'Platte Gemüsepaprika (Apfelpaprika)',
  10006193: 'Rote Johannisbeere',
  10006194: 'Schwarze Johannisbeere',
  10006195: 'Gemüsepaprika – Mischpackungen',
  10006196: 'Romanesco',
  10006197: 'Spitzkohl',
  10006198: 'Petersilie (kraus)',
  10006199: 'Glatte Petersilie (Italienisch)',
  10006200: 'Schwarzwurzeln',
  10006201: 'Auslagen (Kosmetik)',
  10006202: 'unsortierte Eier in der Schale',
  10006203: 'verunreinigte / beschädigte Eier in der Schale',
  10006204: 'Eierextrakte',
  10006210: 'Konsumeier in der Schale',
  10006211: 'Hartgekochte Eier (individuell)',
  10006212: 'Eierprodukte / Volleiersatz (eihaltig)',
  10006213: 'Eierersatz (nicht eihaltig)',
  10006214: 'Extrakte / Gewürze / Geschmacksverstärker (ohne Kühlung haltbar)',
  10006215: 'Spender für Reinigungs– / Hygieneprodukte',
  10006216: 'Fertigsuppen – Mischpackungen',
  10006217: 'Sandwiches / Belegte Brötchen / Wraps – Mischpackungen',
  10006218: 'Soja– / Reismilchmaschinen',
  10006219: 'Teigwaren / Nudeln – Mischpackungen',
  10006220: 'Desinfektions–Kabinett',
  10006221: 'Gemüsebasierte Produkte/ – Speisen / – Mischpackungen',
  10006222: 'Teigbasierte Produkte/- Gerichte – Mischpackungen',
  10006223: 'Schilder, Vorbedruckt',
  10006224: 'Schilder, Unbedruckt',
  10006225: 'Schilder, Kombination',
  10006226: 'Halterungen für Schilder',
  10006227: 'Schilder – Ersatzteile / Zubehör',
  10006228: 'Gertreidebasierte Produkte/-Gerichte – Mischpackungen',
  10006229:
    'Produkte / Gerichte auf Basis von Molkereierzeugnissen / Ei–Erzeugnissen – Mischpackungen',
  10006230: 'Fleischersatz – Mischpackungen',
  10006231: 'Stangen',
  10006232: 'Händetrockner',
  10006233: 'Lebensmittelbehandlung',
  10006234: 'Desinfektionsmittel – Oberflächen',
  10006235: 'Computer– / PC– / Videospiele–Spielesoftware – Digital',
  10006236: 'Computer Software (keine Spiele) – Digital',
  10006237: 'GPS–Software – digital',
  10006238: 'Software für Mobiltelefone – digital',
  10006239: 'Musik – digital',
  10006240: 'Audio (keine Musik) – Digital',
  10006241: 'Filme – digital',
  10006242: 'Videos (keine Filme) – digital',
  10006243: 'Klingeltöne – digital',
  10006244: 'Fernsehshows – digital',
  10006245: 'Grafiken – digital',
  10006246: 'Zubehör / Spielzeuge für die Penetration (elektrisch)',
  10006247: 'Zubehör / Spielzeug für die Penetration (nicht elektrisch)',
  10006248: 'Saugvorrichtungen (elektrisch)',
  10006249: 'Saugvorrichtungen (nicht elektrisch)',
  10006250: 'Cerealien – nicht verzehrbereit (tiefgefroren)',
  10006251: 'Gemüsesaft – trinkfertig (leicht verderblich)',
  10006252: 'Gemüsesaft – trinkfertig (ohne Kühlung haltbar)',
  10006253: 'Gemüsesaft – nicht trinkfertig (tiefgefroren)',
  10006254: 'Gemüsesaft – nicht trinkfertig (ohne Kühlung haltbar)',
  10006255: 'Gemüsesaftgetränke – trinkfertig (leicht verderblich)',
  10006256: 'Gemüsesaftgetränke – trinkfertig (ohne Kühlung haltbar)',
  10006257: 'Gemüsesaftgetränke – nicht trinkfertig (ohne Kühlung haltbar)',
  10006258: 'Abdichtpistole (nicht elektrisch)',
  10006259: 'Keimling – verzehrfertig',
  10006260: 'Sprossen',
  10006261: 'Essbare Blumen',
  10006262: 'Gemüse aus dem Meer – sonstige',
  10006263: 'Buchenrasling',
  10006264: 'Samtfußrübling',
  10006265: 'Kräuter–Seitling',
  10006266: 'Wilde Pilze (sonstige)',
  10006267: 'Eisbergsalat',
  10006268: 'Lose Blätter / Multiblattsalate – sonstige',
  10006269: 'Babyblätter',
  10006270: 'Zuckerschote',
  10006271: 'Kichererbsen',
  10006272: 'Fenchel',
  10006273: 'Baby– / Kleinkindernahrungsmittel (tiefgefroren)',
  10006274: 'Luftüberwachungsgeräte',
  10006275: 'Feuchtigkeitsspendende After–Sun–Produkte',
  10006276: 'Personal Computer (PCs) – Tablet–PCs / E–Book–Reader',
  10006277: 'Metalldetektoren',
  10006278: 'Lamm – nicht bearbeitet / verarbeitet',
  10006279: 'Hammel – nicht bearbeitet / verarbeitet',
  10006280: 'Wildschwein – nicht bearbeitet / verarbeitet',
  10006281: 'Echter Hase – nicht bearbeitet / verarbeitet',
  10006282: 'Antilope – nicht bearbeitet / verarbeitet',
  10006283: 'Beefalo – nicht bearbeitet / verarbeitet',
  10006284: 'Elch / Wapiti – nicht bearbeitet / verarbeitet',
  10006285: 'Amerikanischer Elch / Elch – nicht bearbeitet / verarbeitet',
  10006286: 'Wasserbüffel – nicht bearbeitet / verarbeitet',
  10006287: 'Rentier / Karibu – nicht bearbeitet / verarbeitet',
  10006288: 'Emu – nicht bearbeitet / verarbeitet',
  10006289: 'Gans – nicht bearbeitet / verarbeitet',
  10006290: 'Perlhuhn – nicht bearbeitet / verarbeitet',
  10006291: 'Wachtel – nicht bearbeitet / verarbeitet',
  10006292: 'Nandu – nicht bearbeitet / verarbeitet',
  10006293: 'Jungtaube / Taube – nicht bearbeitet / verarbeitet',
  10006294: 'Lamm – bearbeitet / verarbeitet',
  10006295: 'Hammel – bearbeitet / verarbeitet',
  10006296: 'Wildschwein – bearbeitet / verarbeitet',
  10006297: 'Echter Hase – bearbeitet / verarbeitet',
  10006298: 'Antilope – bearbeitet / verarbeitet',
  10006299: 'Beefalo – bearbeitet / verarbeitet',
  10006300: 'Elch / Wapiti – bearbeitet / verarbeitet',
  10006301: 'Amerikanischer Elch / Elch – bearbeitet / verarbeitet',
  10006302: 'Wasserbüffel – bearbeitet / verarbeitet',
  10006303: 'Rentier / Karibu – bearbeitet / verarbeitet',
  10006304: 'Emu – bearbeitet / verarbeitet',
  10006305: 'Gans – bearbeitet / verarbeitet',
  10006306: 'Perlhuhn – bearbeitet / verarbeitet',
  10006307: 'Wachtel – bearbeitet / verarbeitet',
  10006308: 'Nandu – bearbeitet / verarbeitet',
  10006309: 'Jungtaube / Taube – bearbeitet / verarbeitet',
  10006310: 'Kaffeeersatz – Normal (kein Instantkaffee)',
  10006311: 'Kaffeeersatz – Instant',
  10006312: 'Kaffeeersatz – Trinkfertig',
  10006313: 'Kräutertabak / Kräuterschnupftabak – ohne Tabak',
  10006314: 'Suppeneinlagen (tiefgefroren)',
  10006315: 'Suppeneinlagen (leicht verderblich)',
  10006316: 'Suppeneinlagen (ohne Kühlung haltbar)',
  10006317: 'Mayonnaise / Mayonnaiseersatz (tiefgefroren)',
  10006318: 'Mayonnaise / Mayonnaiseersatz (leicht verderblich)',
  10006319: 'Mayonnaise / Mayonnaiseersatz (ohne Kühlung haltbar)',
  10006320: 'Senf (tiefgefroren)',
  10006321: 'Senf (leicht verderblich)',
  10006322: 'Senf (ohne Kühlung haltbar)',
  10006323: 'Tomatenketchup / Ketchupersatz (tiefgefroren)',
  10006324: 'Tomatenketchup / Ketchupersatz (leicht verderblich)',
  10006325: 'Tomatenketchup / Ketchupersatz (ohne Kühlung haltbar)',
  10006327: 'Alkoholische Getränke auf Apfel– / Birnenbasis – ohne Kohlensäure',
  10006328: 'Luft– / Staubfilter–Reiniger',
  10006329: 'Abgasfilter–Reiniger',
  10006330: 'Präsentationsständer',
  10006331: 'Lebensmittelbehälter (einweg)',
  10006332: 'Lebensmittelbehälter (einweg) – Sets',
  10006333: 'Lebensmittelbehälter (einweg) – sonstige',
  10006334: 'Anis',
  10006335: 'Arakacha',
  10006336: 'Goabohne (Flügelbohne)',
  10006337: 'Indischer Mais',
  10006338: 'Holzapfel',
  10006339: 'Brauner Senf / Indischer Senf (Sareptasenf)',
  10006340: 'Schlangenkürbis',
  10006341: 'Schwarzer Senf',
  10006342: 'Abessinischer Kohl / Äthiopischer Senf',
  10006343: 'Chironja',
  10006344: 'Yambohne',
  10006345: 'Kumquat',
  10006346: 'Loganbeeren',
  10006347: 'Früchte des Westlichen Erdbeerbaums',
  10006348: 'Sonstige Melonen',
  10006349: 'Bittermelone',
  10006350: 'Horngurken',
  10006351: 'Kuschkusch–Yamswurzel',
  10006352: 'Wasserspinat / Ong Choy',
  10006353: 'Salbei',
  10006354: 'Erlenblättrige Felsenbirne',
  10006355: 'Moschus–Kürbis',
  10006356: 'Chayote–Kürbis',
  10006357: 'Flaschenkürbis',
  10006358: 'Tamarillo / Baumtomate',
  10006359: 'Tamarinden',
  10006360: 'Aloe Vera',
  10006361: 'Farn, Zimt (Zimtfarn)',
  10006362: 'Farn, Königsfarn',
  10006363: 'Wurzeln der Großen Klette / Gobo–Wurzeln / Klette',
  10006364: 'Lotoswurzel',
  10006365: 'Große Sapote',
  10006366: 'Schwammgurke, gerippt',
  10006367: 'Bocksbart',
  10006368: 'Sapodilla',
  10006369: 'Sapote, Schwarz',
  10006370: 'Sapote, Weiß',
  10006371: 'Zuckerrohr',
  10006372: 'Wasserkastanie',
  10006373: 'Motorräder',
  10006374: 'Autos / Lieferwagen / Geländewagen / Leicht–LKW',
  10006375: 'Reinigungssets für den Fahrzeuginnenraum',
  10006376: 'Parkschutz–Vorrichtung',
  10006377: 'Radfelge',
  10006378: 'Autolack',
  10006379: 'Kraftstoffinjektor',
  10006380: 'Glühkerze',
  10006381: 'Glühkerzen – Sets',
  10006382: 'Anlasser',
  10006383: 'Starthilfekabel',
  10006384: 'Bremsbelag / Bremsfutter',
  10006385: 'Bremsscheiben',
  10006386: 'Klammer für Bremsscheibe',
  10006387: 'Bremstrommeln – Sets',
  10006388: 'Sonstige Teile für Bremssysteme',
  10006389: 'Bremstrommel / Bremstrommelteile',
  10006390: 'Kaugummi',
  10006391: 'Roller (nicht elektrisch)',
  10006392: 'Diebstahlsicherungen für Fahrräder',
  10006393: 'Rehwild  – bearbeitet / verarbeitet',
  10006394: 'Rehwild – nicht bearbeitet / verarbeitet',
  10006395: 'Action-Figuren (nicht elektrisch)',
  10006396: 'Action-Figuren (elektrisch)',
  10006397: 'Zubehör für Actionfiguren',
  10006398: 'USB-Massenspeicher / USB-Laufwerke',
  10006399: 'Kaminhilfsmittel',
  10006400: 'Kaminroste',
  10006401: 'Kaminabschirmung',
  10006402: 'Aufbewahrung für Kamin-Brennstoffe',
  10006403: 'Kfz–GPS-Halterungen und Gestelle',
  10006404: 'Tor / Garagentor – Öffnungssystme – Ersatzteile und Zubehör',
  10006405: 'Personal Computer (PCs) –  All-in-one',
  10006406: 'Präsentationsflächen (elektrisch)',
  10006407: 'Kohlendioxid-Gas',
  10006408: 'Stickstoffgas',
  10006409: 'Distickstoffmonoxid-Gas',
  10006410: 'Technische Gase – sonstige',
  10006411: 'Heliumgas',
  10006412: 'Medizinprodukte für Haustiere',
  10006414: 'Mispel',
  10006415: 'Shadong-Birne',
  10006416: 'Pfeilwurz (Arrowroot)',
  10006417: 'Weißer Rettich (Daikon)',
  10006418: 'Knolliger Kälberkropf',
  10006419: 'Batavia',
  10006420: 'Gemüse-Amarant / Chinesischer Salat',
  10006421: 'Roter Chicoree',
  10006422: 'Gemeine Wegwarte',
  10006423: 'Puntarelle',
  10006424: 'Lollo Bionda',
  10006425: 'Lollo Rosso',
  10006426: 'Eichblattsalat',
  10006427: 'Neuseeländer Spinat',
  10006428:
    'Blattgemüse – nicht bearbeitet / verarbeitet (frisch) – Mischpackungen',
  10006429: 'Goji-Beere / Gemeiner Bocksdorn',
  10006430: 'Hybride aus Beeren',
  10006431: 'Preiselbeere',
  10006432: 'Schwarzer Holunder',
  10006433: 'Annonen – sonstige',
  10006434: 'Java-Pflaume',
  10006435: 'Longan',
  10006436: 'Salak (Schlangenfrucht)',
  10006437: 'Röhren-Kassie',
  10006438: 'Palästina-Limette / Süße Indische Limette',
  10006439: 'King-Mandarine',
  10006440: 'Mittelmeer-Mandarine (Avana-Mandarine)',
  10006441: 'Mandarinen-Hybriden',
  10006442: 'Tangor',
  10006443: 'Platt-Pfirsich',
  10006444: 'Komatsuna',
  10006445: 'Bimi und andere Kohl-Kreuzungen',
  10006446: 'Choisum (Chinesischer Blütenkohl)',
  10006447: 'Tatsoi',
  10006449: 'Gewürzgurken',
  10006450: 'Krumme Gurke',
  10006451: 'Tomatillos',
  10006452: 'Afrikanische Aubergine',
  10006453: 'Pepino',
  10006454: 'Linsen',
  10006455: 'Rote Spargelerbse',
  10006456: 'Kräuter – Mischpackungen',
  10006457: 'Sellerieblätter',
  10006458: 'Echter Meerkohl',
  10006459: 'Strandflieder',
  10006460: 'Queller',
  10006461: 'Agretti',
  10006462: 'Agapanthus – Schnittblumen',
  10006463: 'Weicher Frauenmantel – Schnittblumen',
  10006464: 'Inkalilien – Schnittblumen',
  10006465: 'Kronen-Anemone – Schnittblumen',
  10006466: 'Flamingoblumen – Schnittblumen',
  10006467: 'Großes Löwenmaul – Schnittblumen',
  10006468: 'Aster – Schnittblume',
  10006469: 'Bouvardie – Schnittblumen',
  10006470: 'Silber-Brandschopf – Schnittblumen',
  10006471: 'Chamelaucium sonstige – Schnittblumen',
  10006472: 'Hakiges Chamelaucium – Schnittblumen',
  10006473: 'Chrysanthemen – Schnittblumen',
  10006474: 'Cymbidium – Schnittblumen',
  10006476: 'Dahlien – Schnittblumen',
  10006477: 'Rittersporne – Schnittblumen',
  10006478: 'Bartnelken – Schnittblumen',
  10006479: 'Nelken sonstige – Schnittblumen',
  10006480: 'Mannstreu – Schnittblumen',
  10006481: 'Eustoma Russellianum – Schnittblumen',
  10006482: 'Freesien – Schnittblumen',
  10006483: 'Gerbera – Schnittblumen',
  10006484: 'Gladiolen – Schnittblumen',
  10006485: 'Rispiges Schleierkraut – Schnittblumen',
  10006486: 'Sonnenblumen – Schnittblumen',
  10006487: 'Rittersterne – Schnittblumen',
  10006488: 'Gartenhyazinthe – Schnittblumen',
  10006489: 'Bauernhortensien – Schnittblumen',
  10006490: 'Blut-Johanniskraut – Schnitblumen',
  10006491: 'Johanniskräuter sonstige – Schnittblumen',
  10006492: 'Hypericum X Inodorum – Schnittblumen',
  10006493: 'Korallenhülse / Rote Winterbeere',
  10006494: 'Schwertlilie – Schnittblumen',
  10006495: 'Oster-Lilie – Schnittblumen',
  10006496: 'Lilien sonstige – Schnittblumen',
  10006497: 'Strandflieder sonstige – Schnittblumen',
  10006498: 'Geflügelter Strandflieder – Schnittblumen',
  10006499: 'Garten-Levkoje – Schnittblumen',
  10006500: 'Narzisse – Schnittblume',
  10006501: 'Großer Milchstern – Schnittblumen',
  10006502: 'Schnittblumen – sonstige',
  10006503: 'Pfingstrosen – Schnittblumen',
  10006504: 'Phalaenopsis – Schnittblumen',
  10006505: 'Phlox – Schnittblumen',
  10006506: 'Klebsamen – Schnittblumen',
  10006507: 'Asiatischer Hahnenfuß – Schnittblumen',
  10006508: 'Hahnenfuß sonstige – Schnittblumen',
  10006509: 'Rose – Schnittblume',
  10006510: 'Goldruten – Schnittblumen',
  10006511: 'Paradiesvogelblume – Schnittblume',
  10006512: 'Gemeiner Flieder – Schnittblumen',
  10006513: 'Mutterkraut – Schnittblumen',
  10006514: 'Blaues Halskraut – Schnittblumen',
  10006515: 'Tulpen – Schnittblumen',
  10006516: 'Vanda – Schnittblumen',
  10006517: 'Ehrenpreis – Schnittblumen',
  10006518: 'Gewöhnlicher Schneeball – Schnittblumen',
  10006519: 'Zantedeschia Aethiopica – Schnittblumen',
  10006520: 'Zantedeschien sonstige – Schnittblumen',
  10006521: 'Schmucklilien – Schnittgrün',
  10006522: 'Flamingoblumen – Schnittgrün',
  10006523: 'Asparagus Setaceus  – Schnittgrün',
  10006524: 'Asparagus Umbellatus – Schnittgrün',
  10006525: 'Aspidistra Elatior – Schnittgrün',
  10006526: 'Prachtspieren, sonstige – Schnittgrün',
  10006527: 'Gemüsekohl – Schnittgrün',
  10006528: 'Carthamus Tinctorius – Schnittgrün',
  10006529: 'Gemeine Hasel – Schnittgrün',
  10006530: 'Monbretien – Schnittgrün',
  10006531: 'Gurken – Schnittgrün',
  10006532: 'Riesen-Kürbis – Schnittgrün',
  10006533: 'Kürbis, sonstige – Schnittgrün',
  10006534: 'Gartenkürbis – Schnittgrün',
  10006535: 'Schnittgrün – Sets',
  10006536: 'Dracaena Sanderiana – Schnittgrün',
  10006537: 'Eucalyptus Cinerea – Schnittgrün',
  10006538: 'Eupatorium Rugosum – Schnittgrün',
  10006539: 'Fatsia Japonica – Schnittgrün',
  10006540: 'Gomphocarpus Fruticosus – Schnittgrün',
  10006541: 'Gartenhortensie – Schnittgrün',
  10006542: 'Ilex Verticillata – Schnittgrün',
  10006543: 'Silberbäume – Schnittgrün',
  10006544: 'Lilien – Schnittgrün',
  10006545: 'Matthiola Incana – Schnittgrün',
  10006546: 'Fensterblätter – Schnittgrün',
  10006547: 'Schnittgrün – sonstige',
  10006548: 'Panicum – Schnittgrün',
  10006549: 'Physalis Alkekengi – Schnittgrün',
  10006550: 'Klebsamen – Schnittgrün',
  10006551: 'Quercus Rubra – Schnittgrün',
  10006552: 'Rosen / Hagebutten – Schnittgrün',
  10006553: 'Ruscus Hypophyllum – Schnittgrün',
  10006554: 'Weiden – Schnittgrün',
  10006555: 'Setaria Italica – Schnittgrün',
  10006556: 'Strelitzia Reginae – Schnittgrün',
  10006557: 'Schneebeeren- Schnittgrün',
  10006558: 'Gemeiner Flieder – Schnittgrün',
  10006559: 'Hellerkräuter – Schnittgrün',
  10006560: 'Gewöhnlicher Schneeball – Schnittgrün',
  10006561: 'Zantedeschia Aethiopica – Schnittgrün',
  10006562: 'Aechmea – lebende Pflanzen',
  10006563: 'Aeonium Arboreum – lebende Pflanzen',
  10006564: 'Schmucklilien – lebende Pflanzen',
  10006565: 'Alokasie – lebende Pflanzen',
  10006566: 'Aloen – lebende Pflanzen',
  10006567: 'Inkalilien – lebende Pflanzen',
  10006568: 'Herbst-Anemone – lebende Pflanzen',
  10006569: 'Angelonien – lebende Pflanzen',
  10006570: 'Anisondontea Capensis – lebende Pflanzen',
  10006571: 'Flamingoblumen – lebende Pflanzen',
  10006572: 'Großes Löwenmaul – lebende Pflanzen',
  10006573: 'Argyranthemum Frutescens – lebende Pflanzen',
  10006574: 'Strand-Grasnelke – lebende Pflanzen',
  10006575: 'Astern – lebende Pflanzen',
  10006576: 'Prachtspieren – lebende Pflanzen',
  10006577: 'Aubrieta Gracilis – lebende Pflanzen',
  10006578: 'Begonien – lebende Pflanzen',
  10006579: 'Bellis Perennis – lebende Pflanzen',
  10006580: 'Zweizähne – lebende Pflanzen',
  10006581: 'Bougainvillea – lebende Pflanzen',
  10006582: 'Brachyscome Multifida – lebende Pflanzen',
  10006583: 'Kohl – lebende Pflanzen',
  10006584: 'Bromelia – lebende Pflanzen',
  10006585: 'Engelstrompeten – lebende Pflanzen',
  10006586: 'Calathea – lebende Pflanzen',
  10006587: 'Calibrachoa – lebende Pflanzen',
  10006588: 'Calocephalus Brownii – lebende Pflanzen',
  10006589: 'Campanula Portenschlagiana – lebende Pflanzen',
  10006590: 'Canna – lebende Pflanzen',
  10006591: 'Celosia – lebende Pflanzen',
  10006592: 'Chamaedorea Elegans – lebende Pflanzen',
  10006593: 'Chlorophytum Comosum – lebende Pflanzen',
  10006594: 'Chrysanthemen – lebende Pflanzen',
  10006595: 'Clivia Miniata – lebende Pflanzen',
  10006596: 'Cocos Nucifera – lebende Pflanzen',
  10006597: 'Codiaeum Variegatum – lebende Pflanzen',
  10006598: 'Cordyline Australis – lebende Pflanzen',
  10006599: 'Coreopsis Grandiflora – lebende Pflanzen',
  10006600: 'Cortaderia Selloana – lebende Pflanzen',
  10006601: 'Cosmos Bipinnatus – lebende Pflanzen',
  10006602: 'Cuphea Hyssopifolia – lebende Pflanzen',
  10006603: 'Zimmerzypressen – lebende Pflanzen',
  10006604: 'Curcuma Alismatifolia – lebende Pflanzen',
  10006605: 'Cycas Revoluta – lebende Pflanzen',
  10006606: 'Zimmer-Alpenveilchen – lebende Pflanzen',
  10006607: 'Cymbidien – lebende Pflanzen',
  10006608: 'Cyperus Alternifolius – lebende Pflanzen',
  10006609: 'Dahlien – lebende Pflanzen',
  10006610: 'Rittersporne – lebende Pflanzen',
  10006611: 'Dendrobium Nobile – lebende Pflanzen',
  10006612: 'Nelken – lebende Pflanzen',
  10006613: 'Tränendes Herz – lebende Pflanzen',
  10006614: 'Dieffenbachien – lebende Pflanzen',
  10006615: 'Dorotheanthus Bellidiformis – lebende Pflanzen',
  10006616: 'Gerandeter Drachenbaum – lebende Pflanzen',
  10006617: 'Goldfruchtpalme – lebende Pflanzen',
  10006618: 'Echeverien – lebende Pflanzen',
  10006619: 'Purpur Sonnenhut – lebende Pflanzen',
  10006620: 'Epipremnum Pinnatum – lebende Pflanzen',
  10006621: 'Weihnachtsstern – lebende Pflanzen',
  10006622: 'Gelbe Strauchmargerite – lebende Pflanzen',
  10006623: 'Muriel-Bambus – lebende Pflanzen',
  10006624: 'Kapastern – lebende Pflanzen',
  10006625: 'Blauschwingel – lebende Pflanzen',
  10006626: 'Fittonien – lebende Pflanzen',
  10006627: 'Fuchsien – lebende Pflanzen',
  10006628: 'Gardenia Jasminoides – lebende Pflanzen',
  10006629: 'Prachtkerze – lebende Pflanzen',
  10006630: 'Gazanien – lebende Pflanzen',
  10006631: 'Enziane – lebende Pflanzen',
  10006632: 'Gerbera – lebende Pflanzen',
  10006633: 'Guzmania – lebende Pflanzen',
  10006634: 'Mauer-Gipskraut – lebende Pflanzen',
  10006635: 'Birkenfeige – lebende Pflanzen',
  10006636: 'Gemeiner Efeu – lebende Pflanzen',
  10006637: 'Sonnenblume – lebende Pflanzen',
  10006638: 'Lakritz-Strohblume – lebende Pflanzen',
  10006639: 'Sonnenwenden – lebende Pflanzen',
  10006640: 'Schneerose – lebende Pflanzen',
  10006641: 'Heuchera – lebende Pflanzen',
  10006642: 'Zimmer-Hibiskus – lebende Pflanzen',
  10006643: 'Rittersterne – lebende Pflanzen',
  10006644: 'Gerste – lebende Pflanzen',
  10006645: 'Hosta – lebende Pflanzen',
  10006646: 'Forstersche Kentia – lebende Pflanzen',
  10006647: 'Garten-Hyazinthe – lebende Pflanzen',
  10006648: 'Bauernhortensien – lebende Pflanzen',
  10006649: 'Springkräuter – lebende Pflanzen',
  10006650: 'Jasminum Polyanthum – lebende Pflanzen',
  10006651: 'Kalanchoe Blossfeldiana – lebende Pflanzen',
  10006652: 'Wandelröschen – lebende Pflanzen',
  10006653: 'Margerite – lebende Pflanzen',
  10006654: 'Gewöhnlicher Bitterwurz – lebende Pflanzen',
  10006655: 'Lilien – lebende Pflanzen',
  10006656: 'Lithodora Diffusa – lebende Pflanzen',
  10006657: 'Lebende Pflanzen – Sets',
  10006658: 'Livistona Rotundifolia – lebende Pflanzen',
  10006659: 'Männertreu – lebende Pflanzne',
  10006660: 'Gewöhnlicher Hornklee – lebende Pflanzen',
  10006661: 'Lupinien – lebende Pflanzen',
  10006662: 'Mandevilla – lebende Pflanzen',
  10006663: 'Medinilla Magnifica – lebende Pflanzen',
  10006664: 'Miltonia – lebende Pflanzen',
  10006665: 'Traunenhyazinthen – lebende Pflanzen',
  10006666: 'Wald-Vergissmeinnicht – lebende Pflanzen',
  10006667: 'Narzisse – lebende Pflanzen',
  10006668: 'Nephrolepis Exaltata – lebende Pflanzen',
  10006669: 'Elefantenfuß – lebende Pflanzen',
  10006670: 'Seerosen – lebende Pflanzen',
  10006671: 'Oncidium – lebende Pflanzen',
  10006672: 'Orchis – lebende Pflanzen',
  10006673: 'Kap-Milchstern – lebende Pflanzen',
  10006674: 'Kapkörbchen – lebende Pflanzen',
  10006675: 'Sukkulente / Kakteen – lebende Pflanzen, sonstige',
  10006676: 'Farne – lebende Pflanzen, sonstige',
  10006677: 'Gräser – lebende Pflanzen, sonstige',
  10006678: 'Kräuter – lebende Pflanzen, sonstige',
  10006679: 'Lebende Pflanzen – sonstige',
  10006680: 'Wasserpflanzen – lebende Pflanzen, sonstige',
  10006681: 'Pachira Aquatica – lebende Pflanzen',
  10006682: 'Pfingstrosen – lebende Pflanzen',
  10006683: 'Islandmohn – lebende Pflanzen',
  10006684: 'Paphiopedilum – lebende Pflanzen',
  10006685: 'Pelargonien – lebende Pflanzen',
  10006686: 'Lampenputzgräser – lebende Pflanzen',
  10006687: 'Petunien – lebende Pflanzen',
  10006688: 'Phalaenopsis – lebende Pflanzen',
  10006689: 'Phlox – lebende Pflanzen',
  10006690: 'Zwergdattelpalme – lebende Pflanzen',
  10006691: 'Platycodon Grandiflorus – lebende Pflanzen',
  10006692: 'Harfensträucher – lebende Pflanzen',
  10006693: 'Portulak – lebende Pflanzen',
  10006694: 'Primeln – lebende Pflanzen',
  10006695: 'Hahnenfuß – lebende Pflanzen',
  10006696: 'Rhipsalidopsis – lebende Pflanzen',
  10006697: 'Rhododendron – lebende Pflanzen',
  10006698: 'Saintpaulia – lebende Pflanzen',
  10006699: 'Hain-Salbei – lebende Pflanzen',
  10006700: 'Sansevieria Cylindrica – lebende Pflanzen',
  10006701: 'Husarenknopf – lebende Pflanzen',
  10006703: 'Steinbrech – lebende Pflanzen',
  10006704: 'Schefflera Arboricola – lebende Pflanzen',
  10006705: 'Schlumbergera – lebende Pflanzen',
  10006706: 'Fetthennen – lebende Pflanzen',
  10006707: 'Hauswurzen – lebende Pflanzen',
  10006708: 'Senecio Maritima – lebende Pflanzen',
  10006709: 'Sinningia – lebende Pflanzen',
  10006710: 'Solanum Rantonnetii – lebende Pflanzen',
  10006711: 'Spathiphyllum – lebende Pflanzen',
  10006712: 'Stephanotis Floribunda – lebende Pflanzen',
  10006713: 'Sutera Cordata – lebende Pflanzen',
  10006714: 'Tagetes – lebende Pflanzen',
  10006715: 'Tillandsia Cyanea – lebende Pflanzen',
  10006716: 'Tulpen – lebende Pflanzen',
  10006717: 'Vanda – lebende Pflanzen',
  10006718: 'Verbenen – lebende Pflanzen',
  10006719: 'Veilchen – lebende Pflanzen',
  10006720: 'Vriesea – lebende Pflanzen',
  10006721: 'xBurrageara – lebende Pflanzen',
  10006722: 'X Citrofortunella Microcapa – lebende Pflanzen',
  10006723: 'Yucca – lebende Pflanzen',
  10006724: 'Zamioculcas Zamiifolia – lebende Pflanzen',
  10006725: 'Zantedeschien – lebende Pflanzen',
  10006726: 'Rose – lebende Pflanzen',
  10006728: 'Molkerei-Nebenerzeugnisse',
  10006729: 'Elektronische Zigaretten',
  10006730: 'Elektronische Zigaretten – Zubehör',
  10006731: 'Arbeitsplatten / Arbeitsflächen',
  10006732: 'Insektizide / Pestizide',
  10006733: 'Wachstumsregler für Pflanzen',
  10006734: 'Saatgutschutz / Beizmittel',
  10006735:
    'Küchen-Multifunktionsgeräte zum Zerkleinern, Schlagen / Verquirlen, Mischen / Mixen',
  10006736: 'Küchenschneidegerät',
  10006737: 'Küchenzerkleinerer',
  10006738: 'Küchen-Mixgerät / Handmixer / Küchenmaschine',
  10006739: 'Küchen-Blender',
  10006740: 'Kuchen-Backeisen / Minikuchen-Backeisen',
  10006742: 'Barbecue-Smoker',
  10006743: 'Smartwatch',
  10006744: 'PVR (Personal Video Recorder)',
  10006745: 'KMV-Switch',
  10006746: 'Erdnussflips',
  10006747: 'Salzstangen / Minibrezeln',
  10006748:
    'Fertiggerichte aus mehreren Bestandteilen – nicht verzehrfertig (tiefgefroren)',
  10006749:
    'Fertiggerichte aus mehreren Bestandteilen – nicht verzehrfertig (leicht verderblich)',
  10006750:
    'Fertiggerichte mit mehreren Bestandteilen – nicht verzehrfertig (ohne Kühlung haltbar)',
  10006751:
    'Fertiggerichte aus mehreren Bestandteilen – verzehrfertig (leicht verderblich)',
  10006752:
    'Fertiggerichte aus mehreren Bestandteilen – verzehrfertig (ohne Kühlung haltbar)',
  10006753:
    'Fertiggerichte aus mehreren Bestandteilen – verzehrfertig – Mischpackungen',
  10006754:
    'Fertiggerichte aus mehreren Bestandteilen – nicht verzehrfertig – Mischpackungen',
  10006755: 'Gewinnspielkarten und Rubbellose',
  10006759: 'Acai-Beeren',
  10006760: 'Lulo/Naranjilla',
  10006761: 'Spargelsalat',
  10006763: 'Rosen-Blumensträuße',
  10006764: 'Nelken-Blumensträuße',
  10006765: 'Kartäusernelken-Blumensträuße',
  10006766: 'Lilien-Blumensträuße',
  10006767: 'Chrysanthemen-Blumensträuße',
  10006768: 'Alstroemeria (Peruanische Lilie)-Blumensträuße',
  10006769: 'Sträuße aus tropischen Blumen',
  10006770: 'Gemischte Blümensträuße',
  10006771: 'Sonstige Blumensträuße',
  10006772: 'Quads',
  10006773: 'Gebrauchsfahrzeuge/Camping-Geländefahrzeuge',
  10006774: 'Setzlinge – bereit zum Anpflanzen',
  10006775: 'Reifendruckmessgerät',
  10006776: 'Wassergehaltsmesser (Boden)',
  10006777: 'Thermisches Lecksuchgerät',
  10006778: 'Riemenscheiben-Abzieher (Handgerät)',
  10006779: 'Riemenscheibenanzieher (elektrisch)',
  10006780: 'Zangensatz',
  10006781: 'Pinzetten (Do-it-yourself)',
  10006782: 'Spritzpistole',
  10006783: 'Gasfackel',
  10006784: 'Lötlampe',
  10006785: 'Kies',
  10006786: 'Holzfliesen – Bodenbelag für Außen',
  10006787: 'Betonfliesen – Außenbereich',
  10006788: 'Raue Fliesen – Außenbereich',
  10006789: 'Fliesen aus Naturstein – Bodenbelag für Außen',
  10006790: 'Sonstige Fliesen – Bodenbelag für den Außenbereich',
  10006791: 'Schlussstein',
  10006792: 'Fensterbrett',
  10006793: 'Abschlussstreifen/Randleiste zum Aufbügeln',
  10006794: 'Montageschienen',
  10006795: 'Baby-Hygieneausstattung – Sets',
  10006796: 'Baby-Hygieneausstattung – Ersatzteile',
  10006797: 'Baby-Hygieneausstattung – sonstige',
  10006798: 'Luftentfeuchter – mobil (nicht elektrisch)',
  10006801: 'Baby- Kleinkinderbesteck (mehrweg)',
  10006802: 'Baby- /Kleinkindgeschirr – Sets',
  10006806: 'Haushalts-Babybetten/-Matratzen – Sets',
  10006807: 'Haushalts-Babybetten/-Matratzen – Ersatzteile',
  10006808: 'Haushalts-Babybetten/-Matratzen – sonstige',
  10006809: 'Haushalts-Babystühle – Sets',
  10006810: 'Haushalts-Babystühle – Ersatzteile',
  10006811: 'Haushalts-Babystühle – sonstige',
  10006812: 'Baby-Trainingsgeräte/ -Transportmittel – Sets',
  10006813: 'Baby-Trainingsgeräte / -Transportmittel – Ersatzteile',
  10006814: 'KFZ-Innenausstattung – Sitze – Sets',
  10006815: 'Produkte zur Abfalllagerung – Sets',
  10006816: 'Produkte zur Abfalllagerung- Ersatzteile',
  10006817: 'Produkte zur Abfalllagerung – sonstige',
  10006818: 'Baby-Schutz/Sicherheit/Überwachung – Sets',
  10006819: 'Baby-Schutz / Sicherheit / Überwachung – Ersatzteile',
  10006820: 'Baby-Schutz / Sicherheit / Überwachung – sonstige',
  10006821: 'Babywindeln / Zubehör – sonstige',
  10006822: 'Babywindeln / Zubehör – Sets',
  10006823: 'Kai-lan (chinesischer Brokkoli)',
  10006824: 'Becherfarn (Straußenfarn)',
  10006825: 'Schwarzaugenbohnen',
  10006826: 'Cantaloupe-Melonen (keine netzartige Schale)',
  10006827: 'Wintermelonen oder geruchlose Zuckermelonen',
  10006828: 'Zuckermelone mit netzartiger Schale',
  10006829: 'Gemüsemelonen',
  10006830: 'Armenische Melonen',
  10006831: 'Ume/Japanische Aprikose',
  10006832: 'Chinesisches Spaltkörbchen',
  10006833: 'Ginseng',
  10006834: 'Adzukibohnen',
  10006835: 'Süßkartoffelstängel',
  10006836: 'Glänzender Lackporling',
  10006837: 'Marmelade / Konfitüre / Fruchtaufstriche (leicht verderblich)',
  10006838: 'Starthilfekabel',
  10006839: 'Radhalterung',
  10006840: 'Sportbekleidung – sonstige',
  10006841: 'Bodenbeläge – Unterlage',
  10006842: 'Werkzeuge zum Feueranzünden / Streichholzzubehör',
  10006843: 'Terrarium-Hilfsmittel / -Zubehör',
  10006845: 'Handwerkzeuge / Arbeitsgeräte – sonstige',
  10006846: 'Auto-Instrumente & Messsysteme',
  10006847: 'Unterschlupf für Wildtiere',
  10006848: 'Honig-Ersatzprodukte',
  10006849: 'Briefmarken',
  10006850: 'Ferngesteuerte Fahrzeuge',
  10006851: 'Ferngesteuerte Fahrzeuge – Ersatzteile/Zubehör',
  10006852: 'Röster für Kaffeebohnen',
  10006853: 'Tierabwehrmittel / -abschreckungsmittel – elektrisch',
  10006854: 'Rittersterne',
  10006855: 'Traubenhyazinthen',
  10006856: 'Dahlien',
  10006857: 'Gladiolien',
  10006858: 'Gartenhyazinthen',
  10006859: 'Iris',
  10006860: 'Krokusse',
  10006861: 'Lilien',
  10006862: 'Narzissen',
  10006863: 'Tulpen',
  10006864: 'Allium',
  10006865: 'Zantedeschien',
  10006866: 'Zitronatzitrone',
  10006867: 'Mistel (Abroma augustum)',
  10006868: 'Chinesische Jutepflanze (Abutilon avicennae)',
  10006869: 'Agave americana (Agave americana)',
  10006870: 'Agave cantala (Agave cantala)',
  10006871: 'Furcraea foetida (Furcraea foetida)',
  10006872: 'Agave fourcroydes (Agave fourcroydes)',
  10006873: 'Agave lechuguilla (Agave lechuguilla)',
  10006874: 'Sonstige Agave-Hanfpflanzen (Agave letonae)',
  10006875: 'Sisal-Agave (Agave sisalana)',
  10006876: 'Upas-Baum (Antiaris Africana)',
  10006877: 'Bambusa (Bambuseae)',
  10006878: 'Ramie (Boehmeria nivea)',
  10006879: 'Rattanpalme (Calamus rotang)',
  10006880: 'Hanfpflanzen (Cannais sativa)',
  10006881: 'Kapokbaum (Ceiba pentandra)',
  10006882: 'Corchorus (Corchorus)',
  10006883: 'Pima-Baumwolle (Gossypium barbadense)',
  10006884: 'Baumwollpflanze (Gossypium hirsutum)',
  10006885: 'Kenaf (Hibiscus cannabinus)',
  10006886: 'Rosellahanf (Hibiscus sabdariffa var. altissima)',
  10006887: 'Gemeiner Lein (Linum usitatissimum)',
  10006888: 'Abacá (Musa textilis)',
  10006889: 'Raphia farinifera (Raphia farinifera)',
  10006890: 'Kongojute (Urena lobata)',
  10006891: 'Große Brennnessel (Urtica dioica)',
  10006892: 'Kautschukbaum (Hevea brasiliensis)',
  10006893: 'Dekorative Fahnen / Flaggen – Zubehör',
  10006894: 'Haushaltskleingeräte – sonstige',
  10006895: 'Bauprodukte – sonstige',
  10006896: 'Elektrische Beleuchtung – sonstige',
  10006897: 'Federmäppchen',
  10006898: 'Schreibwaren / Büromaschinen – sonstige',
  10006899: 'Spielzeuge / Spiele – sonstige',
  10006900: 'Abdeckungen/Panele',
  10006901: 'Eingangsroste / Rahmen für Fußmatten',
  10006902: 'Rinne (Dachrinne / Drainage)',
  10006903: 'Kleidungs- / Fashion-Tape',
  10006904: 'Feuerlöscher fürs Auto',
  10006905: 'Asant (Ferula assa-foetida)',
  10006906: 'Guttaperchabäume (Palladium sp.)',
  10006907: 'Guayule (Parthenium argentatum)',
  10006908: 'Russischer Löwenzahn (Taraxacum kok-saghyz)',
  10006909: 'Adlerholzbaum (Aquilaria malaccensis)',
  10006910: 'Gummiarabikumbaum (Acacia senegal)',
  10006911: 'Balsam-Tanne (Abies balsamea)',
  10006912: 'Kampferbaum (Cinnamomum camphora)',
  10006913: 'Färber-Ginster (Genista tinctoria)',
  10006914: 'Steckenkräuter (Ferula gummosa)',
  10006915: 'Hennastrauch (Lawsonia inermis)',
  10006916: 'Indigopflanze (Indigefera tinctoria)',
  10006917: 'Mallotus philippensis (Mallotus philippensis)',
  10006918: 'Lack-Zistrose (Cistus ladanifer)',
  10006919: 'Färberkrapp (Rubia tinctorum)',
  10006920: 'Mastixstrauch (Pistacia lentiscus)',
  10006921: 'Balsambaum (Myroxylon balsamum)',
  10006922: 'Pterocarpus erinaceus (Pterocarpus erinaceus)',
  10006923: 'Benzoeharzbaum (Styrax benzoin)',
  10006924: 'Weihrauchbaum (Boswellia)',
  10006925: 'Terpentin-Pistazie (Pistacia terebinthus)',
  10006926: 'Quindio-Wachspalme (Ceroxylon quindicenne)',
  10006927: 'Cherimoya (Annona cherimola)',
  10006928: 'Ilama (Annona diversifolia)',
  10006929: 'Stachelannone (Annona muricata)',
  10006930: 'Netzannone (Annona reticulata)',
  10006931: 'Zimtapfel (Annona squamosa)',
  10006932: 'Atemoya (Annona x atemoya)',
  10006933: 'Dreilappige Papau (Asimina)',
  10006934: 'Schneebanane (Ensete glaucum)',
  10006935: 'Zierbanane (Ensete ventricosum)',
  10006936: 'Dessertbanane ( Musa x paradisiaca – AAB)',
  10006937: 'Cavendish-Bananenstauden (Musa acuminata – AAA)',
  10006938: 'Zwergbananenstaude (Musa acuminata – AA)',
  10006939: 'Rote Bananen ( Musa acuminata – AAA Sorte Rubra)',
  10006940:
    'Latundan-Banane (Musa acuminate x M. balbisiana (AAB Gruppe) Silk)',
  10006941:
    'Lakatan-Bananenstauden (Musa acuminata x M. balbisiana – AA Gruppe – Lakatan)',
  10006942: 'Quittenbaum (Cydonia oblonga)',
  10006943: 'Japanische Wollmispel (Eriobotrya Japonica)',
  10006944: 'Apfelbäume (Malus domestica)',
  10006945: 'Holzapfel (Malus sylvestris)',
  10006946: 'Mispelbäume (Mespilus germanica)',
  10006947: 'Weißer Birnbaum (Pyrus bretschneideri)',
  10006948: 'Birnenbäume (Pyrus communis)',
  10006949: 'Nashi-Birnenbaum (Pyrus pyrifolia)',
  10006950: 'Pyrus ussuriensis',
  10006951: 'Ackerlauch (Allium ampelorasum)',
  10006952: 'Schalotten (Allium ascalonicrum)',
  10006953: 'Zwiebelpflanzen (Allium cepa)',
  10006954: 'Frühlingszwiebeln (Allium cepa var. cepa)',
  10006955: 'Winterzwiebel (Allium fistulosum)',
  10006956: 'Allium kurrat',
  10006957: 'Knoblauchpflanzen (Allium sativum)',
  10006958: 'Speiseöle – pflanzlich (leicht verderblich)',
  10006959: 'Gründüngersaat',
  10006960: 'Materialschichten / Tücher',
  10006961: 'Toilettenzubehör',
  10006962: 'Zubehör für Waschbecken im Badezimmer',
  10006963: 'Schwimmbekleidung/Badeanzüge',
  10006964: 'Strandbekleidung/Strandtücher zum Umhängen',
  10006965: 'Schwimmbekleidung – sonstige',
  10006966: 'Knollenkartoffel',
  10006967: 'Knollige Kapuzinerkresse',
  10006968: 'Knolliger Sauerklee',
  10006969: 'Milchersatz (tiefgefroren)',
  10006970: 'Milchersatz (leicht verderblich)',
  10006971: 'Milchersatz (ohne Kühlung haltbar)',
  10006972: 'Milchersatzbasierte Getränke – trinkfertig (leicht verderblich)',
  10006973: 'Milchersatzbasierte Getränke – trinkfertig (ohne Kühlung haltbar)',
  10006974:
    'Milchersatzbasierte Getränke- nicht trinkfertig (ohne Kühlung haltbar)',
  10006975: 'Sahneersatz (tiefgefroren)',
  10006976: 'Sahneersatz (leicht verderblich)',
  10006977: 'Sahneersatz (ohne Kühlung haltbar)',
  10006978: 'Joghurtersatz (tiefgefroren)',
  10006979: 'Joghurtersatz (leicht verderblich)',
  10006980: 'Joghurtersatz (ohne Kühlung haltbar)',
  10006981: 'Margarine (ohne Kühlung haltbar)',
  10006982: 'Margarine (leicht verderblich)',
  10006983: 'Margarine (tiefgefroren)',
  10006984: 'Milchstreichfettprodukte (leicht verderblich)',
  10006985: 'Milchstreichfettprodukte (tiefgefroren)',
  10006986: 'Milchstreichfettprodukte (ohne Kühlung haltbar)',
  10006987: 'Aufstriche aus gemischten Fetten (ohne Kühlung haltbar)',
  10006988: 'Aufstriche aus gemischten Fetten (tiefgefroren)',
  10006989: 'Aufstriche aus gemischten Fetten (leicht verderblich)',
  10006990: 'Speisefette – gemischt (leicht verderblich)',
  10006991: 'Speisefette – gemischt (ohne Kühlung haltbar)',
  10006992: 'Cannabisöl',
  10006993: 'Cannabis getrocknete Blüte',
  10006994: 'Vorgeholtes Cannabis',
  10006995: 'Käseersatz (tiefgefroren)',
  10006996: 'Käseersatz (leicht verderblich)',
  10006997: 'Käseersatz (ohne Kühlung haltbar)',
  10006998: 'Carport',
  10006999: 'Terrassenüberdachung/Schutzbereich',
  10007000: 'Garage',
  10007001: 'Dübelbolzen',
  10007002: 'Verbindungsplättchen (DIY)',
  10007003: 'Heizkabel / Heizband / Heizschnur',
  10007004: 'Reinigungs-/Pflegeprodukte für den Kamin',
  10007005:
    'Haushaltsboiler / Heizöfen / Vorratswassererhitzer – Ersatzteile/Zubehör',
  10007006: 'Wecker',
  10007007: 'Übersteigschutz / Abschreckendes Sicherheitsprodukt',
  10007008: 'Glabruchmelder',
  10007009: 'Kunstrasen',
  10007010: 'Weihnachtsbäume – geschnitten',
  10007011: 'Künstlicher Weihnachtsbaum',
  10007012: 'Gabion',
  10007013: 'Gitterroste (Regenrinnen/Drainage)',
  10007014: 'Aufbewahrungsboxen für den Garten',
  10007015: 'Toiletten- / Bidet-Einbaurahmen',
  10007016: 'Toiletten-/Bidet-Sets',
  10007017: 'Toiletten-/Bidet – Ersatzteile/Zubehör',
  10007018: 'Toilette-/ Bidet-Wandabdeckungen',
  10007019: 'Leiter – Ersatzteile/Zubehör',
  10007020: 'Mobiltelefon- / Smartphone-Zubehör',
  10007021: 'Smarthome- / Heimautomatisierungs-Ausrüstung – Bedienfeld',
  10007022:
    'Smarthome- / Heimautomatisierungs-Ausrüstung – Sicherheitsvorrichtungen',
  10007023:
    'Smarthome- / Heimautomatisierungs-Ausrüstung – Geräte zur Temperaturregulierung',
  10007024:
    'Smarthome- / Heimautomatisierungs-Ausrüstung – Rasen-/Garten-/Freizeitgeräte',
  10007025:
    'Smarthome- / Heimautomatisierungs-Ausrüstung – Beleuchtungsanlagen',
  10007026: 'Abrasivstrahler/Sandstrahler',
  10007027: 'Bohrhammer und Schlagschrauber – Set',
  10007028: 'Abbruchhammer',
  10007029: 'Endoskopkameras (DIY)',
  10007030: 'Lochsäge',
  10007031: 'Mischer/Rüttler',
  10007032: 'Oszillierende Mehrfachwerkzeuge',
  10007033: 'Rotierende Mehrfachwerkzeuge',
  10007034: 'Schleifwalzen (elektrisch)',
  10007035: 'Mauernutfräse (elektrisch)',
  10007036: 'Ständer/Sockel für Schirme/Sonnenschirme',
  10007037: 'Poolfolien-/schichten',
  10007038: 'Wasserfilter – Ersatzteile/Zubehör',
  10007039: 'Motorisierung für Fensterläden',
  10007040: 'Felsenbirne (Amelanchier)',
  10007041: 'Amerikanischer Erdbeerbaum (Arbutus menziesii)',
  10007042: 'Echte Bärentraube (Arctostaphylos uva-ursi)',
  10007043: 'Apfelbeerenbüsche (Aronia)',
  10007044: 'Weißdornbusch (Crataegus)',
  10007045: 'Reichblütige Ölweide (Elaeagus multiflora)',
  10007046: 'Schwarzer Krähenbeerenbusch (Empetrum nigrum)',
  10007047: 'Erdbeerpflanzen (Fragaria x ananassa)',
  10007048: 'Sanddornbusch (Hippohae)',
  10007049: 'Acerola (Malpighia emarginata)',
  10007050: 'Gold-Johannisbeerenbusch (Ribes aureum)',
  10007051: 'Rubus flagellaris (Rubus flagellaris)',
  10007052: 'Bromeerpflanzen (Rubus fruticosus)',
  10007053: 'Himbeerpflanzen (Rubus ideaus)',
  10007054: 'Taybeere (Rubus Tayberry hybridis)',
  10007055: 'Rubus ursinus (Rubus ursinus)',
  10007056: 'Loganbeerbusch (Rubus x loganobaccus)',
  10007057: 'Holunder (Sambucus)',
  10007058: 'Chinesischer Spaltkörbchenbusch (Schisandra chinensis)',
  10007059: 'Vogelbeerbaum (Sorbus aucuparia)',
  10007060: 'Speierling (Sorbus domestica)',
  10007061: 'Vaccinium deliciosum',
  10007062: 'Großfrüchtige Moosbeere (Vaccinium macrocarpon)',
  10007063: 'Vaccinium membranaceum',
  10007064: 'Heidelbeerstrauch (Vaccinium myrtillus)',
  10007065: 'Gewöhnliche Moosbeerbüsche (Vaccinium oxycoccos)',
  10007066: 'Vaccinium parvifolium',
  10007067: 'Amerikanischer Heidelbeerbusch (Vaccinium sect. Cyanococcus)',
  10007068: 'Preiselbeerbusch (Vaccinium vitis-idaea)',
  10007069: 'Kanadischer Schneeball (Viburnum lentago)',
  10007070: 'Weinreben (Vitis sp.)',
  10007071: 'Bengalische Quitte (Aegle marmelos)',
  10007072: 'Calamondinorangenbaum (Citrofortunella microcarpa)',
  10007073: 'Zitronatzitronenbäume (Citrus medica)',
  10007074: 'Clementinenbäume (Citrus clementina)',
  10007075: 'Grapefruitbaum (Citrus paradisi)',
  10007076: 'Dreiblättrige Orangenbäume (Poncirus trifolata)',
  10007077: 'Citrus limettioides',
  10007078: 'Tangerinenbäume (Citrus nobilis)',
  10007079: 'Kumquatbäume (Citrus japonica)',
  10007080: 'Echte Zitronenbäume (Citrus limon)',
  10007081: 'Gewöhnliche Limettenbäue (Citrus latifolia)',
  10007082: 'Mandarinenbäume (Citrus x reticulata)',
  10007083: 'Echte Limettenbäume (Citrus aurantifolia)',
  10007084: 'Tangelobäume (Citrus x tangelo)',
  10007085: 'Kaffernlimettenbäume (Citrus papeda)',
  10007086: 'Pampelmusenbäume (Citrus maxima)',
  10007087: "Satsumabäume (Citrus reticulata 'Satsuma')",
  10007088: 'Bitterorangenbäume (Citrus aurantium)',
  10007089: 'Süße Limettenbäume (Citrus limetta)',
  10007090: 'Orangenbäume (Citrus sinensis)',
  10007091: 'Tangerinenbäume (Citrus tangerina)',
  10007092: 'Wampibaum (Clausena lansium)',
  10007093: 'Aprikosenbäume (Prunus armeniaca)',
  10007094: 'Kriechpflaumenbäume (Prunus domestica ssp. Institiia)',
  10007095: 'Edel-Pflaumenbaum (Prunus domestica ssp. Italica)',
  10007096: 'Nektarinenbäume (Prunus persica var nucipersica)',
  10007097: 'Plattpfirsichbaum (Prunus persica var. Platycarpa)',
  10007098: 'Pfirsichbäume (Prunus persica)',
  10007099: 'Pflaumenbäume (Prunus domestica)',
  10007100: 'Prunus-Hybriden (Prunus hybridis)',
  10007101: 'Schlehdornbusch (Prunus spinosa)',
  10007102: 'Sauerkirschbäume (Prunus cerasus)',
  10007103: 'Vogel-Kirschbaum (Prunus avium)',
  10007104: 'Feigenkaktuspflanzen (Opuntia ficus-indica)',
  10007105: 'Hylocereus costaricensis',
  10007106: 'Stenocereus',
  10007107: 'Chacampflanze (Hylocereus undatus)',
  10007108: 'Gelbe Drachenfruchtpflanze (Selenicereus megalanthus)',
  10007109: 'Kohlpalme (Euterpe olearcea)',
  10007110: 'Kokospalme (Cocos nucifera)',
  10007111: 'Echte Dattelpalme (Phoenix dactylifera)',
  10007112: 'Borassus (Borassus)',
  10007113: 'Salakpalme (Salacca edulis)',
  10007114: 'Brasilianische Guavenbäume (Fejoa sellowiana)',
  10007115: 'Echte Guavenbäume (Psidium guajava)',
  10007116: 'Baumstammkirschenbaum (Myrciaria cauliflora)',
  10007117: 'Jambolanapflaumenbaum (Syzygium cumini)',
  10007118: 'Javaapfelbäume (Syzygium samarangense)',
  10007119: 'Cleistocalyx operculatus var. paniala',
  10007120: 'Wasserapfelbäume (Syzgium malaccense)',
  10007121: 'Erdbeer-Guavenbaum (Psidium cattleianum)',
  10007122: 'Wasserjambosenbaum (Syzgium aqueum)',
  10007123: 'Goldpflaumenbäume (Spondias dulcis)',
  10007124: 'Dractonmelon dao',
  10007125: 'Gelber Mombinpflaumenbaum (Spondias mombin)',
  10007126: 'Gandariabaum (Bouea macrophylla)',
  10007127: 'Stinkender Mangobaum (Mangifera foetida)',
  10007128: 'Wohlriechende Mangobäume (Mangifera odorata)',
  10007129: 'Mangobäume (Mangifera indica)',
  10007130: 'Marula-Bäume (Scleocarya birrea)',
  10007131: 'Roter Mobinpflaumenbaum (Spondias purpurea)',
  10007132: 'Akeenbäume (Blighia sapida)',
  10007133: 'Longanbäume (Dimocarpus longan)',
  10007134: 'Litschibäume (Litchi chinensis)',
  10007135: 'Rambutanbäume (Nephelium lappaceum)',
  10007136: 'Pometia pinnata',
  10007137: 'Chrysophyllum albidum',
  10007138: 'Lucumabäume (Pouteria lucuma)',
  10007139: 'Großer Sapotenbaum (Pouteria sapota)',
  10007140: 'Breiapfelbäume (Manilkara zapota)',
  10007141: 'Sternapfelbäume (Chrysophyllum cainito)',
  10007142: 'Weiße Sapotenbäume (Casimiroa edulis)',
  10007143: 'Mammiapfelbaum (Mammea americana)',
  10007144: 'Pouteria campechiana',
  10007145: 'Salamanderbäume (Antidesma bunius)',
  10007146: 'Baccaurea ramiflora',
  10007147: 'Amlabäume (Phyllanthus emblica)',
  10007148: 'Baccaurea motleyana',
  10007149: 'Stachelbeerbäume (Phyllanthus acidus)',
  10007150: 'Baccaurea macrocarpa',
  10007151: 'Amerikanischer Persimonenbaum (Diospyros virginiana)',
  10007152: 'Avocadobäume (Persea americana)',
  10007153: 'Granadillabäume (Passiflora quadrangularis)',
  10007154: 'Myricabaum (Myrica)',
  10007155: 'Gurkenbaum (Averrhoa bilimbi)',
  10007156: 'Schwarzer Sapotenbaum  (Diospyros digya)',
  10007157: 'Kapstachelbeerbäume (Physalis peruviana)',
  10007158: 'Sternfruchtbaum (Averrhoa carambola)',
  10007159: 'Cempedakbaum (Artocarpus integer)',
  10007160: 'Chinesische Jujubenbäume (Ziziphus jujuba)',
  10007161: 'Großblütiger Kakaobaum (Theobroma grandiflora)',
  10007162: 'Durianbaum (Durio zibethinus)',
  10007163: 'Feigenbaum (Ficus carica)',
  10007164: 'Pithecellobium dulce',
  10007165: 'Indischer Jujubenbaum (Ziziphus mauritiana)',
  10007166: 'Flacourtia indica',
  10007167: 'Jackfruchtbaum (Artocarpus heterophyllus)',
  10007168: 'Muntingia calabura',
  10007169: 'Jengkolbaum (Archidendron jiringa)',
  10007170: 'Kakibaum  (Diospyros kaki)',
  10007171: 'Kikibaum (Actindia deliciosa)',
  10007172: 'Kokumbaum (Garcinia indica)',
  10007173: 'Lansibaum  (Lansium domesticum)',
  10007174: 'Diospyros discolor',
  10007175: 'Mangostanenbaum (Garcinia mangostana)',
  10007176: 'Maracujabäume (Passiflora edulis)',
  10007177: 'Berg-Papayabaum (Vasconcellea pubescens)',
  10007178: 'Maulbeerbäume (Morus)',
  10007179: 'Nonibäume (Morinda citrifolia)',
  10007180: 'Papayabäume (Carica papaya)',
  10007181: 'Ananaspflanzen (Ananas comosus)',
  10007182: 'Granatapfelbäume (Punica granatum)',
  10007183: 'Santolbäume (Sandoricum koetjape)',
  10007184: 'Süße Granadillabaum (Passiflora ligularis)',
  10007185: 'Tamariillobäume (Cyphomandra betacea)',
  10007186: 'Tamarindenbäume (Tamarindus indica)',
  10007187: 'Mandelbäume (Prunus dulcis var. dulcis)',
  10007188: 'Betelnusspalme (Areca catechu)',
  10007189: 'Bittermandelbäumen (Prunus dulcis var. amara)',
  10007190: 'Paranussbaum (Bertholetia excelsa)',
  10007191: 'Souarinussbaum (Caryocar nuciferum)',
  10007192: 'Cashewbaum (Anacardium occidentale)',
  10007193: 'Edelkastanie (Castanea sativa)',
  10007194: 'Scheinkastanie (Castanopsis)',
  10007195: 'Gemeine Hasel (Corylus aveliana)',
  10007196: 'Katappenbaum (Terminalia catappa)',
  10007197: 'Canarium indicum (Canarium indicum)',
  10007198: 'Kolabäume (Cola acuminata)',
  10007199: 'Macadamiabaum (Macadamia ternifolia)',
  10007200: 'Paradiesnuss (Lecythis ollaria)',
  10007201: 'Okwabaum (Treculia africana)',
  10007202: 'Paradiesnussbaum (Lecythis zabucajo)',
  10007203: 'Pekanussbaum (Carya illinoinensis)',
  10007204: 'Pinie (Pinus pinea)',
  10007205: 'Pistazienbaum (Pistacia vera)',
  10007206: 'Karitébaum (Vitellaria paradoxa)',
  10007207: 'Indianerbirne (Apios americana)',
  10007208: 'Bambara-Erdnuss (Vigna subterranea)',
  10007209: 'Erdbohne (Macrotyloma geocarpum)',
  10007210: 'Erdnuss (Archiv hypogaea)',
  10007211: 'Aloe-Verapflanze (Aloe vera)',
  10007212: 'Garcinia atrovirdis (Garcinia atrovirdis)',
  10007213: 'Linden (Tillia)',
  10007214: 'Kakaobaum (Theobroma cacao)',
  10007215: 'Echte Kamille (Matricaria chamomilla)',
  10007216: 'Kap-Aloe (Aloe ferox)',
  10007217: 'Kaffeesträucher (Coffea)',
  10007218: 'Echter Alant (Inula helenium)',
  10007219: 'Guaranapflanzen (Paullinia cupana)',
  10007220: 'Echter Hopfen (Kumulus lupulus)',
  10007221: 'Garcinia livingstonei',
  10007222: 'Jasminpflanzen (Jasminum officinale)',
  10007223: 'Kavabusch (Piper methysticum)',
  10007224: 'Flockenblumen (Centaurea)',
  10007225: 'Grönländischer Porst (Ledum groenlandicum)',
  10007226: 'Meerettichbaum (Moringa oleifera)',
  10007227: 'Rooibospflanze (Aspalathus linearis)',
  10007228: 'Roselle (Hibiscus sabdariffa)',
  10007229: 'Rose (Rosa)',
  10007230: 'Alexandrinische Senna (Senna alexandrina)',
  10007231: 'Aloe perryi (Aloe perry)',
  10007232: 'Teepflanze (Camellia sinensis)',
  10007233: 'Südseemyrte (Leptospermum)',
  10007234: 'Veilchen (Viola)',
  10007235: 'Jubaea (Jubaea)',
  10007236: 'Weinreben (Vitis vinifera)',
  10007237: 'Mata-Strauch (Ilex paraguariensis)',
  10007238: 'Tragbare Lebensmittelkisten / Behälter (nicht elektrisch)',
  10007239: 'Fondue-Set (nicht elektrisch)',
  10007240: 'Fondue-Set (nicht elektrisch) – Ersatzteile/Zubehör',
  10007241: 'Töpfe für Kochfelder / Pfannen / Woks / Kokotten – Sets',
  10007242: 'Essgeschirr – Sets',
  10007243: 'Stielgläser für Wein/Wasser/Champagner',
  10007244: 'Becher',
  10007245: 'Bar-/Cocktailgläser',
  10007246: 'Gläserset',
  10007247: 'Trinkgeschirr – sonstige',
  10007248: 'Trinkgeschirr – Sets',
  10007249: 'Biergläser',
  10007250: 'Tee-/Kaffee-/Kakao-Zubehör',
  10007251: 'Tee/Kaffee/Kakao – Sets',
  10007252: 'Wein – Zubehör',
  10007253: 'Cocktail-Zubehör (mehrweg)',
  10007254: 'Sonstiges Bar- und Weinzubehör',
  10007255: 'Bar- und Wein-Sets',
  10007256: 'Buffet',
  10007257: 'Serviergeschirr – Sets',
  10007258: 'Flache Servierteller',
  10007259: 'Tiefe Servierteller',
  10007260: 'Serviergeschirr – sonstige',
  10007261: 'Trinkgefäße (einweg)',
  10007262: 'Geschirr (einweg)',
  10007263: 'Tischgeschirrzubehör (einweg)',
  10007264: 'Tischsets / Servietten (einweg)',
  10007265: 'Tischgeschirr – Sets',
  10007266: 'Tischgeschirr-Zubehör – sonstige',
  10007267: 'Tischgeschirrzubehör – Sets',
  10007268: 'Tee-/Kaffeebesteck (mehrweg)',
  10007269: 'Besteck – sonstige (mehrweg)',
  10007270: 'Besteck – Sets (mehrweg)',
  10007271: 'Reiseklappmesser',
  10007272: 'Tischbesteck (mehrweg)',
  10007273: 'Servierbesteck (mehrweg)',
  10007274: 'Fisch- / Meeresfrüchte- / Schneckenbesteck (mehrweg)',
  10007275: 'Vorspeisen-/Nachspeisen-/Käse-Besteck (mehrweg)',
  10007276: 'Snacks – sonstige',
  10007277: 'Gardinenschienen - Zubehör',
  10007278: 'Parkschranken',
  10007279: 'Äthiopischer Hafer (Avena Abyssinica)',
  10007280: 'Saat-Hafer (Avena Sativa)',
  10007281: 'Sand-Hafer (Avena Strigosa)',
  10007282: 'Kaniwa (Chenopodium Pallidicaule)',
  10007283: 'Quinoa (Chenopodium Quinoa)',
  10007284: 'Hiobsträne (Coix Lacryma-Jobi)',
  10007285: 'Foniohirse (Digitaria Exilis)',
  10007286: 'Iburu (Digitaria Iburua)',
  10007287: 'Japanhirse (Echinochloa Frumentacea)',
  10007288: 'Fingerhirse (Eleusine Coracana)',
  10007289: 'Teff (Eragrostis Tef)',
  10007290: 'Echter Buchweizen (Fagopyrum Esculentum)',
  10007291: 'Afrikanischer Reis (Oryza Glaberrima)',
  10007292: 'Reis (Oryza Sativa)',
  10007293: 'Rispenhirse (Panicum Spp.)',
  10007294: 'Kodo-Hirse (Paspalum Scrobiculatum)',
  10007295: 'Perlhirse (Pennisetum Glaucum)',
  10007296: 'Kanariengras (Phalaris Canariensis)',
  10007297: 'Mohrenhirse (Sorghum Bicolor)',
  10007298: 'Triticale (Triticosecale)',
  10007299: 'Polnischer Weizen (Triticum Polonicum)',
  10007300: 'Dinkel (Triticum Spelta)',
  10007301: 'Khorasan-Weizen (Triticum Turgidum subsp. Turanicum)',
  10007302: 'Mais (Zea Mays subsp. Mays)',
  10007303: 'Wasserreis (Zizania Aquatica)',
  10007304: 'Zucker-Ahorn (Acer Saccharum)',
  10007305: 'Zuckerpalme (Arenga Saccharifera)',
  10007306: 'Zuckerrübe (Beta Vulgaris subsp. Vulgaris var. Altissima)',
  10007307: 'Zuckerrohr (Saccharum Officinarum)',
  10007308: 'Sorgumhirse (Sorghum Saccharatum)',
  10007309: 'Babasuspalme (Attalea Speciosa)',
  10007310: 'Raps (Brassica Napus)',
  10007311: 'Färberdistel (Carthamus Tinctorius)',
  10007312: 'Soja (Glycine Max)',
  10007313: 'Ölpalme  (Eleais Guineensis)',
  10007314: 'Amerikanische Ölpalme (Eleais Oleifera)',
  10007315: 'Sonnenblume (Helianthus Annus)',
  10007316: 'Gemeiner Lein (Linum Usitatissimum)',
  10007317: 'Olivenbaum (Olea Europaea)',
  10007318: 'Sesam (Sesamum Indicum)',
  10007319: 'Gerste (Hordeum vulgare)',
  10007320: 'Roggen (Secale cereale)',
  10007321: 'Weichweizen (Triticum spp.)',
  10007322: 'Bastardschwingel (x Schedolium Loliaceum)',
  10007323: 'Nilgras (Acroceras Macrum)',
  10007324: 'Agrostis spp',
  10007325: 'Gewöhnlicher Strandhafer (Ammophila Arenaria)',
  10007326: 'Amerikanischer Strandhafer (Ammophila Breviligulata)',
  10007327: 'Andropogon spp',
  10007328: 'Antephora spp.',
  10007329: 'Pfahlrohr (Arundo Donax)',
  10007330: 'Axonopus spp.',
  10007331: 'Borthriochloa spp',
  10007332: 'Gramagras (Bouteloua spp.)',
  10007333: 'Tara-Strauch (Caesalpinia Spinosa)',
  10007334: 'Aufrechte Studentenblume (Tagetes Erecta)',
  10007335: 'Anogeissus Leiocarpa',
  10007336: 'Winterkresse (Barbarea Vulgaris)',
  10007337: 'Vieh-Mangold (Beta Vulgaris Subsp. Vulgaris var. Crassa)',
  10007338: 'Schwarzer Senf (Brassica Nigra)',
  10007339: 'Leindotter (Camelia Sativa)',
  10007340: 'Acker-Senf (Sinapis Arvensis)',
  10007341: 'Weißer Senf (Sinapsis Alba)',
  10007342: 'Akazienbäume (Acacia Spp.)',
  10007343: 'Amerikanische Schaampflanze (Aeschynomene Americana)',
  10007344: 'Albizia Spp',
  10007345: 'Alysicarpus Spp.',
  10007346: 'Erdnüsse (Arachis Glabrata)',
  10007347: 'Arachis Pintoi',
  10007348: 'Bauhinien (Bauhinia Spp.)',
  10007349: 'Calliandra-Baum (Calliandra Calothyrsus)',
  10007350: 'Calopogonium Spp.',
  10007351: 'Johannisbrotbaum (Ceratonia Siliqua)',
  10007352: 'Rundblattkassie (Chamaecrista Rotundifolia)',
  10007353: 'Cordeauxia Edulis',
  10007354: 'Cratylia Argentea',
  10007355: 'Croalaria Spp',
  10007356: 'Tagasaste (Cytisus Proliferus)',
  10007357: 'Desmanthus Spp',
  10007359: 'Desmodium Spp.',
  10007360: 'Farbkätzchenstrauch (Dichsostachys Cinerea)',
  10007361: 'Enterolobium Cyclocarpum',
  10007362: 'Korallenbaum (Erythrina App.)',
  10007363: 'Anabaum (Faidherbia Albida)',
  10007364: 'Flemingia Macrophylla',
  10007365: 'Amerikanische Gleditschie (Gleditsia Triacanthos)',
  10007366: 'Robiniengewächs (Gliricidia Sepium)',
  10007367: 'Spanische Esparsette (Hedysarum Coronarium)',
  10007368: 'Indigofera Spp',
  10007369: 'Saat-Platterbse (Lathyrus Sativus)',
  10007370: 'Chinesischer Buschklee (Lespedeza Cuneata)',
  10007371: 'Weißkopfmimose (Leucaena Leucocephala)',
  10007372: 'Lotononis Bainesii',
  10007373: 'Gewöhnlicher Hornklee (Lotus Corniculatus)',
  10007374: 'Lupinen (Lupinus Spp.)',
  10007375: 'Phaseolus Atropurpureus',
  10007376: 'Gartenbohne (Macroptilium Lathyroides)',
  10007377: 'Hopfenklee (Medicago Lupulina)',
  10007378: 'Rauer Schneckenklee (Medicago Polymorpha)',
  10007379: 'Luzerne (Medicago Sativa)',
  10007380: 'Medicago Truncatula',
  10007381: 'Weißer Steinklee (Melilotus Albus)',
  10007382: 'Kleinblütiger Steinklee (Melilotus Indicus)',
  10007383: 'Mehrjährige Sojapflanze (Glycine Wightii)',
  10007384: 'Saat-Esparsette (Onobrychis Viciifolia)',
  10007385: 'Echte Serradella (Ornithopus Sativus)',
  10007386: 'Parkia Africana',
  10007387: 'Österreichische Wintererbsen (Pisum Sativum var. Arvense)',
  10007388: 'Manila-Tamarinde (Pithecellobium Dulce)',
  10007389: 'Prosopis (Prosopis Spp)',
  10007390: 'Kudzu (Pueraria Spp.)',
  10007391: 'Sesbania (Sesbania Spp)',
  10007392: 'Stylosanthes Spp',
  10007393: 'Tephrosia Purpurea',
  10007394: 'Nicht spezifizierte Kleepflanzen (Trifolium)',
  10007395: 'Ägyptischer Klee (Trifolium Alexandrinum)',
  10007396: 'Schweden-Klee (Trifolium Hybridem)',
  10007397: 'Inkarnat-Klee (Trifolium Incarnatum)',
  10007398: 'Wiesenklee (Trifolium Pratense)',
  10007399: 'Weißklee (Trifolium Repens)',
  10007400: 'Persischer Klee (Trifolium Resupinatum)',
  10007401: 'Bodenfrüchtiger Klee (Trifolium Subterraneum)',
  10007402: 'Blasenfrüchtiger Klee (Trifolium Vesiculosum)',
  10007403: 'Futterwicke (Vicia Sativa)',
  10007404: 'Zottige Wicke (Vicia Villosa)',
  10007405: 'Urdbohne (Vienna Mungo)',
  10007406: 'Afrikanischer Affenbrotbaum (Adansonia Digitata)',
  10007407: 'Aereva Javanica',
  10007408: 'Amarant Futterpflanze (Amaranthus Spp.)',
  10007409: 'Arganbaum (Argania Spinosa)',
  10007410: 'Atriplex Spp',
  10007411: 'Cadaba Farinosa',
  10007412: 'Combretum Aculeatum',
  10007413: 'Rainfarn-Phazelie (Phacelia Tanacetifolia)',
  10007414: 'Eichen (Quercus Spp)',
  10007415: 'Zahnbürstenbaum (Salvadora Persica)',
  10007416: 'Acker-Spark (Spergula Arvensis)',
  10007417: 'Aufrechte Studentenblume (Tagetes Erecta)',
  10007418: 'Mexikanische Sonnenblume (Tithonia Diversifolia)',
  10007419: 'Ziziphus Mucronata',
  10007420: 'Gemeine Schafgarbe (Achillea Millefolium)',
  10007421: 'Achlys Triphylla',
  10007422: 'Jambú (Amella Oleracea)',
  10007423: 'Frühlings-Adonisröschen (Adonis Vernalis)',
  10007424: 'Buchu (Agathosma)',
  10007425: 'Ammi',
  10007426: 'Echte Arnika (Arnica Montana)',
  10007427: 'Afrikanischer Wermut (Artemisia Afra)',
  10007428: 'Einjähriger Beifuß (Artemisia Annua)',
  10007429: 'Artemisia Arborescens',
  10007430: 'Wurmsamen (Artemisia Cina)',
  10007431: 'Strand-Beifuß (Artemisia Maritima)',
  10007432: 'Gewöhnliche Haselwurz (Asarum Europaeum)',
  10007433: 'Tragant (Astragalus)',
  10007434: 'Baeckea (Baeckea Frutescens)',
  10007435: 'Para-Gras (Brachiaria Mutica)',
  10007436: 'Korallenrauten (Boronia)',
  10007437: 'Wimper-Stachelgras (Cenchrus Ciliaris)',
  10007438: 'Weiße Zaunrübe (Bryonia Alba)',
  10007439: 'Rhodosgras (Chloris Guyana)',
  10007440: 'Palo Santo (Bulnesia Sarmientoi)',
  10007441: 'Vetiver (Chrysopogon spp.)',
  10007442: 'Brechwurzel (Carapichea Ipecacuanha)',
  10007443: 'Hiobsträne (Coix Lacryma-jobi)',
  10007444: 'Trommelstockbaum (Cassio Sieberiana)',
  10007445: 'Römische Kamille (Chamaemelum Nobile)',
  10007446: 'Chinarindenbaum (Cinchona)',
  10007447: 'Kampferbaum (Cinnamomum Camphora)',
  10007448: 'Koloquinte (Citrullus Colocynthis)',
  10007449: 'Hundszahngras (Cynodon Dactylon)',
  10007450: 'Kleinbütige Bergminze (Clinopodium Nepeta)',
  10007451: 'Orientalische Purgierwinde  (Convolvulvus Scammonia)',
  10007452: 'Copaifera Langsdorffii',
  10007453: 'Krotonölbaum (Croton Tiglium)',
  10007454: 'Diptam (Dictamnus Albus)',
  10007455: 'Echter Wurmfarn (Dryopteris Filip-Mas)',
  10007456: 'Mexikanischer Drüsengänsefuß (Dysphania Ambrosioides)',
  10007457: 'Cocastrauch (Erythroxylum Coca)',
  10007458: 'Pflaumenflechte (Evernia Prunastri)',
  10007459: 'Ginkgo (Ginkgo Biloba)',
  10007460: 'Italienische Strohblume (Helichrysum Italicum)',
  10007461: 'Echtes Johanniskraut (Hypericum Perforatum)',
  10007462: 'Wiesen-Kammgras (Cynosurus Cristatus)',
  10007463: 'Zyperngras (Papyrus) (Cyperus spp.)',
  10007464: 'Schleifenblumen (Iberis)',
  10007465: 'Jalapa (Ipomoea Purga)',
  10007466: 'Sadebaum (Juniperus Sabina)',
  10007467: 'Virginischer Wacholder (Juniperus Virginiana)',
  10007468: 'Kunzea',
  10007469: 'Anden-Lupine (Lupinus Mutabilis)',
  10007470: 'Ufer-Wolfstrapp (Lycopus Europaeus)',
  10007471: 'Incienso (Myrocarpus Frondosus)',
  10007472: 'Stauden-Nachtkerze (Oenothera Fruticosa)',
  10007473: 'Yohimbe (Pausinystalia yohimbe)',
  10007474: 'Steppenraute (Peganum Harmala)',
  10007475: 'Plantago Ovata',
  10007476: 'Kosso (Pterocarpus Erinaceus)',
  10007477: 'Indische Schlangenwurzel (Rauvolfia Serpentina)',
  10007478: 'Wunderbaum (Ricinus Communis)',
  10007479: 'Damaszener Rosen (Rosa x Damascena)',
  10007480: 'Krainer Tollkraut (Scopolia Carniolica)',
  10007481: 'Jojoba (Simmondsia Chinensis)',
  10007482: 'Stechwinde (Smilax)',
  10007483: 'Goldruten (Solidago)',
  10007484: 'Rainfarn(Tanacetum Vulgare)',
  10007485: 'Edel-Gamander (Teuricum Chamaedrys)',
  10007486: 'Abendländischer Lebensbaum (Thuja Occidentalis)',
  10007487: 'Bartflechten (Usnea)',
  10007488: 'Baldrian (Valeriana Officinalis)',
  10007489: 'Verbena (Verbena)',
  10007490: 'Yucca (Yucca)',
  10007491: 'Ylang-Ylang (Cananga Odorata)',
  10007492: 'Vetiver (Chrysopogon Zizanioides)',
  10007493: 'Eukalypten (Eucalyptus Sp.)',
  10007494: 'Echter Lavendel (Lavandula Angustifolia)',
  10007495: 'Litsea Cubeba',
  10007496: 'Melaleuca Sp.',
  10007497: 'Indische Narde (Nardostachys Jatamansi)',
  10007498: 'Indisches Patschuli (Pogostemon Cabin)',
  10007499: 'Ravensara Aromatica',
  10007500: 'Frauenminze (Tanacetum Balsamita)',
  10007501: 'Blauer Eisenhut (Aconicum)',
  10007502: 'Kalmus (Acorus Calamus)',
  10007503: 'Schwarze Tollkirsche (Atropa Belladonna)',
  10007504: 'Purpurbrauner Mutterkornpilz (Claviceps Purpurea)',
  10007505: 'Herbstzeitlose (Colchicum Autumnale)',
  10007506: 'Maiglöckchen (Canvallaria Majalis)',
  10007507: 'Stechäpfel (Datura)',
  10007508: 'Roter Fingerhut (Digitalis Purpurea)',
  10007509: 'Schwarzes Bilsenkraut (Hyoscyamus Niger)',
  10007510: 'Gemeine Alraune (Mandragora Officinarum)',
  10007511: 'Schildförmiges Fußblatt (Podophyllum Peltatum)',
  10007512: 'Adlerfarn (Pteridium Aquilinum)',
  10007513: 'Kanadische Blutwurz (Sanguinaria Canadensis)',
  10007514: 'Bittersüßer Nachtschatten (Solanum Dulcamara)',
  10007515: 'Schwarzer Nachtschatten (Solanum Nigrum)',
  10007516: 'Kombe-Pfeilgift (Strophantus Kombe)',
  10007517: 'Gewöhnliche Brechnuss (Strychnos Nun-Vomica)',
  10007518: 'Rainfarn (Tanacetum Vulgare)',
  10007519: 'Weiße Meerzwiebel (Uriginea Maritima)',
  10007520: 'Immergrün (Vinca)',
  10007521: 'Steckrübe (Brassica Napobrassica)',
  10007522: 'Romanesco (Brassica Oleracea Convar. Botrytis var. Botrytis)',
  10007523: 'Broccolini (Brassica Oleracea Italica X Alboglabra)',
  10007524: 'Kai-Ian (Brassica Oleracea var. Alboglabra)',
  10007525: 'Blumenkohl (Brassica Oleracea var. Botrytis)',
  10007526: 'Weißkohl (Brassica Oleracea var. Capitata)',
  10007527: 'Marshall-Spitzkohl (Brassica Oleracea var. Capitata F. Conica)',
  10007528: 'Rotkohl (Brassica Oleracea var. Capitata F. Rubra)',
  10007529: 'Rosenkohl (Brassica Oleracea var. Gemmifera)',
  10007530: 'Broccoli (Brassica Oleracea var. Italica)',
  10007531: 'Wirsing (Brassica Oleracea var. Sabauda)',
  10007532: 'Grünkohl (Brassica Oleracea var. Sabellica)',
  10007533: 'Blattkohl (Brassica Oleracea var. Viridis)',
  10007534: 'Speiserübe (Brassica Rapa Subsp. Rapa)',
  10007535: 'Gewöhnliches Knäuelgras (Dactylis Glomerata)',
  10007536: 'Ägyptisches Krähenfußgras (Dactyloctenium Aegyptium)',
  10007537: 'Kalkutta-Bambus (Dendrocalamus Strictus)',
  10007538: 'Dichanthium spp.',
  10007539: 'Fingerhirse (Digitaria spp.)',
  10007540: 'Ehrharta Stipoides',
  10007541: 'Indische Fingerhirse (Eleusine Indica)',
  10007542: 'Kriech-Quecke (Elymus repens)',
  10007543: 'Liebesgras (Eragrostis spp.)',
  10007544: 'Straucherbse (Cajanus Cajan)',
  10007546: 'Mauerkübel/Bauarbeitereimer',
  10007547: 'Jackbohne (Canavalia Ensiformis)',
  10007548: 'Schwertbohne (Canavalia Gladiata)',
  10007549: 'Kichererbse (Cicero Arientinum)',
  10007550: 'Blaue Klitorie (Clitoria Ternatea)',
  10007551: 'Guarbohne (Cyamopsis Tetragonoloba)',
  10007552: 'Helmbohne (Lablab Purpureus)',
  10007553: 'Duftende Platterbse (Lathyrus Odoratus)',
  10007554: 'Knollen-Platterbse (Lathyrus Tuberosus)',
  10007555: 'Linse (Lens Culinaris)',
  10007556: 'Juckbohne (Mucuna Pruriens)',
  10007557: 'Parkia Biglobosa',
  10007558: 'Gestankbohne (Parkia Speciosa)',
  10007559: 'Teparybohne (Phaseolus Acutifolius)',
  10007560: 'Feuerbohne (Phaseolus Coccineus)',
  10007561: 'Limabohne (Phaseolus Lunatus)',
  10007562: 'Gartenbohne (Phaseolus Vulgaris)',
  10007563: 'Gartenbohne (Phaseolus Vulgaris)',
  10007564: 'Erbse (Pisum Sativum)',
  10007565: 'Ackererbse (Pisum Sativum Subsp. Arvense)',
  10007566: 'Steckrübe (Brassica Napobrassica)',
  10007567: 'Kefe (Pisum Sativum var. Saccharatum)',
  10007568: 'Goabohne (Psphocarpus Tetragonolobus)',
  10007569: 'Rote Spargelbohne (Tetragonolobus Purpureus)',
  10007570: 'Feld-Ackerbohne (Vicia Faba subsp. Minor)',
  10007571: 'Pferdebohnen (Vicia Faba var. Equina)',
  10007572: 'Ackerbohne (Vicia Faba var. Major)',
  10007573: 'Adzukibohne (Vigna Angularis)',
  10007574: 'Mungbohne (Vigna Radiata)',
  10007575: 'Reisbohne (Vigna Umbellata)',
  10007576: 'Augenbohne (Vigna Unguiculata)',
  10007577: 'Spargelbohne (Vigna Unguiculata subsp. Sesquipedalis)',
  10007578: 'Buchhaltungsdienst',
  10007579: 'Werbedienstleistungen',
  10007580: 'Architektur- und Ingenieurleistungen',
  10007581: 'Geschäftsführung- und Consulting-Dienstlesitungen',
  10007582: 'Computer- und Technologie-Dienstleistungen',
  10007583: 'Juristische Dienstleistungen',
  10007584: 'Bauausführung und ähnliche Dienstleistungen',
  10007585: 'Reinigungsdienstleistungen',
  10007586: 'Audiovisuelle Dienste',
  10007587: 'Telekommunikationsdienstleistungen',
  10007588: 'Bildungsdienstleistungen',
  10007589: 'Unterhaltungsdienste',
  10007590: 'Energiedienstleistungen',
  10007591: 'Kreislaufwirtschaft',
  10007592: 'Finanzdienstleistungen',
  10007593: 'Verpackung-/Lagerdienstleistungen',
  10007594: 'Postdienst',
  10007595: 'Wissenschaftliche und technologische Dienstleistungen',
  10007596: 'Speisen- und Getränke-Service',
  10007597: 'Dienstleistungen für Wohnen auf Zeit',
  10007598: 'Wartungs-/Reparaturdienstleistungen',
  10007599: 'Montagedienstleistung',
  10007600: 'Gesundheits- und Schönheitspflege',
  10007601: 'Medizinische Dienstleistungen',
  10007602: 'Veterinärdienst',
  10007603: 'Transportdienstleistungen',
  10007605: 'Reisedienstleistungen',
  10007606: 'Eintopftisch',
  10007607: 'Sockelleiste/Fußleiste',
  10007608: 'Kantenleisten',
  10007609: 'Schornsteinabdeckung/Regenschutz',
  10007610: 'Luftkanal',
  10007611: 'Tausendfüßler-Gras (Eremochloa Ophiuroides)',
  10007612: 'Raublättriger Schaf-Schwingel (Festuca Brevipila)',
  10007613: 'Echter Schaf-Schwingel (Festuca Ovina)',
  10007614: 'Wiesen-Schwingel (Festuca Pratensis)',
  10007615: 'Gewöhnlicher Rot-Schwingel (Festuca Rubra)',
  10007616: 'Hemarthria Altissima',
  10007617: 'Heteropogon Contortus',
  10007618: 'Jaragua (Hyparrhenia Rufa)',
  10007619: 'Silberhaargras (Imperata Cylindrica)',
  10007620: 'Murainagras (Ischaemum spp.)',
  10007621: 'Leersia (Leersia Hexandra)',
  10007622: 'Amerikanisches Dünengras (Leymus spp.)',
  10007623: 'Italienisches Raygras (Lollium Multiforum)',
  10007624: 'Deutsches Weidelgras (Lolium Perenne)',
  10007625: 'Bastardweidelgras (Lolium X Hybridum)',
  10007626: 'Rubingras (Melinis Repens)',
  10007627: 'Napiergras (Pennisetum Purpureum)',
  10007628: 'Rohrleitungen - Sets',
  10007629: 'Textmarker',
  10007630: 'Indianisches Reisgras (Oryzopis Hymenoides)',
  10007631: 'Buntes Guineagras (Panicum Coloratum)',
  10007632: 'Guineagras (Panicum Maximum)',
  10007633: 'Rutehirse (Panicum Vigatum)',
  10007634: 'Buffalo-Gras (Paspalum Conjugatum)',
  10007635: 'Bahiagras (Paspalum Notatum)',
  10007636: 'Kodo-Hirse (Paspalum Scobiculatum)',
  10007637: 'Kikuyu-Gras (Pennisetum Cladestinum)',
  10007638: 'Rohrglanzgras (Phalaris spp.)',
  10007639: 'Wiesen-Lieschgras (Phleum Pratense)',
  10007640: 'Sumpf-Rispengras (Poa Palustris)',
  10007641: 'Wiesen-Rispengras (Poa Pratensis)',
  10007642: 'Wiesenrispengras (Poa spp.)',
  10007643: 'Javagras (Polytrias Armaura)',
  10007644: 'Rohr-Schwingel (Schedonorus Arundinaceus)',
  10007645: 'Hammam-Kabine',
  10007646: 'Infrarot-Kabine',
  10007647: 'Sauna-Kabine',
  10007648: 'Sonnenbank',
  10007649: 'Gesundheits- und Wellnessvorrichtungen - Ersatzteile und Zubehör',
  10007650: 'Gesundheit- und Wellness - Multifunktionskabine',
  10007651: 'Gemüsespargel (Aspargus Officinalis)',
  10007652: 'Kolbenhirse (Setaria Italica)',
  10007653: 'Eiskraut (Mesembryanthemum Crystallinum)',
  10007654: 'Kohlrabi (Brassica Oleracea var. Gongylodes)',
  10007655: 'Wilde Artischocke (Cynara Cardunculus)',
  10007656: 'Rote Borstenhirse (Setaria Pumila)',
  10007657: 'Artischocke (Cynara Scolymus)',
  10007658: 'Fenchel (Foeniculum Vulgare)',
  10007659: 'Metroxylon Spp',
  10007660: 'Rhaponik-Rhabarber',
  10007661: 'Borstenhirse (Setaria spp.)',
  10007663: 'Sudangras (Sorghum x Drummondii)',
  10007665: 'Riesenblättriges Pfeilblatt (Alocasia Macrorrhizos)',
  10007666: 'Sorghum X Almum',
  10007667: 'Teufelszunge (Amorphophallus Konjac)',
  10007668: 'Echter Sellerie (Apium Graveolens)',
  10007669: 'St. Augustin-Gras (Stenotaphrum Secundatum)',
  10007670: 'Große Klette (Actium Lappa)',
  10007671: 'Känguru-Gras (Themata Triandra)',
  10007672: 'Arakacha (Arracacia Xanthorrhiza)',
  10007673: 'Rote Bete (Beta Vulgaris Subsp. Vulgaris var. Conditiva)',
  10007674: 'Elefantenohr (Colocasia Antiquorum)',
  10007675: 'Taro (Colocasia Esculenta)',
  10007676: 'Gamagras (Tripsacum spp.)',
  10007677: 'Erdmandel (Cyperus Esculentus)',
  10007678: 'Möhre (Baucus Carota)',
  10007679: 'Urochloa Mosambicensis',
  10007680: 'Kartoffel-Yams (Dioscorea Esculenta)',
  10007681: 'Wasseryams (Dioscorea Alata)',
  10007682: 'Signalgras (Urochoa Panicoides)',
  10007683: 'Luftkartoffel (Dioscorea Bulbifera)',
  10007684: 'Indische Yams (Dioscorea Trifida)',
  10007685: 'Wasserkastanie (Eleocharis Dulcis)',
  10007686: 'Zoysia-Gras (Zoysia spp.)',
  10007687: 'Topinambur (Helianthus Tuberosus)',
  10007688: 'Süßkartoffel (Ipomoea Batatas)',
  10007689: 'Maniok (Manihot Esculenta)',
  10007690: 'Pfeilwurz (Maranta Arundinacea)',
  10007691: 'Indische Lotusblume (Nelumbo Nucifera)',
  10007692: 'Knolliger Sauerklee (Oxalis Tuberosa)',
  10007693: 'Yambohne (Pachyrhizus Erosus)',
  10007694: 'Knollenbohne (Pachyrhizus Tuberosus)',
  10007695: 'Pastinak (Pastinaca Sativa)',
  10007696: 'Garten-Rettich (Raphanus Sativus)',
  10007697: 'Winterrettich (Raphanus Sativus var. Longipinnatus)',
  10007698: 'Schwarzer Winter-Rettich (Raphanus Sativus var. Niger)',
  10007699: 'Garten-Schwarzwurzel (Scorzonera Hispanica)',
  10007700: 'Zuckerwurzel (Saum Sisarum)',
  10007701: 'Yacón (Smallanthus Sonchifolius)',
  10007702: 'Kartoffel (Solanum Tuberosum)',
  10007703: 'Afrikanische Yambohne (Sphenostylis Stenocarpa)',
  10007704: 'Haferwurzel (Tragopogon Porrifolius)',
  10007705: 'Knollige Kapuzinerkresse (Tropaeolum Tuberosum)',
  10007706: 'Ollucu (Ullucus Tuberosus)',
  10007707: 'Tania (Xanthosoma Sagittifolium)',
  10007708: 'Ingwer (Zingiber Officinale)',
  10007709: 'Champignon (Agaricus)',
  10007710: 'Gemeiner Steinpilz (Boletus Edulis)',
  10007711: 'Echter Pfifferling (Cantharellus Cibarius)',
  10007712: 'Gemeiner Samtfußrübling (Flammulina Velutipes)',
  10007713: 'Glänzender Lackporling (Ganoderma Luzidem)',
  10007714: 'Hypsizgus Tessellatus',
  10007715: 'Shiitake (Lentinula Edodes)',
  10007716: 'Speise-Morchel (Morcheln Esculenta)',
  10007717: 'Kräuterseitling (Pleurotus Eryngii)',
  10007718: 'Austern-Seitling (Pleurotus Ostreatus)',
  10007719: 'Sommer Trüffel (Tuber Aestivum)',
  10007720: 'Waldpilze',
  10007721: 'Möbelfüße',
  10007722: 'Mittel zur Fehler-/ Oberflächenrissprüfung',
  10007723: 'Taste für die Toilettenspülung',
  10007724: 'Brausearm',
  10007725: 'Brauseschlauch',
  10007726: 'Duschsets',
  10007727: 'Dusch-Schieberegler',
  10007728: 'Spanische Pfefferpflanzen (Capsicum Annum)',
  10007729: 'Sapanische Pfefferbäume (Capsicum Annum)',
  10007730: 'Glockenchili (Capsicum Baccatum)',
  10007731: 'Chili (Capsicum Frutescens)',
  10007732: 'Gemeiner Bocksdorn (Lycium Barbarum)',
  10007733: 'Tomatillo (Physalis Philadelphica)',
  10007734: 'Tomate (Solanum Lycopersicum)',
  10007735: 'Afrikanische Aubergine (Solanum Macrocarpon)',
  10007736: 'Aubergine (Solanum Melongena)',
  10007737: 'Pepino (Solanum Muricatum)',
  10007738: 'Lulo (Solanum Quitoense)',
  10007739: 'Schwarzenbeere (Solanum Retroflexum)',
  10007740: 'Wachskürbis (Benincasa Hispida)',
  10007741: 'Wassermelone (Citrullus Lutantus)',
  10007742: 'Tindola (Coccinia Grandis)',
  10007743: 'Cantaloupe-Melone (Cucumis Melo var. Cantaloupensis)',
  10007744: 'Armenische Melone (Cucumis Melo var. Conomon)',
  10007745: 'Armenische Melone (Curcumis Melo var. Flexuosus)',
  10007746: 'Honigmelone (Cucumis Melo var. Inodorus)',
  10007747: 'Galiamelone (Cucumis Melo var. Reticulatus)',
  10007748: 'Horngurke (Cucumis Metuliferus)',
  10007749: 'Gurke (Cucumis Sativus)',
  10007750: 'Riesen-Kürbis (Cucurbita Maxima)',
  10007752:
    'Speisekürbis, Zucchini und andere Sorten des Gartenkürbis (Curcurbita Pepo)',
  10007753: 'Pattisson (Cucurbita Melopepo)',
  10007754: 'Moschus-Kürbis (Curcurbita Moschata)',
  10007755: 'Flaschenkürbis (Lagenaria Siceraria)',
  10007756: 'Luffa (Luffa)',
  10007757: 'Bittermelone (Momordica Charantia)',
  10007758: 'Chayote (Sechium Edule)',
  10007759: 'Okra (Abelmoschus Esculentus)',
  10007760: 'Levellierungszement / -mörtel',
  10007761: 'Bisameinbisch (Abelmoschus Moschatus)',
  10007762: 'Gnetum Gnemon',
  10007763: 'Zuckermais (Zea Mays Subsp. Saccharata)',
  10007764: 'Endivien (Cichorium Endivia)',
  10007765: 'Zuckerhut (Cichorium Intybus var. Foliosum)',
  10007766: 'Salat-Zichorie (Cichorium Intybus var. Foliosum)',
  10007767: 'Wurzelzichorie (Cichorium Intybus var. Sativum)',
  10007768: 'Aquarium / Vivarium',
  10007769: 'Radicchio (Cichorium Intybus var. Foliosum)',
  10007770: 'Puntarelle (Cichorium Intybus Gr. Catalugna)',
  10007771: 'Kopfsalat (Lactuca Sativa var. Capitata)',
  10007772: 'Römersalat (Lactuca Sativa var. Romana)',
  10007773: 'Schnittsalat (Lactuca Sativa var. Crispa)',
  10007774: 'Chinarindenbäume (Cinchona)',
  10007775: 'Spargelsalat (Lactuca Sativa var. Angustana)',
  10007776: 'Spanische Limette (Meliococcus Bijgatus)',
  10007777: 'Garten-Senfrauke (Erica Sativa)',
  10007778: 'Amerikanische Stachelbeere (Ribes Hirtellum)',
  10007779: 'Choisum (Brassica Chinensis var. Parachinensis)',
  10007780: 'Schwarze Johannisbeere (Ribes Nigrum)',
  10007781: 'Brauner Senf (Brassica Junacea)',
  10007782: 'Rote Johannisbeere (Ribes Rubrum)',
  10007783: 'Tatsoi (Brassica Narinosa)',
  10007784: 'Stachelbeere (Ribes Uva-Crispa)',
  10007785: 'Pak Choi (Brassica Chinensis)',
  10007786: 'Jostabeere (Ribes X Nidigrolaria)',
  10007787: 'Moltebeere (Rubus Chamaemorus)',
  10007788: 'Japanische Weinbeere (Rubus Phoenicolasius)',
  10007789: 'Blattkohl (Brassica oleracea var. viridis)',
  10007790: 'Umbu (Spondias Tuberosa)',
  10007791: 'Brotfruchtbaum (Artocarpus Altilis)',
  10007792: 'Curubabaum (Passiflora Mollissima)',
  10007793: 'Komatsuna (Brassica Perviridis)',
  10007794: 'Japanischer Senfkohl (Brassica Rapa Japonica)',
  10007795: 'Mizuna (Brassica Rapa Subsp. Nipposinica)',
  10007796: 'Chinakohl (Brassica Pekinensis)',
  10007797: 'Gartenkresse (Lepidium Sativum)',
  10007798: 'Echte Brunnenkresse (Nasturtium Officinale)',
  10007799: 'Amarant (Amaranthus)',
  10007800: 'Melden (Atriplex)',
  10007801: 'Mangold (Beta Vulgaris Subsp. Vulgaris var. Cicla)',
  10007802: 'Spinat (Spinacia Oleracea)',
  10007803: 'Baumspinat (Cnidoscolus Aconitifolius)',
  10007804: 'Gewöhnlicher Feldsalat (Valerianella Locusta)',
  10007805: 'Wasserspinat (Ipomaea Aquatica)',
  10007806: 'Portulak (Portulaca Oleracea)',
  10007807: 'Wiesen-Sauerampfer (Rummel Acetosa)',
  10007808: 'Neuseeländischer Spinat (Tetragonia Tetragoniodes)',
  10007809: 'Lauch (Allium Porrum)',
  10007810: 'Australische Kastanie - lebende Pflanzen',
  10007811: 'Kaffee - lebende Pflanzen',
  10007812: 'Venusfliegenfalle - lebende Pflanzen',
  10007813: 'Pferdeeppich (Smyrnium Olusatrum)',
  10007814: 'Arznei-Engelwurz (Angelica Archangelica)',
  10007815: 'Anis (Pimpinella Anisum)',
  10007816: 'Ginseng (Panax)',
  10007817: 'Basilikum (Basilicum Spp.)',
  10007818: 'Echter Lorbeer (Laurus Nobilis)',
  10007819: 'Goldmelisse (Monarda Didyma)',
  10007820: 'Mariendistel (Silybum Marianum)',
  10007821: 'Boldostrauch (Peumus Boldus)',
  10007822: 'Borretsch (Borago Officinalis)',
  10007823: 'Wiesenknopf (Sanguisorba Spp.)',
  10007824: 'Echter Sellerie (Apium Graveolens)',
  10007825: 'Echter Kerbel (Anthriscus Cerefolium)',
  10007826: 'Schnittlauch (Allium Schoenoprasum)',
  10007827: 'Echter Koriander (Coriandrum Sativum)',
  10007828: 'Mexikanischer Oregano (Plectranthus Amboinicus)',
  10007829: 'Löwenzahn (Taraxacum)',
  10007830: 'Dill (Anethum Graveolens)',
  10007831: 'Bockshornklee (Trigonella Foenum-Graecum)',
  10007832: 'Chinesischer Ingwer (Boesenbergia Rotunda)',
  10007833: 'Knoblauch-Schnittlauch (Allium Tuberosum)',
  10007834: 'Enzian (Gentiana Spp.)',
  10007835: 'Kleinbütiges Kopfkraut (Galinsoga Parviflora)',
  10007836: 'Ysop (Hyssopus Officinalis)',
  10007837: 'Indianertabak (Lobelia Inflata)',
  10007838: 'Wildes Stiefmütterchen (Viola Tricolor)',
  10007839: 'Ztronenmelisse (Melissa Officinalis)',
  10007840: 'Zitronenstrauch (Aloysia Citriodora)',
  10007841: 'Zitronengras (Cymbopogon Citratus)',
  10007842: 'Liebstöckel (Levisticum Officinale)',
  10007843: 'Majoran (Origanum Majorana)',
  10007844: 'Echtes Mädesüß (Filipendula Ulmaria)',
  10007845: 'Minze (Mental Spp.)',
  10007846: 'Beifuß (Artemisia Vulgaris)',
  10007847: 'Oregano (Origanum Vulgare)',
  10007848: 'Petersilie (Petroselinum Crispum)',
  10007849: 'Perilla (Perilla Frutescens)',
  10007850: 'Ringelblume (Caldenula Officinalis)',
  10007851: 'Purpur-Sonnenhut (Echinacea Purpurea)',
  10007852: 'Bärlauch (Allium Ursinum)',
  10007853: 'Spitzwegerich (Plantago Lanceolata)',
  10007854: 'Reisfeldpflanze (Limnophila Aromatica)',
  10007855: 'Rosmarin (Rosmarinus Officinalis)',
  10007856: 'Weinraute (Ruta Graveolens)',
  10007857: 'Echter Salbei (Salvia Officinalis)',
  10007858: 'Sassafrasbaum (Sassafras Albidum)',
  10007859: 'Bohnenkräuter (Satureja)',
  10007860: 'Sauerdock (Rumex Arcticus)',
  10007861: 'Süßkraut (Stevia Rebaudiana)',
  10007862: 'Süßdolde (Myrrhis Odorata)',
  10007863: 'Estragon (Artemisia Dracunculus)',
  10007864: 'Echter Thymian (Thymus Vulgaris)',
  10007865: 'Echter Wasabi (Eutrema Japonicum)',
  10007866: 'Wermutkraut (Artemisia Absinthium)',
  10007867: 'Mohrenpfeffer (Xylopia Aethiopica)',
  10007868: 'Ajowan (Trachyspermum Ammi)',
  10007869: 'Piment (Pimenta Dioica)',
  10007870: 'Brasilianischer Quassiabaum (Quassia Amara)',
  10007871: 'Annattostrauch (Bixa Orellana)',
  10007872: 'Schwarzer Kardamom (Amomum Subulatum)',
  10007873: 'Gewöhnlicher Knollenkümmel (Bunium Bulbocastanum)',
  10007874: 'Schwarzer Pfeffer (Piper Nigrum)',
  10007875: 'Brasilianischer Pfefferbaum (Schinus Terebinthifolia)',
  10007876: 'Echter Kapernstrauch (Capparis Spinosa)',
  10007877: 'Echter Kümmel (Carum Carvi)',
  10007878: 'Zimtkassie (Cinnamomum Cassia)',
  10007879: 'Molchschwanz (Houttuynia Cordata)',
  10007880: 'Ceylon-Zimtbaum (Cinnamomum Verum)',
  10007881: 'Gewürznelkenbaum (Syzgium Aromaticum)',
  10007882: 'Kubeben-Pfeffer (Piper Cubeba)',
  10007883: 'Kreuzkümmel (Cuminum Cyminum)',
  10007884: 'Currybaum (Murraay Koenigii)',
  10007885: 'Mexikanischer Drüsengänsefuß (Chenopodium Ambrosiodes)',
  10007886: 'Thai-Ingwer (Alpinia Galanga)',
  10007887: 'Grüner Kardamom (Elettaria Cardamomum)',
  10007888: 'Langer Pfeffer (Piper Longum)',
  10007889: 'Indonesisches Lorbeerblatt (Eugenia Polyantha)',
  10007890: 'Gemeiner Wacholder (Juniperus Communis)',
  10007891: 'Tahiti-Pfeffer (Piper Excelsum)',
  10007892: 'Australische Zitronenmyrte (Backhousia Citriodoria)',
  10007893: 'Echtes Süßholz (Glycyrrhiza Glabra)',
  10007894: 'Langer Koriander (Eryngium Foetidum)',
  10007895: 'Steichweichsel (Prunus Mahaleb)',
  10007896: 'Paradieskörner (Aframomum Melegueta)',
  10007897: 'Mexikanischer Blattpfeffer (Piper Auritum)',
  10007898: 'Südliches Pfefferholz (Pseudowintera Colorata)',
  10007899: 'Myrte (Myrtus)',
  10007900: 'Echter Schwarzkümmel (Nigella Sativa)',
  10007901: 'Njangsa (Ricinodendron Heudelotii)',
  10007902: 'Muskatnussbaum (Myristica Fragrans)',
  10007903: 'Schraubenbaum (Pandanus Utilis)',
  10007904: 'Peruanischer Pfefferbaum (Schinus Molle)',
  10007905: 'Schlafmohn (Papaver Somniferum)',
  10007906: 'Türkischer Oregano (Origanum Onites)',
  10007907: 'Safran (Crocus Sativus)',
  10007908: 'Helm-Knabenkraut (Orchis Militaris)',
  10007909: 'Szechuanpfeffer (Zanthoxylum)',
  10007910: 'Eberraute (Artemisia Abrotanum)',
  10007911: 'Echter Sternanis (Illicium Verum)',
  10007912: 'Gerber-Sumach (Rhus Coriaria)',
  10007913: 'Tasmanischer Bergpfeffer (Drimys Lanceolata)',
  10007914: 'Tonkabohnenbaum (Dipteryx Odorata)',
  10007915: 'Kurkuma (Curcuma Longa)',
  10007916: 'Gewürzvanille (Vanilla Planifolia)',
  10007917: 'Vietnamesischer Koriander (Persicaria Odorata)',
  10007918: 'Mönchspfeffer (Vitex Agnes-Castus)',
  10007919: 'Wasserpfeffer (Persicaria Hydropiper)',
  10007920: 'Zitwerwurzel (Curcuma Zedoaria)',
  10007921: 'Ludwigien - lebende Pflanzen',
  10007922: 'Bananen - lebende Pflanzen',
  10007923: 'Peperomien - lebende Pflanzen',
  10007924: 'Chinesischer Geldbaum - lebende Pflanzen',
  10007925: 'Philodendren - lebende Pflanzen',
  10007926: 'Fiederaralien - lebende Pflanzen',
  10007927: 'Steckenpalme- lebende Pflanzen',
  10100000: 'Haustierbedarf',
  10101500: 'Haustierfürsorge / –Hygiene',
  10101600: 'Nahrungsergänzung für Haustiere',
  10101700: 'Haustierzubehör',
  10101800: 'Haustierbedarf',
  10110000: 'Haustiernahrung',
  10111500: 'Haustiergetränke',
  10111600: 'Haustierfutter',
  10111700: 'Haustierfutter / –getränke – Sets',
  10120000: 'Haustierbedarf / Haustiernahrung – Sets',
  10120100: 'Haustierbedarf / Haustiernahrung – Sets',
  47000000: 'Reinigungsmittel / Haushygiene',
  47100000: 'Reinigungsmittel',
  47101500: 'Lufterfrischer / Textilerfrischer',
  47101600: 'Reiniger',
  47101700: 'Wäschepflege',
  47101900: 'Oberflächenpflege',
  47102000: 'Reinigungsmittel – Sets',
  47120000: 'Insekten– / Schädlingsbekämpfung',
  47121500: 'Insekten– / Schädlingsbekämpfung',
  47190000: 'Reinigungsmittel / Haushygieneprodukte – Sets',
  47190100: 'Reinigungsmittel / Haushygieneprodukte – Sets',
  47200000: 'Reinigungs– / Hygienebedarf',
  47200100: 'Produktspender',
  47210000: 'Entsorgungsprodukte',
  47210100: 'Produkte zur Abfalllagerung',
  50000000: 'Lebensmittel / Getränke / Tabakwaren',
  50100000: 'Obst / Gemüse / Nüsse / Samen – bearbeitet / verarbeitet',
  50101800: 'Nüsse / Samen – bearbeitet / verarbeitet',
  50101900: 'Früchte– / Nüsse– / Samen–Mischungen',
  50102000: 'Obst – bearbeitet / verarbeitet',
  50102100: 'Gemüse – bearbeitet / verarbeitet',
  50102200: 'Obst / Gemüse / Nüsse / Samen – Mischpackungen',
  50120000: 'Fisch / Meeresfrüchte',
  50121500: 'Fisch – nicht bearbeitet / verarbeitet',
  50121700:
    'Krustentiere / Muscheln / Schnecken – nicht bearbeitet / verarbeitet',
  50121800: 'Wasserpflanzen / Algen – nicht bearbeitet / verarbeitet',
  50121900: 'Fisch – bearbeitet / verarbeitet',
  50122000: 'Weichtiere – bearbeitet / verarbeitet',
  50122100: 'Krustentiere / Muscheln / Schnecken – bearbeitet / verarbeitet',
  50122200: 'Wasserpflanzen / Algen – bearbeitet / verarbeitet',
  50122300: 'Weichtiere – nicht bearbeitet / verarbeitet',
  50122400: 'Fisch / Meeresfrüchte – Mischpackungen',
  50122500: 'Fisch / Meeresfrüchte – Mischungen',
  50130000: 'Milch / Butter / Sahne / Käse / Eier / Ersatzprodukte',
  50131700: 'Milch / Milchersatz',
  50131800: 'Käse / Käseersatz',
  50131900: 'Butter / Butterersatz',
  50132000: 'Sahne / Sahneersatz',
  50132100: 'Joghurt / Joghurtersatz',
  50132200:
    'Milch / Butter / Sahne / Käse / Eier / Ersatzprodukte – Mischpackungen',
  50132300: 'Eier / Eierextrakte (industrielles Verfahren)',
  50132500: 'Eier / Eierersatz',
  50132600: 'Molkerei-Nebenerzeugnis / Molkereiderivate',
  50150000: 'Speiseöle / –Fette',
  50151500: 'Speiseöl',
  50151600: 'Speisefett',
  50151700: 'Speiseöl– / Speisefett – Mischpackungen',
  50160000: 'Süßwaren / Süßungsmittel',
  50161500: 'Zucker– / Zuckerersatzprodukte',
  50161800: 'Süßwaren',
  50161900: 'Süßwaren / Süßungsmittel –  Mischpackungen',
  50170000: 'Gewürze / Konservierungsstoffe / Extrakte',
  50171500: 'Kräuter / Gewürze / Extrakte',
  50171700: 'Essig / Kochweine',
  50171800: 'Saucen / Aufstriche / Dips / Würzsaucen',
  50171900: 'Eingelegtes Gemüse / Relishes / Chutneys / Oliven',
  50172000: 'Gewürze / Konservierungsstoffe / Extrakte – Mischpackungen',
  50180000: 'Brot / Backwaren',
  50181700: 'Back– / Kochmischungen / Zutaten',
  50181900: 'Brot',
  50182000: 'Süße Backwaren',
  50182100: 'Kekse / Gebäck',
  50182200: 'Herzhafte Backwaren',
  50182300: 'Brot / Backwaren – Mischpackungen',
  50190000: 'Bearbeitete / Verarbeitete Nahrungsmittel',
  50191500: 'Fertigsuppen',
  50192100: 'Snacks / Knabberartikel',
  50192300: 'Desserts / Dessertsaucen / Garnierungen',
  50192400: 'Süße Aufstriche',
  50192500: 'Sandwiches / belegte Brötchen / Wraps',
  50192900: 'Teigwaren / Nudeln',
  50193000: 'Baby– / Kleinkindernahrung',
  50193100: 'Gemüse-/Kartoffelbasierte Produkte/ -Gerichte',
  50193200: 'Getreidebasierte Produkte /- Gerichte',
  50193300: 'Teigbasierte Produkte/- Gerichte',
  50193400: 'Bearbeitete / Verarbeitete Nahrungsmittel – Mischpackungen',
  50193500:
    'Fertigprodukte / Gerichte auf Basis von Molkereierzeugnissen/Ei–Erzeugnissen',
  50193600: 'Fleischersatz',
  50193800: 'Fertiggerichte aus mehreren Zutaten',
  50200000: 'Getränke',
  50201700: 'Kaffee / Tee / Ersatzprodukte',
  50202200: 'Alkoholische Getränke',
  50202300: 'Alkoholfreie Getränke – trinkfertig',
  50202400: 'Alkoholfreie Getränke – nicht trinkfertig',
  50202500: 'Getränke – Mischpackungen',
  50210000: 'Tabakwaren- / Cannabis-/ Raucherzubehör',
  50211500: 'Tabakwaren /Kanabisprodukte /  Raucherzubehör',
  50220000: 'Getreide– / Hülsenfruchtprodukte',
  50221000: 'Getreide / Mehl',
  50221200: 'Bearbeitete Getreideprodukte',
  50221300: 'Getreide– / Korn– / Hülsenfruchtprodukte – Mischpackungen',
  50230000: 'Lebensmittel / Getränke / Tabakwaren – Mischpackungen',
  50230100: 'Lebensmittel / Getränke / Tabakwaren – Mischpackungen',
  50240000: 'Fleisch / Geflügel / sonstige Tiere',
  50240100: 'Fleisch / Geflügel / sonstige Tiere – bearbeitet / verarbeitet',
  50240200:
    'Fleisch / Geflügel / sonstige Tiere – nicht bearbeitet / verarbeitet',
  50240300:
    'Würste (Fleisch / Geflügel / sonstige Tiere) – bearbeitet / verarbeitet',
  50250000: 'Obst – nicht bearbeitet / verarbeitet (frisch)',
  50250600: 'Zitrusfrüchte',
  50250700: 'Bananen',
  50250800: 'Kernobst',
  50250900: 'Steinobst',
  50251000: 'Beeren / Kleinobst',
  50251100: 'Ananas',
  50251200: 'Kiwis',
  50251300: 'Annonen',
  50251400: 'Avocados',
  50251500: 'Kakifrüchte',
  50251600: 'Passionsfrüchte',
  50251700: 'Papayas',
  50251800: 'Pitahayas',
  50251900: 'Sonstiges Obst',
  50252000: 'Obst – nicht bearbeitet / verarbeitet (frisch) – Mischpackungen',
  50260000:
    'Gemüse (ohne Blattgemüse) – nicht bearbeitet / verarbeitet (frisch)',
  50260100: 'Wurzel– / Knollengemüse',
  50260200: 'Zwiebelgemüse',
  50260300: 'Tomaten',
  50260400: 'Paprika',
  50260500: 'Sonstige Nachtschattengewächse',
  50260600: 'Gurken',
  50260700: 'Kürbisse – essbare Schale',
  50260800: 'Melonen',
  50260900: 'Kürbisse – ungenießbare Schale',
  50261000: 'Sonstige Gemüse',
  50261100: 'Kohlgemüse',
  50261300: 'Kräuter',
  50261400: 'Bohnen (mit Hülsen)',
  50261500: 'Erbsen (mit Hülsen)',
  50261600: 'Stängelgemüse',
  50261700: 'Pilze',
  50261800: 'Gemüse – nicht bearbeitet / verarbeitet (frisch) – Mischpackungen',
  50261900: 'Mikrogemüse',
  50262000: 'Essbare Blumen',
  50262100: 'Gemüse aus dem Meer',
  50262200: 'Kichererbsen',
  50262300: 'Sukkulente',
  50262400: 'Farnpflanzen',
  50262500: 'Sapote',
  50262600: 'Zuckerrohr',
  50262700: 'Seggen / Riedgras',
  50270000: 'Obst – nicht bearbeitet / verarbeitet (tiefgefroren)',
  50270100: 'Obst – nicht bearbeitet / verarbeitet (tiefgefroren)',
  50290000: 'Gemüse – nicht bearbeitet / verarbeitet (tiefgefroren)',
  50290100: 'Gemüse – nicht bearbeitet / verarbeitet (tiefgefroren)',
  50310000: 'Obst – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  50310100: 'Obst – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  50320000: 'Gemüse – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  50320100: 'Gemüse – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  50330000:
    'Nüsse / Samen – nicht bearbeitet / verarbeitet (leicht verderblich)',
  50330100:
    'Nüsse / Samen – nicht bearbeitet / verarbeitet (leicht verderblich)',
  50340000:
    'Nüsse / Samen – nicht bearbeitet / verarbeitet (ohne Kühlung Haltbar)',
  50340100:
    'Nüsse / Samen – nicht bearbeitet / verarbeitet (ohne Kühlung haltbar)',
  50350000: 'Blattgemüse – nicht bearbeitet / verarbeitet (frisch)',
  50350100: 'Blätter der Wegwarte',
  50350200: 'Kopfsalat',
  50350300: 'Lose Blätter / Multiblattsalate',
  50350400: 'Salatgrün in einzelnen Blättern',
  50350500: 'Spinat (frisch)',
  50350600:
    'Blattgemüse – nicht bearbeitet / verarbeitet (frisch) – Mischpackungen',
  50350700: 'Spargelsalat',
  51000000: 'Gesundheitswesen',
  51100000: 'Gesundheitswesen – Behandlung / Hilfsmittel',
  51101500: 'Persönliche Hilfsmittel',
  51101600: 'Medikamentenverabreichung',
  51101700: 'Erste–Hilfe–Produkte',
  51101800: 'Fuß– / Beinpflege / Behandlung',
  51101900: 'Entwöhnungsbehandlung',
  51102100: 'Präparate / Hilfsmittel für Sinnesorgane (Augen / Ohren)',
  51102200: 'Baby– / Kleinkinder–Behandlung',
  51102300: 'Gesundheitswesen – Behandlung / Hilfsmittel – Sets',
  51102400:
    'Präparate gegen Beschwerden der Blase / im Genital– / Rektalbereich',
  51102500: 'Schmerzmittel / Schmerzbekämpfung',
  51102600: 'Homöopathische – / Pflanzliche Mittel',
  51102700: 'Gastrointestinale Präparate',
  51102800: 'Schlafmittel / Anti–Stress–Mittel',
  51102900: 'Produkte gegen Atemwegserkrankungen / Allergien',
  51103000:
    'Unterstützende Produkte gegen Erkrankungen / Verletzungen der Haut / Kopfhaut',
  51103100: 'Reisekrankheitsmittel',
  51103200: 'Geräte / Hilfsmittel zur enteralen Ernährung',
  51103300: 'Mund– / Rachenmittel',
  51103400: 'Gesundheitswesen Materialien für Behandlungen / Hilfsmittel',
  51110000: 'Familienplanung',
  51111500: 'Mechanische Verhütungsmittel',
  51111600: 'Hormonelle Verhütungsmittel',
  51111700: 'Intrauterine Verhütung',
  51111800: 'Familienplanung – Sets',
  51120000: 'Gesundheitsförderung',
  51121500: 'Diätunterstützung',
  51121600: 'Vitamine / Mineralstoffe / Nahrungsergänzungsmittel',
  51121800: 'Gesundheitsförderung – Sets',
  51121900: 'Stimulantien / Aufputschmittel',
  51130000: 'Heimdiagnostik',
  51131500: 'Diagnostik – Überwachung',
  51131600: 'Diagnostik – Tests',
  51131700: 'Heimdiagnostik – Sets',
  51140000: 'Gesundheitswesen – Sets',
  51140100: 'Gesundheitswesen – Sets',
  51150000: 'Medizinprodukte',
  51150100: 'Medizinprodukte',
  51160000: 'Arzneimittel',
  51160100: 'Arzneimittel',
  51170000: 'Arzneimittel / Gesundheitspflege für Haustiere',
  51170100: 'Arzneimittel für Haustiere',
  51170200: 'Medizinprodukte für Haustiere',
  53000000: 'Schönheit / Körperpflege / Hygieneartikel',
  53130000: 'Hautpflege',
  53131100: 'Hautpflegeprodukte',
  53131200: 'Bräunungsprodukte',
  53131300: 'Körperreinigung',
  53131400: 'Hautpflege – Sets',
  53140000: 'Haarpflege / Haarentfernung',
  53141000: 'Haarentfernung / Haarkuren',
  53141100: 'Haarpflegeprodukte',
  53141200: 'Haarpflege / Haarentfernung – Sets',
  53160000: 'Kosmetik / Parfüm / Düfte / Schönheitspflege',
  53161000: 'Kosmetikprodukte',
  53161200: 'Nagelkosmetik / Nagelpflege',
  53161300: 'Parfüms / Düfte',
  53161400: 'Kosmetik / Parfüms / Düfte – Sets',
  53161500: 'Aromatherapie',
  53180000: 'Hygieneartikel / Mundhygiene',
  53181100: 'Allgemeine Körperhygiene',
  53181200: 'Damenhygiene / Stillhygiene',
  53181300: 'Inkontinenzprodukte für Erwachsene',
  53181500: 'Mundhygiene',
  53181600: 'Hygieneartikel / Mundhygiene – Sets',
  53181700: 'Babywindeln/Zubehör',
  53200000: 'Produkte für den Körper',
  53201000: 'Körpermassage / Muskelstimulatoren',
  53220000: 'Schönheit / Körperpflege / Hygieneartikel  – Sets',
  53220100: 'Schönheit / Körperpflege / Hygieneartikel  – Sets',
  53230000: 'Sexspielzeuge',
  53230100: 'Sexspielzeuge / –Hilfen',
  58000000: 'Segmentübergreifende Klassifikation',
  58010000: 'Segmentübergreifende Klassifikation',
  58010100: 'Segmentübergreifende Klassifikation',
  60000000: 'Druckmedien / Textmedien',
  60010000: 'Druckmedien / Textmedien',
  60010100: 'Druckmedien / Textmedien – Sets',
  60010200: 'Bücher',
  60010300: 'Zeitungen / Zeitschriften',
  60010400: 'Karten',
  61000000: 'Musik',
  61010000: 'Musikinstrumente / Zubehör',
  61010200: 'Musikinstrumente (akustisch / mechanisch)',
  61010300: 'Musikinstrumente (elektrisch / elektronisch)',
  61010400: 'Musikinstrumente – Zubehör',
  61010500: 'Musikinstrumente / Zubehör – Sets',
  62000000: 'Schreibwaren / Bürobedarf / Büromaschinen / Partyartikel',
  62050000: 'Glückwunschkarten / Geschenkverpackungen / Partyartikel',
  62050100: 'Geschenkverpackungen / Zubehör',
  62050200: 'Glückwunschkarten / Geschenkpapier / Partyartikel – Sets',
  62050300: 'Glückwunschkarten / Einladungskarten',
  62050400: 'Party– / Dekorationsartikel',
  62060000: 'Schreibwaren / Bürobedarf / Büromaschinen',
  62060100: 'Schreib– / Gestaltungsutensilien / Hilfsmittel',
  62060300: 'Büromaschinen',
  62060400: 'Planungs– / Organisationshilfsmittel',
  62060500: 'Versandmaterialien / Postbearbeitung / Zubehör',
  62060600: 'Präsentationsmaterialien / –Geräte',
  62060700: 'Bürobedarf – Klebemittel / Bindemaschinen / Heftmaschinen',
  62060800: 'Bürobedarf – Schneidewerkzeuge / Schredder / Locher',
  62060900: 'Bürobedarf – Aufbewahrung / Archivierung',
  62061000: 'Schreibwaren / Bürobedarf / Büromaschinen – Sets',
  62061100: 'Bürobedarf – Papiere / Kartone / Folien',
  62061200: 'Schreibwaren / Büromaschinen – sonstige',
  62070000: 'Schreibwaren / Bürobedarf / Büromaschinen / Partyartikel –Sets',
  62070100: 'Schreibwaren / Bürobedarf / Büromaschinen / Partyartikel –Sets',
  63000000: 'Schuhe',
  63010000: 'Schuhe',
  63010100: 'Sportschuhe',
  63010200: 'Schuhzubehör',
  63010300: 'Universalschuhe',
  63010400: 'Hausschuhe',
  63010500: 'Sicherheitsschuhe',
  64000000: 'Persönliche Accessoires',
  64010000: 'Persönliche Accessoires',
  64010100: 'Schmuck',
  64010200: 'Persönliche Accessoires / Koffer / Taschen',
  64010300: 'Armbanduhren / Taschenuhren',
  64010400: 'Persönliche Accessoires – Sets',
  65000000: 'Computer / PC– / Videospiele',
  65010000: 'Computer / PC– / Videospiele',
  65010100: 'Computer / PC– / Videospiele – Zubehör',
  65010200: 'Computer – Komponenten',
  65010300: 'Computer – Laufwerke',
  65010400: 'Computer / PC– / Videospiele – Software',
  65010500: 'Computer',
  65010600: 'Computer / PC– / Videospiele – Steuer– / Eingabegeräte',
  65010700: 'Computer / PC– / Videospiele – Peripheriegeräte',
  65010800: 'Computer – Netzwerk–Ausstattung',
  65010900: 'Computer / PC– / Videospiele – Sets',
  65011000: 'Spielkonsolen',
  66000000: 'Kommunikation',
  66010000: 'Kommunikation',
  66010100: 'Kommunikationsgeräte – Zubehör',
  66010200: 'Kommunikationsgeräte – Festnetz / kabelgebunden',
  66010300: 'Kommunikationsgeräte / Dienstleistungen  – Mobilfunk / drahtlos',
  66010400: 'Kommunikationsgeräte / Dienstleistungen – Sets',
  66010500: 'Beschilderung / Leitsysteme',
  67000000: 'Bekleidung',
  67010000: 'Bekleidung',
  67010100: 'Bekleidung – Accessoires / Zubehör',
  67010200: 'Ganzkörperbekleidung',
  67010300: 'Beinbekleidung',
  67010800: 'Oberkörperbekleidung',
  67011100: 'Bekleidung – Sets',
  67020000: 'Schlafbekleidung',
  67020100: 'Nachtwäsche',
  67030000: 'Sportbekleidung',
  67030100: 'Sportbekleidung',
  67040000: 'Unterwäsche',
  67040100: 'Unterwäsche / Strumpfwaren',
  67050000: 'Schutzbekleidung',
  67050100: 'Schutzkleidung',
  67060000: 'Badebekleidung',
  67060100: 'Schwimmbekleidung',
  68000000: 'Audio / Video / Foto',
  68010000: 'Audio / Video – Geräte / Zubehör',
  68010100: 'Fernseher',
  68010200: 'Video – Aufnahme / Wiedergabe',
  68010300: 'Audio / Video – Geräte (tragbar)',
  68010400: 'Heim–Audio–Geräte',
  68010700: 'Audio / Video – Zubehör',
  68010800: 'Audio– / Video–Geräte / Zubehör – Sets',
  68010900: 'TV–Empfang / –Installation',
  68020000: 'Fotografie / Optik',
  68020100: 'Fotografie',
  68020200: 'Optik',
  68020300: 'Fotolabor–Geräte / –Zubehör',
  68020400: 'Fotografie / Optik – Sets',
  68030000: 'Kfz–Audio / Kfz–Video / Kfz–Navigation',
  68030100: 'Kfz–Video / –Navigation',
  68030200: 'Kfz–Audio',
  68030300: 'Kfz–Audio / Kfz–Video / Kfz–Navigation – Sets',
  68040000: 'Audio / Video – Medien',
  68040100: 'Bespielte Medien oder Medien mit digitalem Inhalt',
  68040200: 'Beschreibbare Medien',
  68050000: 'Audio / Video / Foto – Sets',
  68050100: 'Audio / Video / Foto – Sets',
  70000000: 'Kunst / Kunsthandwerk / Basteln / Handarbeit',
  70010000: 'Künstler– / Kunsthandwerks– / Bastel– / Handarbeitsbedarf',
  70010100: 'Mal– / Zeichenbedarf',
  70010200: 'Airbrushbedarf',
  70010300: 'Bildhauer– / Töpferbedarf',
  70010400: 'Handarbeitsbedarf / Puppenbedarf',
  70010500: 'Schmuckbedarf',
  70010600: 'Korbflechterei–Bedarf',
  70010700: 'Papier– / Karten–Bastelbedarf',
  70010800: 'Glas– / Emaillier– / Einlegearbeiten–Bastelbedarf',
  70010900: 'Kerzen– / Seifen–Bastelbedarf',
  70011000: 'Brandmalerei– / Gravier–Bedarf',
  70011100: 'Drucker–Bedarf',
  70011200: 'Spinn– / Webbedarf',
  70011300: 'Künstler– / Kunsthandwerks– / Bastel– / Handarbeitsbedarf – Sets',
  71000000: 'Sportartikel',
  71010000: 'Sportartikel',
  71010100: 'Leichtathletik–Artikel',
  71010200: 'Sportbälle / Pucks / Federbälle / Frisbees / Bumerangs',
  71010300: 'Racketsportartikel',
  71010400: 'Schläger / Stöcke',
  71010500: 'Wintersportausrüstung',
  71010600: 'Trekking– / Bergsteigerausrüstung',
  71010700: 'Kampfsportausrüstung',
  71010800: 'Radsportausrüstung',
  71010900: 'Fitnessausrüstung',
  71011000: 'Gymnastikausrüstung',
  71011100: 'Kiting– / Fallschirmspring–Ausrüstung',
  71011200: 'Roller– / Skateboardausrüstung',
  71011300: 'Schwimm– / Surf– / Tauchausrüstung',
  71011400: 'Sporttische',
  71011500: 'Bogensport–Ausrüstung',
  71011600: 'Schießsport–Ausrüstung',
  71011700: 'Jagdsportzubehör',
  71011800: 'Wassersportgeräte (ohne Antrieb) und Ausrüstung',
  71011900: 'Sportartikel – Zubehör',
  71012000: 'Sport–Schutzausrüstung',
  71012100: 'Angel–Ausrüstung',
  71012300: 'Sportartikel – Sets',
  71020000: 'Baby-Trainingsgerät/-Transportmittel',
  71020100: 'Baby-Trainingsgerät/-Transportmittel',
  72000000: 'Haushaltsgeräte',
  72010000: 'Haushaltsgroßgeräte',
  72010100: 'Abfallentsorgung / Abfallverdichtung',
  72010200: 'Kühlgeräte / Gefriergeräte',
  72010300: 'Kochgeräte',
  72010400: 'Warmhaltegeräte',
  72010500: 'Waschmaschinen / Wäschetrockner',
  72010600: 'Geschirr–Reinigungsgeräte',
  72010700: 'Wasserspender – Großgeräte',
  72020000: 'Haushaltskleingeräte',
  72020100: 'Koch– / Wärmekleingeräte',
  72020200: 'Geräte zur Essens– / Getränkezubereitung',
  72020300: 'Wäschepflegegeräte',
  72020400: 'Reinigungsgeräte',
  72020500: 'Wasserspender – Kleingeräte',
  72020600: 'Klimageräte (mobil)',
  72020700: 'Haushaltskleingeräte – sonstige',
  72020800: 'Smarthome- / Heimautomatisierungs-Ausrüstung',
  73000000: 'Küchengeräte und Geschirr',
  73040000: 'Küchengeräte',
  73040100: 'Küche – Aufbewahrung',
  73040200: 'Getränke – Zubereitung / Behälter',
  73040300: 'Küchen–Messgeräte',
  73040400: 'Kochgeschirr / Backformen',
  73040600: 'Essenszubereitung – Geräte / Hilfsmittel',
  73040800: 'Tafel– / Küchengeräte – Sets',
  73040900: 'Essens– / Getränkedekoration',
  73041000: 'Lebensmittelbehälter (einweg)',
  73050000: 'Geschirr',
  73050100: 'Babygeschirr',
  73050200: 'Essgeschirr (mehrweg)',
  73050300: 'Trinkgeschirr (mehrweg)',
  73050500: 'Barzubehör (mehrweg)',
  73050600: 'Serviergeschirr (mehrweg)',
  73050700: 'Tischgeschirr (einweg)',
  73050800: 'Tischgeschirr – Sets',
  73050900: 'Tischgeschirr-Zubehör',
  73051000: 'Besteck (mehrweg)',
  74000000: 'Camping',
  74010000: 'Camping',
  74010100: 'Zelte / Wetterschutz',
  74010200: 'Campingausrüstung – Heizung / Beleuchtung',
  74010300: 'Camping–Möbel',
  74010400: 'Campingausrüstung – Kochen / Essen / Trinken',
  74010500: 'Campingausrüstung – Körperhygiene / Sanitär',
  74010600: 'Camping – Sets',
  75000000: 'Wohn– / Büromöbel / Innendekoration',
  75010000: 'Wohn– / Büromöbel',
  75010100: 'Aufbewahrungs– / Ergänzungsmöbel / Raumteiler',
  75010200: 'Sitzmöbel / Polstermöbel',
  75010300: 'Tische / Schreibtische',
  75010400: 'Betten / Matratzen',
  75010500: 'Wohn– / Büromöbel – Sets',
  75010600: 'Wohn– / Büromöbel – Zubehör',
  75010700: 'Präsentationsständer',
  75020000: 'Heimtextilien',
  75020100: 'Heimtextilien – textile Wohn– / Büroeinrichtung',
  75020200: 'Bettwaren',
  75020300: 'Heimtextilien – Sets',
  75030000: 'Dekorative Wohnaccessoires',
  75030100: 'Dekorationsgegenstände',
  75030200: 'Bilder / Spiegel / Bilderrahmen',
  75030400: 'Uhren',
  75030600: 'Dekorative Wohnaccessoires – Sets',
  75030700: 'Fahnen / Flaggen',
  75030800: 'Dekorative Fahnen / Flaggen – Zubehör',
  75050000: 'Baby-Mobiliar',
  75050100: 'Baby-Hygieneausstattung',
  75050200: 'Haushalts-Babybetten/-Matratzen',
  75050300: 'Haushalts-Babystühle',
  77000000: 'Kraftfahrzeug–Teile / –Zubehör',
  77010000: 'Kfz–Zubehör und Instandhaltung',
  77010200: 'Kfz–Karosseriereparatur',
  77010300: 'Kfz–Transportvorrichtungen',
  77010400: 'Kfz–Pflegemittel',
  77010500: 'Kfz–Reinigungsmittel (chemisch)',
  77010900: 'Kfz–Getriebeöle',
  77011200: 'Kfz–Instandhaltungs– / Reparaturmittel',
  77011300: 'Kfz–Sicherheit',
  77011400: 'Kfz–Innenausstattung – Sitze',
  77011500: 'Kfz–Innenausstattung – Ablagen / Halter',
  77011600: 'Kfz–Innenausstattung – Komfort',
  77011700: 'Kfz–Innenausstattung – Sonnenschutz',
  77011800: 'Kfz–Innenausstattung – Lenkrad',
  77011900: 'Kfz–Innenausstattung – Fußraum / Kofferraum',
  77012000: 'Kfz–Innenausstattung – Armaturenbrett',
  77012100: 'Kfz–Innenausstattung – Dekoration',
  77012200: 'Kfz–Karosseriezubehör – Flankenschutz / Einstiegshilfen',
  77012300: 'Kfz–Karosseriezubehör – Schutzbügel / Stoßstangen / Anbauteile',
  77012400: 'Kfz–Karosseriezubehör – Windabweiser / Sonnenschutz',
  77012500: 'Kfz–Karosseriezubehör – Abdeckungen / Blenden / Halter',
  77012600: 'Kfz–Karosseriestyling / –Tuning',
  77012700: 'Kfz–Reifen / Räder',
  77012800: 'Kfz–Reifen / Räder Zubehör',
  77012900: 'Kfz–Reinigungszubehör / Innenraumdüfte',
  77013100: 'Kfz–Abschleppzubehör / Anhängerkupplungen',
  77013200: 'Kfz–Abschleppzubehör / Anhängerkupplungen – Elektrik',
  77013300: 'Kfz–Anhänger / Anhängerzubehör',
  77013400: 'Kfz–Seilwinden / Seilwindenzubehör',
  77013500: 'Kfz–Diebstahlsicherungen',
  77013600: 'Kfz–Scheibenwischer / Scheibenwischerteile',
  77013700: 'Kfz–Zündkerzen / Glühkerzen / Injektoren',
  77013800: 'Kfz–Filter',
  77013900: 'Kfz–Leuchten / Leuchtmittel',
  77014000: 'Kfz–Beleuchtung / –scheinwerfer',
  77014100: 'Kfz–Dekorbeleuchtung',
  77014300: 'Kfz–Elektrik',
  77014500: 'Kfz–Betriebsflüssigkeits–Handhabung',
  77014700: 'Kfz–Betriebsflüssigkeits–Wechselzubehör',
  77014900: 'Kfz–Scheibenwischflüssigkeit',
  77015000: 'Kfz–Batterien',
  77015100: 'Kfz–Frostschutzmittel',
  77015300: 'Bremsen für Kraftfahrzeuge',
  77030000: 'Kraftwagen und Krafträder',
  77030100: 'PKWs',
  77030200: 'Motorräder/Geländewagen/Nutzfahrzeuge',
  78000000: 'Elektrozubehör / Beleuchtung',
  78020000: 'Elektrische Verbindung / Verteilung',
  78020500: 'Elektrische Verbindung',
  78020600: 'Elektrische Verteilung',
  78021100: 'Batterien / Ladegeräte',
  78030000: 'Elektrische Beleuchtung',
  78030100: 'Elektrische Beleuchtung – Steuerungselemente',
  78030200: 'Elektrische Beleuchtung – Zubehör',
  78030300: 'Elektrische Lampen / Glühbirnen / Beleuchtung',
  78030400: 'Lampen / Leuchten – mobil',
  78030500: 'Elektrische Beleuchtung – sonstige',
  78040000: 'Elektrokabel / –Drähte',
  78040100: 'Kabel / Drähte – Verlegung / Ordnung',
  78040300: 'Elektrokabel',
  78040400: 'Elektrodrähte',
  78050000: 'Elektronik–Bauteile',
  78050100: 'Elektronik–Bauteile',
  78060000: 'Elektrozubehör – allgemein',
  78060100: 'Elektrozubehör – allgemein',
  79000000: 'Sanitär– / Heizungs– / Klimatechnik',
  79010000: 'Sanitär– / Heizungs– / Klimatechnik',
  79010100: 'Sanitärkeramik / Sanitärausstattung',
  79010300: 'Badezimmerausstattung',
  79010400: 'Wasserspeicher / –Aufbereitung',
  79010500: 'Heizungstechnik',
  79010600: 'Klimatisierungsgeräte / Ventilatoren',
  79010700: 'Sanitär– Heizungs– und Klimatechnik – Sets',
  79010800: 'Wasser– / Gasversorgung',
  79010900: 'Abwassersysteme',
  79011000: 'Rückflussverhinderer',
  79011300: 'Sanität/Heizung/Belüftung/Klimatisierung',
  79011400: 'Gesundheit und Wellness',
  80000000: 'Handwerkzeuge / Arbeitsgeräte',
  80010000: 'Handwerkzeuge / Arbeitsgeräte',
  80010100: 'Mess– / Nivellier– / Markierwerkzeuge',
  80010200: 'Trockenbauwerkzeuge',
  80010300: 'Maurer– / Glas– / Fliesenwerkzeuge',
  80010400: 'Trage– / Hebe– / Klettergeräte',
  80010500: 'Demontage / Zerstörung',
  80010600: 'Nagelpistolen / Heftwerkzeuge / Nietwerkzeuge',
  80010700: 'Schraubenzieher',
  80010800: 'Zangen / Scheren / Metallschneidewerkzeuge',
  80010900: 'Spannwerkzeuge',
  80011000: 'Schleifer / Schärfer / Schabmesser',
  80011100: 'Handbohrer',
  80011300: 'Ahlen / Stanzer / Nageltreiber',
  80011400: 'Messer  (nicht elektrisch)',
  80011500: 'Meißel / Beitel /  Hohlmeißel',
  80011600: 'Hämmer / Beile / Ambosse',
  80011700: 'Schraubenschlüssel / Steckschlüssel / Schraubwerkzeuge',
  80011800: 'Handsägen',
  80011900: 'Hobel / Feilen / Raspeln',
  80012000: 'Rohrwerkzeuge',
  80012200: 'Gewindebohrer/–Schneideisen  (nicht elektrisch)',
  80012300: 'Handwerkzeuge / Arbeitsgeräte – Sets',
  80012400: 'Trichter',
  80012600: 'Druckluftwerkzeuge',
  80012700: 'Gasbrenner/Gasfackel',
  80012800: 'Handwerkzeuge / Arbeitsgeräte – sonstige',
  81000000: 'Gartenbedarf',
  81010000: 'Gartenbedarf',
  81010100: 'Pools / Gartenteiche / Wasserspiele & Dekoration',
  81010200: 'Pflanzenschutzmittel',
  81010300: 'Gartenmöbel / –Ausstattung',
  81010400: 'Gartenbewässerung',
  81010500: 'Gartenzäune / Garteneinfriedeungen',
  81010700: 'Gartenabfallsysteme / Komposter',
  81010800: 'Gartengrillgeräte / Außenheizungen',
  81011000: 'Gartenhäuser / Gewächshäuser / Pavillons',
  81011100: 'Garten–Wetterstationen / –messgeräte',
  81011200: 'Gartengroßgeräte und -werkzeuge',
  81011400: 'Gartenanalyse–Produkte',
  81011500: 'Gartenerde / Dünger',
  81011600: 'Gartenbeleuchtung',
  81011700: 'Tierabwehr / –abschreckung',
  81011800: 'Gartenzubehör Blumen- / Pflanzenzubehör',
  81011900: 'Rasen-/Gartenfliesen',
  82000000: 'Werkzeuge / Maschinen (elektrisch)',
  82010000: 'Werkzeuge / Maschinen (elektrisch)',
  82010100: 'Elektrowerkzeuge – Hebe–/Transportgeräte',
  82010200: 'Elektrowerkzeuge – Sets',
  82010300: 'Elektrowerkzeuge – stationär',
  82010400: 'Elektrowerkzeuge – handgeführt / mobil',
  83000000: 'Baustoffe / Bauelemente / Baubedarf',
  83010000: 'Baustoffe / Bauelemente / Baubedarf',
  83010100: 'Wand– / Decken–Verkleidung',
  83010200: 'Bodenbeläge',
  83010300: 'Isolierung / Dämmstoffe',
  83010400: 'Malerbedarf',
  83010500: 'Baustoffe / Bauelemente / Baubedarf – Sets',
  83010600: 'Mineralische Baustoffe / Asphaltbaustoffe',
  83010700: 'Tragende Komponenten / Bauelemente',
  83010800: 'Bauholz / Täfelungen / Gipsbaustoffe',
  83010900: 'Fenster – Teile / Zubehör',
  83011000: 'Dekorative Elemente / Treppenteile',
  83011100: 'Türen',
  83011200: 'Türbeschläge / Zubehör',
  83011300: 'Glas',
  83011400: 'Dachrinnen / Drainagen',
  83011500: 'Geländer / Terrassenbaubedarf',
  83011700: 'Dachbaustoffe',
  83011800: 'Schleifmittel',
  83011900: 'Befestigungsmaterialien',
  83012000: 'Vorhänge – Teile / Zubehör',
  83012100:
    'Dichtungs– / Füll– / Klebemittel / Mittel zur Fehler- / Oberflächenrissprüfung',
  83012200: 'Fenster',
  83012300: 'Fassade / Außenverkleidung',
  83012400: 'Bauprodukte – Sonstige',
  83012500: 'Abdeckungen/Panele',
  83012600: 'Dach-/Schutzbauten für den Außenbereich',
  84000000: 'Werkzeugaufbewahrung / Werkstattausstattung',
  84010000: 'Werkzeugaufbewahrung / Werkstattausstattung',
  84010100: 'Werkzeugaufbewahrung',
  84010200: 'Werkstatteinrichtung',
  85000000: 'Sicherheit / Schutz – Do–it–yourself',
  85010000: 'Sicherheit / Schutz – Do–it–yourself',
  85010100: 'Persönliche Sicherheitsausrüstung – Do–it–yourself',
  85010200: 'Schutzvorrichtungen',
  86000000: 'Spielzeuge / Spiele',
  86010000: 'Spielzeuge / Spiele',
  86010100: 'Brettspiele / Kartenspiele / Geduldspiele / Puzzles',
  86010200: 'Puppen / Marionetten / Action-Figuren / Stofftiere',
  86010300: 'Puppen / Marionetten / Action-Figuren / Stofftiere – Zubehör',
  86010400: 'Lern– / Entwicklungsspielzeuge',
  86010500: 'Kostüme / Kostümzubehör',
  86010600: 'Musikspielzeuge',
  86010700:
    'Spielzeuge / Spielgeräte für Garten, Spielplatz und den Innenbereich',
  86010800: 'Tischspiele',
  86010900: 'Spielzeuge / Spiele – Sets',
  86011000: 'Kinderfahrzeuge',
  86011100: 'Spielzeug–Verkehrsmittel',
  86011200: 'Rollenspiel–Spielzeuge',
  86011300: 'Spielzeuge/Spiele – sonstige',
  86020000: 'Glücksspielprodukte – Dienstleistungen',
  86020100: 'Glücksspielprodukte (EInzelhandel)',
  87000000: 'Brennstoffe / Gase',
  87010000: 'Brennstoffe / Kraftstoffzusätze',
  87010100: 'Kraftstoffe / Zündmittel',
  87010200: 'Kraftstoffzusätze / Additive',
  87010500: 'Brennstoffe / Kraftstoffzusätze – Sets',
  87020000: 'Brennstofflagerung / –Transport',
  87020100: 'Brennstoffpumpen',
  87020200: 'Brennstofflagerung',
  87030000: 'Gase, die nicht als Brennstoffe verwendet werden',
  87030100: 'Technische Gase',
  88000000: 'Schmierstoffe',
  88010000: 'Schmierstoffe / Schutzmittel',
  88010100: 'Schmierstoffprodukte',
  88010200: 'Schutzmittel',
  88010500: 'Schmierstoffe / Schutzmittel – Sets',
  88020000: 'Schmierstoffe / Schutzmittel – Aufbewahrung / Transport',
  88020100: 'Schmieröl– / Flüssigkeitspumpen',
  88020200: 'Schmierstoffe / Schutzmittel – Aufbewahrung',
  88030000: 'Schmierstoffe – Sets',
  88030100: 'Schmierstoffe – Sets',
  89000000: 'Lebende Tiere',
  89020000: 'Lebende Tiere',
  89020100: 'Wirbellose  Tiere',
  89020200: 'Wirbeltiere',
  91000000: 'Sicherheit / Schutz / Überwachung',
  91010000: 'Persönliche Sicherheit',
  91010100: 'Persönliche Schutzvorrichtungen',
  91020000: 'Umweltsicherheit / –Schutzprodukte',
  91020100: 'Brandschutz– / Chemikaliensicherheitsprodukte',
  91020200: 'Wetter– / Naturkatstrophen–Sicherheitsprodukte',
  91030000: 'Sicherheit / Schutz / Überwachung – Gebäude',
  91030100: 'Alarmsysteme',
  91030200: 'Türen– / Fenster– / Grundstücks–Sicherheitsprodukte',
  91030300: 'Brandschutz',
  91030400: 'Gebäude–Überwachungsausrüstung',
  91030500: 'Safes / Panzerschränke',
  91030600: 'Sicherheit / Schutz / Überwachung – Gebäude – Sets',
  91030700: 'Mengenkontrolle / Wegführer für Menschenmassen',
  91030800: 'Absperrungen',
  91040000: 'Sicherheit / Schutz / Überwachung – Sets',
  91040100: 'Sicherheit / Schutz / Überwachung – Sets',
  91050000: 'Baby-Schutz / Sicherheit / Überwachung',
  91050100: 'Baby-Schutz / Sicherheit / Überwachung',
  92000000: 'Lager– / Transportbehälter',
  92010000: 'Flaschen / Zylinder / Fässer / Tonnen (leer)',
  92010100: 'Flaschen / Zylinder (leer)',
  92010300: 'Fässer / Tonnen (leer)',
  92020000: 'Lager– / Transportboxen / –kisten / –trays (leer)',
  92020100: 'Lager– / Transportboxen / –kisten / –trays (leer)',
  92030000: 'Lager– / Transport–Frachtbehälter (leer)',
  92030100: 'Frachtbehälter / –container (leer)',
  92040000: 'Lager– / Transporthilfsmittel',
  92040100: 'Transportplattformen / –wagen',
  93000000: 'Pflanzen (Gartenbau)',
  93010000: 'Schnittblumen',
  93010100: 'Agapanthus – Schnittblumen',
  93010200: 'Frauenmatel – Schnittblumen',
  93010300: 'Inkalilien – Schnittblumen',
  93010400: 'Anemone – Schnittblumen',
  93010500: 'Flamingoblumen – Schnittblumen',
  93010600: 'Löwenmäuler – Schnittblumen',
  93010700: 'Aster – Schnittblume',
  93010800: 'Bouvardie – Schnittblumen',
  93010900: 'Brandschopf – Schnittblumen',
  93011000: 'Chamelaucium – Schnittblumen',
  93011100: 'Chrysamthemen – Schnittblumen',
  93011200: 'Cymbidium – Schnittblumen',
  93011400: 'Dahlien – Schnittblumen',
  93011500: 'Rittersporne – Schnittblumen',
  93011600: 'Nelken – Schnittblumen',
  93011700: 'Mannstreu – Schnittblumen',
  93011800: 'Lisianthus – Schnittblumen',
  93011900: 'Freesien – Schnittblumen',
  93012000: 'Gerbera – Schnittblumen',
  93012100: 'Gladiolen – Schnittblumen',
  93012200: 'Schleierkraut – Schnittblumen',
  93012300: 'Sonnenblumen – Schnittblumen',
  93012400: 'Rittersterne – Schnittblumen',
  93012500: 'Hyazinthen – Schnittblumen',
  93012600: 'Hortensien – Schnittblumen',
  93012700: 'Johanniskräuter – Schnittblumen',
  93012800: 'Ilex – Schnittblumen',
  93012900: 'Schwertlinie – Schnittblumen',
  93013000: 'Lilien – Schnittblumen',
  93013100: 'Strandflieder – Schnittblumen',
  93013200: 'Levkojen – Schnittblumen',
  93013300: 'Narzisse – Schnittblume',
  93013400: 'Milchsterne – Schnittblumen',
  93013500: 'Schnittblumen – sonstige',
  93013600: 'Pfingstrosen – Schnittblumen',
  93013700: 'Phalaenopsis – Schnittblumen',
  93013800: 'Phlox – Schnittblumen',
  93013900: 'Klebsamen – Schnittblumen',
  93014000: 'Hahnenfuß – Schnittblumen',
  93014100: 'Rose – Schnittblume',
  93014200: 'Goldruten – Schnittblumen',
  93014300: 'Strelitzien – Schnittblumen',
  93014400: 'Flieder – Schnittblumen',
  93014500: 'Wucherblumen – Schnittblumen',
  93014600: 'Blaues Halskraut – Schnittblumen',
  93014700: 'Tulpen – Schnittblumen',
  93014800: 'Vanda – Schnittblumen',
  93014900: 'Ehrenpreis – Schnittblumen',
  93015000: 'Schneeball – Schnittblumen',
  93015100: 'Zantedeschien – Schnittblumen',
  93020000: 'Schnittgrün',
  93020100: 'Schmucklilien – Schnittgün',
  93020200: 'Flamingoblumen – Schnittgrün',
  93020300: 'Spargel – Schnittgrün',
  93020400: 'Aspidistra – Schnittgrün',
  93020500: 'Prachtspieren – Schnittgrün',
  93020600: 'Kohl – Schnittgrün',
  93020700: 'Carthamus – Schnittgrün',
  93020800: 'Corylus – Schnittgrün',
  93020900: 'Monbretien – Schnittgrün',
  93021000: 'Gurken – Schnittgrün',
  93021100: 'Kürbisse – Schnittgrün',
  93021200: 'Schnittgrün – Sets',
  93021300: 'Dracanea – Schnittgrün',
  93021400: 'Eukalypten – Schnittgrün',
  93021500: 'Eupatorium – Schnittgrün',
  93021600: 'Fatsia – Schnittblumen',
  93021700: 'Gomphocarpus – Schnittgrün',
  93021800: 'Hortensien – Schnittgrün',
  93021900: 'Ilex – Schnittgrün',
  93022000: 'Silberbäume – Schnittgrün',
  93022100: 'Lilien – Schnittgrün',
  93022200: 'Matthiola – Schnittgrün',
  93022300: 'Fensterblätter – Schnittgrün',
  93022400: 'Schnittgrün – sonstige',
  93022500: 'Panicum – Schnittgrün',
  93022600: 'Physalis – Schnittgrün',
  93022700: 'Klebsamen – Schnittgrün',
  93022800: 'Quercus – Schnittgrün',
  93022900: 'Rosen – Schnittgrün',
  93023000: 'Ruscus – Schnittgrün',
  93023100: 'Weiden – Schnittgrün',
  93023200: 'Setaria – Schnittgrün',
  93023300: 'Strelitzien – Schnittgrün',
  93023400: 'Schneebeeren – Schnittgrün',
  93023500: 'Flieder – Schnittgrün',
  93023600: 'Hellerkräuter – Schnittgrün',
  93023700: 'Schneeball – Schnittgrün',
  93023800: 'Zandtedeschein – Schnittgrün',
  93030000: 'Lebende Pflanzen (Gattung A bis G)',
  93030100: 'Aechmea – lebende Pflanzen',
  93030200: 'Aeonium – lebende Pflanzen',
  93030300: 'Schmucklilien – lebende Pflanzen',
  93030400: 'Alokasie – lebende Pflanzen',
  93030500: 'Aloen – lebende Pflanzen',
  93030600: 'Inkalilien – lebende Pflanzen',
  93030700: 'Anemone – lebende Pflanzen',
  93030800: 'Angelonie – lebende Pflanzen',
  93030900: 'Anisodontea – lebende Pflanzen',
  93031000: 'Flamingoblumen – lebende Pflanzen',
  93031100: 'Löwenmäuler – lebende Pflanzen',
  93031200: 'Argyranthemum – lebende Pflanzen',
  93031300: 'Grasnelken – lebende Pflanzen',
  93031400: 'Aster – lebende Pflanzen',
  93031500: 'Prachtspieren – lebende Pflanzen',
  93031600: 'Blaukissen – lebende Pflanzen',
  93031700: 'Begonien – lebende Pflanzen',
  93031800: 'Bellis – lebende Pflanzen',
  93031900: 'Zweizähne – lebende Pflanzen',
  93032000: 'Bougainvillea – lebende Pflanzen',
  93032100: 'Brachyscome – lebende Pflanzen',
  93032200: 'Kohl – lebende Pflanzen',
  93032300: 'Bromelia – lebende Pflanzen',
  93032400: 'Engelstrompeten – lebende Pflanzen',
  93032500: 'Calathea – lebende Pflanzen',
  93032600: 'Calibrachoa – lebende Pflanzen',
  93032700: 'Calocephalus – lebende Pflanzen',
  93032800: 'Campanula – lebende Pflanzen',
  93032900: 'Canna – lebende Pflanzen',
  93033000: 'Celosia – lebende Pflanzen',
  93033100: 'Chamaedorea – lebende Pflanzen',
  93033200: 'Chlorophytum – lebende Pflanzen',
  93033300: 'Chrysanthemen – lebende Pflanzen',
  93033400: 'Clivia – lebende Pflanzen',
  93033500: 'Cocos – lebende Pflanzen',
  93033600: 'Codiaeum – lebende Pflanzen',
  93033700: 'Cordyline – lebende Pflanzen',
  93033800: 'Coreopsis – lebende Pflanzen',
  93033900: 'Cortaderia – lebende Pflanzen',
  93034000: 'Cosmos – lebende Pflanzen',
  93034100: 'Cuphea – lebende Pflanzen',
  93034200: 'Zypressen – lebende Pflanzen',
  93034300: 'Curcuma – lebende Pflanzen',
  93034400: 'Cycas – lebende Pflanzen',
  93034500: 'Alpenveilchen – lebende Pflanzen',
  93034600: 'Cymbidien – lebende Pflanzen',
  93034700: 'Zypergräser – lebende Pflanzen',
  93034800: 'Dahlien – lebende Pflanzen',
  93034900: 'Rittersporne – lebende Pflanzen',
  93035000: 'Dendrobium – lebende Pflanzen',
  93035100: 'Nelken – lebende Pflanzen',
  93035200: 'Herzblumen – lebende Pflanzen',
  93035300: 'Dieffenbachien – lebende Pflanzen',
  93035400: 'Dorotheanths – lebende Pflanzen',
  93035500: 'Drachenbaum – lebende Pflanzen',
  93035600: 'Dypsis – lebende Pflanzen',
  93035700: 'Echeverien – lebende Pflanzen',
  93035800: 'Echinacea / Sonnenhüte – lebende Pflanzen',
  93035900: 'Efeututen – lebende Pflanzen',
  93036000: 'Wolfsmilch – lebende Pflanzen',
  93036100: 'Gelbe Strauchmargerite – lebende Pflanzen',
  93036200: 'Fargesia – lebende Pflanzen',
  93036300: 'Kapastern – lebende Pflanzen',
  93036400: 'Schwingel – lebende Pflanzen',
  93036500: 'Fittonie – lebende Pflanzen',
  93036600: 'Fuchsien – lebende Pflanzen',
  93036700: 'Gardenien – lebende Pflanzen',
  93036800: 'Gaura – lebende Pflanzen',
  93036900: 'Gazanien – lebene Pflanzen',
  93037000: 'Enziane – lebende Pflanzen',
  93037100: 'Gerbera – lebende Pflanzen',
  93037200: 'Guzmania – lebende Pflanzen',
  93037300: 'Gipskräuter – lebende Pflanzen',
  93037400: 'Feigen / Ficus – lebende Pflanzen',
  93037600: 'Castonospermum - lebende Pflanzen',
  93037700: 'Kaffee - lebende Pflanzen',
  93037800: 'Dionaea - lebende Pflanzen',
  93040000: 'Lebende Pflanzen (Gattung H bis Z)',
  93040100: 'Efeu – lebende Pflanzen',
  93040200: 'Sonnenblumen – lebende Pflanzen',
  93040300: 'Strohblumen – lebende Pflanzen',
  93040400: 'Sonnenwenden – lebende Pflanzen',
  93040500: 'Nieswurz – lebende Pflanzen',
  93040600: 'Heuchera – lebende Pflanzen',
  93040700: 'Hibiskus – lebende Pflanzen',
  93040800: 'Rittersterne – lebende Pflanzen',
  93040900: 'Gerste – lebende Pflanzen',
  93041000: 'Hosta – lebende Pflanzen',
  93041100: 'Kentia-Palmen – lebende Pflanzen',
  93041200: 'Hyazinthen – lebende Pflanzen',
  93041300: 'Hortensien – lebende Pflanzen',
  93041400: 'Springkräuter – lebende Pflanzen',
  93041500: 'Jasminum – lebende Pflanzen',
  93041600: 'Kalanchoe – lebende Pflanzen',
  93041700: 'Wandelröschen – lebende Pflanzen',
  93041800: 'Margerite – lebende Pflanzen',
  93041900: 'Bitterwurz – lebende Pflanzen',
  93042000: 'Lilien – lebende Pflanzen',
  93042100: 'Lithodora – lebende Pflanzen',
  93042200: 'Lebende Pflanzen – Sets',
  93042300: 'Livistona – lebende Pflanzen',
  93042400: 'Lobelien – lebende Pflanzen',
  93042500: 'Hornklee – lebende Pflanzen',
  93042600: 'Lupinien – lebende Pflanzen',
  93042700: 'Mandevilla – lebende Pflanzen',
  93042800: 'Medinillen – lebende Pflanzen',
  93042900: 'Miltonia – lebende Pflanzen',
  93043000: 'Traubenhyazinthen – lebende Pflanzen',
  93043100: 'Vergissmeinnicht – lebende Pflanzen',
  93043200: 'Narzisse – lebende Pflanzen',
  93043300: 'Nephrolepis – lebende Pflanzen',
  93043400: 'Nolina – lebende Pflanzen',
  93043500: 'Seerosen – lebende Pflanzen',
  93043600: 'Oncidium – lebende Pflanzen',
  93043700: 'Orchis – lebende Pflanzen',
  93043800: 'Milchsterne – lebende Pflanzen',
  93043900: 'Kapkörbchen – lebende Pflanzen',
  93044000: 'Lebende Pflanzen – sonstige',
  93044100: 'Pachira – lebende Pflanzen',
  93044200: 'Pfingstrosen – lebende Pflanzen',
  93044300: 'Mohn – lebende Pflanzen',
  93044400: 'Paphiopedilum – lebende Pflanzen',
  93044500: 'Pelargonien – lebende Pflanzen',
  93044600: 'Lampenputzgräser – lebende Pflanzen',
  93044700: 'Petunien – lebende Pflanzen',
  93044800: 'Phalaenopsis – lebende Pflanzen',
  93044900: 'Phlox – lebende Pflanzen',
  93045000: 'Dattelpalme – lebende Pflanzen',
  93045100: 'Platycodon – lebende Pflanzen',
  93045200: 'Harfensträucher – lebende Pflanzen',
  93045300: 'Portulak – lebende Pflanzen',
  93045400: 'Primeln – lebende Pflanzen',
  93045500: 'Hahnenfuß – lebende Pflanzen',
  93045600: 'Rhipsalidopsis – lebende Pflanzen',
  93045700: 'Rhododendron – lebende Pflanzen',
  93045800: 'Rose – lebende Pflanzen',
  93045900: 'Saintpaulia – lebenden Pflanzen',
  93046000: 'Salbei – lebende Pflanzen',
  93046100: 'Sansevieria – lebende Pflanzen',
  93046200: 'Sanvitalia – lebende Pflanzen',
  93046400: 'Steinbrech – lebende Pflanzen',
  93046500: 'Schefflera – lebende Pflanzen',
  93046600: 'Schlumbergera – lebende Pflanzen',
  93046700: 'Fetthennen – lebende Pflanzen',
  93046800: 'Hauswurzen – lebende Pflanzen',
  93046900: 'Senecio – lebende Pflanzen',
  93047000: 'Sinningia – lebende Pflanzen',
  93047100: 'Nachtschatten – lebende Pflanzen',
  93047200: 'Spathiphyllum – lebende Pflanzen',
  93047300: 'Stephanotis – lebende Pflanzen',
  93047400: 'Sutera – lebende Pflanzen',
  93047500: 'Tagetes – lebende Pflanzen',
  93047600: 'Tillandsia – lebende Pflanzen',
  93047700: 'Tulpen – lebende Pflanzen',
  93047800: 'Vanda – lebende Pflanzen',
  93047900: 'Verbenen – lebende Pflanzen',
  93048000: 'Veilchen – lebende Pflanzen',
  93048100: 'Vriesea – lebende Pflanzen',
  93048200: 'xBurrageara – lebende Pflanzen',
  93048300: 'XCitrofortunella – lebende Pflanzen',
  93048400: 'Yucca – lebende Pflanzen',
  93048500: 'Zamioculas – lebende Pflanzen',
  93048600: 'Zantedeschien – lebende Pflanzen',
  93048700: 'Ludwigien - lebende Pflanzen',
  93048800: 'Bananen - Lebende Pflanzen',
  93048900: 'Peperomien - lebende Pflanzen',
  93049000: 'Chinesischer Geldbaum - Lebende Pflanzen',
  93049100: 'Philodendren - lebende Pflanzen',
  93049200: 'Fiederaralien - lebende Pflanzen',
  93049300: 'Steckenpalme - lebende Pflanzen',
  93050000: 'Blumenzwiebeln / Knollen / Wurzelstöcke / Sprossknollen',
  93050100: 'Blumenzwiebeln / Knollen / Wurzelstöcke / Sprossknollen',
  93060000: 'Pflanzen – Sets',
  93060100: 'Pflanzen – Sets',
  93070000: 'Samen / Sporen',
  93070100: 'Samen / Sporen',
  93080000: 'Sträucher / Bäume',
  93080100: 'Sträucher / Bäume',
  93090000: 'Gemüsepflanzen / Speisepilze',
  93090100: 'Gemüsepflanzen / Speisepilze',
  93100000: 'Blumenstrauß',
  93100100: 'Blumensträuße',
  93110000: 'Setzlinge – bereit zum einpflanzen',
  93110100: 'Setzlinge – Bereit zum Einpflanzen',
  94000000: 'Kulturpflanzen',
  94010000:
    'Kulturpflanzen nicht als Lebensmittel oder zu Futterzwecken (Tiere und Fische)',
  94010100: 'Kulturpflanzen zur Produktion von Naturfasern und Harz',
  94010200: 'Kulturpflanzen zur Herstellung von Latex (Latex-Kulturpflanzen)',
  94010300:
    'Kulturpflanzen für die Produktion von natürlichen Pigmenten, Harzen und Wachsen',
  94010700: 'Ungiftige Pflanzen für Arzneimittel und ätherische Öle',
  94010800: 'Giftige Pflanzen für Arzneimittel',
  94020000: 'Kulturpflanzen zur Lebensmittelproduktion',
  94020100: 'Kulturpflanzen für die Produktion von Annonafrüchten',
  94020200: 'Kulturflanzen für die Produktion von Bananen',
  94020300: 'Essbare Kernobstpflanzen',
  94020400: 'Essbare Lauchgewächse',
  94020500: 'Kulturpflanzen für die Produktion von Beeren und kleinen Früchten',
  94020600:
    'Kulturpflanzen für die Produktion von Zitrusgewächsen und anderen Rautengewächsen',
  94020700: 'Kulturpflanzen für die Produktion von Kernobst',
  94020800: 'Kulturpflanzen für de Produktion von essbaren Kaktusfrüchten',
  94020900:
    'Kulturpflanzen für die Produktion von essbaren Früchten von Palmen',
  94021000:
    'Kulturpflanzen für die Produktion von essbaren Früchten vom Myrtenbaum',
  94021100: 'Kulturpflanzen für die Produktion von essbaren Sumachfrüchten',
  94021200:
    'Kulturpflanzen für die Produktion von essbaren Früchten von Seifenbäumen',
  94021300:
    'Kulturpflanzen für die Produktion von essbaren Früchten von Sapote-Bäumen',
  94021400:
    'Kulturpflanzen für die Produktion von essbaren Früchten vom Phyllantaceae-Bäumen',
  94021500: 'Kulturpflanzen für die Produktion von anderen Bäumen und Pflanzen',
  94021600: 'Kulturpflanzen für die Produktion von essbaren Nüssen',
  94021700: 'Kulturpflanzen für die Produktion von essbaren Erdnüssen',
  94021800: 'Kulturpflanzen für Getränke',
  94021900: 'Kulturpflanzen für die Produktion von Körnern und Getreide',
  94022000: 'Zuckerkulturen',
  94022100: 'Kulturpflanzen für die Produktion von essbaren Ölen',
  94022200: 'Kohlgemüse (Kohlarten)',
  94022300: 'Kulturpflanze für Essbares Gemüse',
  94022400: 'Gemüsekulturen - essbare Stängel',
  94022500: 'Gemüsekulturen - essbare Wurzeln, Knollen und Rhizome',
  94022600: 'Essbare Pilze',
  94022700: 'Fruchtgemüse - Nachtschattengewächse',
  94022800:
    'Kulturpflanzen für die Produktion von Fruchtgemüse - Kürbisse und Flaschenkürbisse',
  94022900: 'Fruchtgemüse - sonstige',
  94023000: 'Blattgemüsekulturen - Wegwarten',
  94023100: 'Blattgemüsekulturen - Salatpflanzen',
  94023200: 'Blattgemüsekulturen - Brassicaceae',
  94023300: 'Blattgemüseulturen - Spinattyp',
  94023400: 'Kulturpflanzen für die Produktion von Blattgemüse - sonstige',
  94023500: 'Essbare Kräuter',
  94023600: 'Essbare Gewürze',
  94030000:
    'Gräser und andere Kulturpflanzen als Tierfutter oder zur Bodenverbesserung',
  94030100: 'Grasartige (Gräser)',
  94030200: 'Kreuzblütler-Futterpflanzen',
  94030300: 'Hülsenfrüchte-Futterpflanzen',
  94030400: 'Sonstige Futterpflanzen',
  95000000: 'Dienstleistungen',
  95010000: 'Unternehmensdienstleistungen und kommerzielle Dienste',
  95010100: 'Buchhaltungsdienst',
  95010200: 'Werbedienstleistungen',
  95010300: 'Architektur- und Ingenieur-Dienstleistungen',
  95010400: 'Geschäftsführung- und Consulting-Dienstleistungen',
  95010500: 'Computer- und Technologie-Dienstleistungen',
  95010600: 'Juristische Dienstleistungen',
  95020000: 'Bauausführung und ähnliche Dienstleistungen',
  95020100: 'Bauausführung und ähnliche Dienstleistungen',
  95030000: 'Reinigungsdienstleistungen',
  95030100: 'Reinigungsdienstleistungen',
  95040000: 'Kommunikationsdienstleistungen',
  95040100: 'Audiovisuelle Dienste',
  95040200: 'Telekommunikationsdienstleistungen',
  95050000: 'Bildungsdienstleistungen und Unterhaltungsdienste',
  95050100: 'Bildungsdienstleistungen',
  95050200: 'Unterhaltungsdienste',
  95060000: 'Energiedienstleistungen und Kreislaufwirtschaft',
  95060100: 'Energiedienstleistungen',
  95060200: 'Kreislaufwirtschaft',
  95070000: 'Finanzdienstleistungen',
  95070100: 'Finanzdienstleistung',
  95080000: 'Verpackungs- / Lagerungsdienstleistungen',
  95080100: 'Verpackungs-/Lagerdienstleistungen',
  95090000: 'Postdienst',
  95090100: 'Postdienst',
  95100000: 'Wissenschaftliche und technologische Dienstleistungen',
  95100100: 'Wissenschaftliche und technologische Dienstleistungen',
  95110000:
    'Dienstleistungen für Wohnen auf Zeit / Essens- und Getränke-Service',
  95110300: 'Speisen- und Getränke-Service',
  95110400: 'Dienstleistung für Wohnen auf Zeit',
  95120000: 'Montagedienstleistungen / Wartungs- und Reparaturdienstleistungen',
  95120100: 'Wartungs- / Reparaturdienstleistungen',
  95120200: 'Montagedienstleistungen',
  95130000: 'Gesundheits- und Körperpflege / Medizinische Dienstleistungen',
  95130100: 'Gesundheit- und Körperpflege - Dienstleistungen',
  95130200: 'Medizinische Dienstleistungen',
  95130300: 'Veterinärdienst',
  95140000: 'Transportdiestleistungen',
  95140100: 'Transportdienstleistungen',
  95150000: 'Reisedienstleistungen',
  95150100: 'Reisedienstleistungen',
  99999999: 'Temporäre Klassifikation'
}



// WEBPACK FOOTER //
// ./src/i18n/de/gpc.js